export default {
    "da": {
        "activities": {
            "page_header": "Aktiviteter",
            "handled_cpr": "Håndterede Cpr-nummer",
            "count": "Antal",
            "expand": "Udvid alle",
            "collapse": "Skjul alle",
            "logged_out": "Logged ud",
            "table": {
                "id": "Id",
                "by": "Udført af bruger",
                "description": "Beskrivelse",
                "action": "Handling",
                "for": "Udført på",
                "content": "Indhold",
                "created_column": "Dato"
            },
            "filterTable": {
                "by": "Udført af bruger",
                "description": "Beskrivelse",
                "action": "Handling",
                "for": "Udført på"
            },
            "action": {
                "downloaded": "Download af Danløn fil",
                "displayed": "Visning af medarbejder",
                "updated": "Opdatering af medarbejder",
                "created": "Oprettelse af medarbejder",
                "display_changes": "Visning af ændringer på medarbejder",
                "displayed_cpr_number": "Visning af cpr nummer",
                "upload-final": "Upload af løn",
                "uploaded_voucher_statement": "Kontoudtog uploadet",
                "updated_voucher": "Bilag opdateret",
                "approved_voucher": "Bilag godkendt",
                "deleted_voucher_attachment": "Bilagsfil slettet",
                "v2": {
                    "index": "Vis dashboard",
                    "search": "Globalsøgning",
                    "powerbi": {
                        "index": "Vis powerbi",
                        "get": "Hent powerbi data",
                        "dashboard": {
                            "index": "Vis powerbi"
                        },
                        "setup": {
                            "index": "Vis BI Mapping",
                            "table": "Hent BI Mapping tabel data",
                            "get": "Hent BI Mapping data",
                            "store": "BI rapport konto oprettet",
                            "update": "BI rapport konto opdateret",
                            "destroy": "BI rapport konto slettet",
                            "upload": "BI rapport konto csv uploadet"
                        }
                    },
                    "kube": {
                        "index": "Vis kube tabel",
                        "table": "Hent kube tabel data",
                        "options": "Hent kube data",
                        "store": "Kube datafelt oprettet",
                        "update": "Kube datafelt opdateret",
                        "destroy": "Kube datafelt slettet"
                    },
                    "dashboard": {
                        "table": "Hent dashboard data",
                        "index": "Vis dashboard",
                        "selected": {
                            "set": "Sæt valgt dashboard"
                        },
                        "status": {
                            "update": "Dashboard status opdateret",
                            "bulk-update": "Dashboard status masseopdateret"
                        },
                        "reload-on-demand": {
                            "update": "Dashboard genindlæs ved behov ændret"
                        },
                        "comments": "Vis kommentarer for virksomhed",
                        "comments.store": "Virksomhedskommentar oprettet",
                        "vat": {
                            "update": "Moms opdateret på dashboard",
                            "bulk-update": "Moms masseopdateret på dashboard"
                        },
                        "customer": {
                            "index": "Vis kunde dashboard"
                        },
                        "tasks": {
                            "get": "Hent opgaver for virksomhed",
                            "store": "Opgave oprettet",
                            "update": "Opgave opdateret",
                            "destroy": "Opgave slettet",
                            "delete": "Opgave slettet",
                            "employees": "Hent medarbejdere for opgave",
                            "vouchers": {
                                "get": "Hent bilag for opgave",
                                "create": "Bilag for opgave oprettet",
                                "update": "Bilag for opgave opdateret",
                                "destroy": "Bilag for opgave slettet",
                                "delete": "Bilag for opgave slettet"
                            }
                        },
                        "templates": {
                            "get": "Hent opgaver fra opgaveskabeloner"
                        },
                        "procedures": {
                            "get": "Hent procedurer for virksomhed",
                            "create": "Procedure oprettet",
                            "update": "Procedure opdateret",
                            "destroy": "Procedure slettet",
                            "delete": "Procedure slettet",
                            "employees": {
                                "get": "Hent medarbejdere for procedure"
                            }
                        },
                        "procedure": {
                            "employees": {
                                "get": "Hent medarbejdere for procedure"
                            }
                        },
                        "view-options": {
                            "toggle-active": "Skift aktive dashboard visning",
                            "store": "Dashboard visning oprettet",
                            "update": "Dashboard visning opdateret",
                            "destroy": "Dashboard visning slettet"
                        }
                    },
                    "users": {
                        "table": "Hent bruger tabel data",
                        "index": "Vis bruger tabel",
                        "store": "Bruger oprettet",
                        "update": "Bruger opdateret",
                        "destroy": "Bruger slettet",
                        "deactivate": "Bruger deaktiveret",
                        "activate": "Bruger aktiveret",
                        "reset-password": "Bruger adgangskode nulstillet",
                        "roles": {
                            "options": "Hent roller til vælgermenu"
                        }
                    },
                    "user": {
                        "profile-picture": {
                            "uploaded": "Upload profilbillede",
                            "upload": "Upload profilbillede",
                            "delete": "Slet profilbillede"
                        },
                        "select-month": "Skiftede viste måned",
                        "get": "Hent bruger"
                    },
                    "roles": {
                        "table": "Hent roller tabel data",
                        "index": "Vis roller",
                        "store": "Rolle oprettet",
                        "update": "Rolle opdateret",
                        "destroy": "Rolle slettet",
                        "permissions": {
                            "options": "Hent tilladelser til vælgermenu"
                        }
                    },
                    "user-companies": {
                        "table": "Hent ansatte & virksomheder tabel data",
                        "index": "Vis ansatte & virksomheder",
                        "update": "Keepers medarbejdere for virksomhed opdateret"
                    },
                    "user-groups": {
                        "store": "Keepers medarbejder gruppe oprettet",
                        "table": "Hent ansatte & grupper tabel data",
                        "index": "Vis ansatte & grupper tabel",
                        "update": "Keepers medarbejder gruppe opdateret",
                        "destroy": "Keepers medarbejder gruppe slettet"
                    },
                    "voucher": {
                        "store": "Bilag behandlet",
                        "upload": {
                            "specific": "Enkelt bilag uploadet",
                            "all": "Alle bilag uploadet",
                            "selection": "Valgte bilag uploadet"
                        },
                        "admin": {
                            "contra-accounts": {
                                "get": "Hent modkonti"
                            },
                            "statement": {
                                "register": "Kontoudtog registreret",
                                "upload": "Kontoudtog uploadet",
                                "delete": "Kontoudtog slettet"
                            },
                            "close-period": "Luk periode",
                            "release": {
                                "all": "Frigiv bilag"
                            },
                            "ignore": {
                                "selection": "Ignorer valgte bilag"
                            },
                            "remove": {
                                "selection": "Fjern valgte bilag"
                            },
                            "close": {
                                "selection": "Afslut valgte bilag"
                            },
                            "mark-as-missing": {
                                "selection": "Markér valgte bilag som bortkommet"
                            },
                            "attachment": {
                                "delete": "Bilagsfil slettet"
                            },
                            "assign": {
                                "selection": "Tildel valgte bilag"
                            }
                        },
                        "files": {
                            "info": "Hent bilags filer info"
                        },
                        "file": {
                            "download": "Download bilagsfil"
                        },
                        "statement": {
                            "file": {
                                "download": "Download kontoudtogsfil"
                            }
                        },
                        "approved-accounts": {
                            "get": "Hent godkendte E-conomic konti"
                        },
                        "departments": {
                            "get": "Hent afdelinger"
                        },
                        "accounts": {
                            "all": "Hent alle virksomheds konti"
                        }
                    },
                    "vouchers": {
                        "table": "Hent bilag tabel data",
                        "index": "Vis bilags tabel",
                        "approved-accounts": {
                            "get": "Hent godkendte E-conomic konti"
                        },
                        "files": {
                            "info": "Hent bilags filer info"
                        },
                        "departments": {
                            "get": "Hent afdelinger"
                        },
                        "departments-data": "Hent afdelinger data",
                        "earlier-releases": {
                            "index": "Vis tidligere frigivne bilag",
                            "table": "Hent tidligere frigivne bilag tabel data",
                            "get": "Hent tidligere frigivne bilag data",
                            "load-table": "Hent tidligere frigivne bilag"
                        }
                    },
                    "companies": {
                        "table": "Hent virksomheder tabel data",
                        "index": "Vis virksomheder",
                        "get": "Hent virksomheder",
                        "update": "Virksomhed opdateret",
                        "store": "Virksomhed oprettet",
                        "destroy": "Virksomhed slettet",
                        "options": {
                            "get": "Hent virksomheder til vælgermenu"
                        },
                        "keepers-employees": {
                            "get": "Hent keepers medarbejder data"
                        },
                        "all-keepers-employees": {
                            "index": "Vis keepers medarbejdere",
                            "get": "Hent keepers medarbejdere data"
                        },
                        "voucher-assignment": {
                            "edit": "Vis bilags administration",
                            "update": "Bilag medarbejdere opdateret"
                        },
                        "all-company-clients": {
                            "get": "Hent virksomheds ansatte"
                        },
                        "with-group": {
                            "get": "Hent virksomheder med koncern"
                        }
                    },
                    "company": {
                        "table": "Hent virksomhed data",
                        "index": "Vis virksomhed",
                        "keepers-employees": {
                            "get": "Hent keepers medarbejder data for virksomhed"
                        }
                    },
                    "company-groups": {
                        "index": "Vis virksomheder & koncern",
                        "table": "Hent virksomheder & koncern tabel data",
                        "get": "Hent virksomheds grupper data",
                        "store": "Koncern oprettet",
                        "update": "Koncern opdateret",
                        "destroy": "Koncern slettet"
                    },
                    "credit-cards": {
                        "index": "Vis kreditkort",
                        "table": "Hent kreditkort tabel data",
                        "get": "Hent kreditkort data",
                        "update": "Kreditkort opdateret",
                        "store": "Kreditkort oprettet",
                        "destroy": "Kreditkort slettet"
                    },
                    "bank": {
                        "table": "Hent bank tabel data",
                        "index": "Vis bank tabel",
                        "company-accounts": "Hent virksomheds konti",
                        "transactions": {
                            "all": "Hent bank transaktioner",
                            "transfer-economics": "Overfør transaktioner til E-conomic",
                            "journals": "Hent kassekladder",
                            "cash-book-types": "Hent kassekladde typer"
                        }
                    },
                    "salary": {
                        "index": "Vis løn",
                        "employees": {
                            "index": "Vis medarbejdere",
                            "table": "Hent medarbejder tabel data",
                            "get": "Hent medarbejder data",
                            "store": "Medarbejder oprettet",
                            "edit": "Vis ret medarbejder",
                            "update": "Medarbejder opdateret",
                            "destroy": "Medarbejder slettet",
                            "companies-for-select-data": "Hent virksomheder til vælgermenu",
                            "for-current-company": "Hent medarbejdere for virksomhed",
                            "departments-data": "Hent afdelinger for medarbejdere",
                            "unmasked-social-security-number": "Visning af cpr-nummer",
                            "import-template": "Hent medarbejder import skabelon",
                            "import": "Medarbejder import fra fil",
                            "danmarks-statistik-data": "Hent Danmarks statistik data"
                        },
                        "employee": {
                            "changes": {
                                "show": "Vis medarbejder ændringer",
                                "noted": "Medarbejder ændringer noteret",
                                "export": "Eksportér medarbejder ændringer"
                            },
                            "terminate": {
                                "create": "Medarbejder fratrådt"
                            }
                        },
                        "employees-optionals": {
                            "index": "Vis tilvalgsfelter",
                            "table": "Hent tilvalgsfelter tabel data",
                            "get": "Hent tilvalgsfelter data",
                            "store": "Tilvalgsfelt oprettet",
                            "update": "Tilvalgsfelt opdateret",
                            "destroy": "Tilvalgsfelt slettet"
                        },
                        "payrolls": {
                            "index": "Vis lønkørseler",
                            "table": "Hent lønkørseler tabel data",
                            "get": "Hent lønkørseler data",
                            "show": "Vis lønkørsel",
                            "approve": "Lønkørsel godkendt",
                            "store": "Lønkørsel oprettet",
                            "update": "Lønkørsel opdateret",
                            "destroy": "Lønkørsel slettet"
                        },
                        "payroll": {
                            "index": "Vis lønkørsel",
                            "table": "Hent lønkørsel data",
                            "get": "Hent lønkørsel data"
                        },
                        "payslip": {
                            "upload": "Lønseddel uploadet",
                            "delete": "Lønseddel slettet"
                        },
                        "status": {
                            "index": "Vis løn status",
                            "table": "Hent løn status tabel data",
                            "get": "Hent løn status data"
                        },
                        "holiday-pay-obligations": {
                            "index": "Vis feriepengeforpligtigelser",
                            "table": "Hent feriepengeforpligtigelser tabel data",
                            "get": "Hent feriepengeforpligtigelser data",
                            "upload": "Feriepengeforpligtigelser fil uploadet",
                            "edit": "Vis enkelt feriepengeforpligtigelse",
                            "export": "Eksportér feriepengeforpligtigelser til E-conomic",
                            "entries": {
                                "get": "Hent feriepengeforpligtigelser per medarbejder"
                            }
                        },
                        "data-fields": {
                            "index": "Vis datafelter",
                            "table": "Hent datafelter tabel data",
                            "get": "Hent datafelter data"
                        },
                        "holidays": {
                            "index": "Vis helligdage",
                            "table": "Hent helligdage tabel data",
                            "get": "Hent helligdage data",
                            "update": "Helligdag opdateret"
                        },
                        "work-calendars": {
                            "index": "Vis arbejdskalendere",
                            "table": "Hent arbejdskalendere tabel data",
                            "store": "Arbejdskalender oprettet",
                            "update": "Arbejdskalender opdateret",
                            "destroy": "Arbejdskalender slettet"
                        },
                        "log": {
                            "table": "Hent payroll tabel data",
                            "index": "Vis payroll log",
                            "activities": "Hent log data"
                        }
                    },
                    "log": {
                        "table": "Hent log tabel data",
                        "index": "Vis log",
                        "activities": "Hent log data"
                    },
                    "onboarding": {
                        "index": "Vis onboarding flow",
                        "table": "Hent onboarding flow tabel data",
                        "get": "Hent onboarding flow data",
                        "store": "Onboarding punkt oprettet",
                        "services": {
                            "get": "Hent onboarding flow services"
                        },
                        "customer": {
                            "index": "Vis kunde onboarding flow",
                            "table": "Hent kunde onboarding flow tabel data",
                            "get": "Hent kunde onboarding flow data",
                            "store": "Kunde onboarding flow oprettet",
                            "update": "Kunde onboarding flow opdateret",
                            "destroy": "Kunde onboarding flow slettet",
                            "complete": "Kunde onboarding flow gennemført"
                        }
                    },
                    "profile": {
                        "index": "Vis profil",
                        "update": "Opdater profil",
                        "password.update": "Opdater adgangskode"
                    },
                    "vat-deadlines": {
                        "index": "Vis moms deadlines",
                        "table": "Hent moms deadlines tabel data",
                        "update": "Opdater moms deadline",
                        "delete": "Slet moms deadline",
                        "destroy": "Moms deadline slettet",
                        "store": "Moms deadline oprettet"
                    },
                    "data-fields": {
                        "index": "Vis datafelter",
                        "table": "Hent datafelter tabel data",
                        "get": "Hent datafelter data",
                        "store": "Datafelt oprettet",
                        "update": "Datafelt opdateret",
                        "destroy": "Datafelt slettet"
                    },
                    "transactions": {
                        "index": "Vis transaktioner",
                        "table": "Hent transaktioner tabel data",
                        "get": "Hent transaktioner data",
                        "all": "Hent transaktioner",
                        "transfer-economics": "Overfør transaktioner til E-conomic",
                        "journals": "Hent kassekladder",
                        "cash-book-types": "Hent kassekladde typer"
                    },
                    "task-templates": {
                        "index": "Vis opgave templates",
                        "table": "Hent opgave templates tabel data",
                        "get": "Hent opgave templates data",
                        "store": "Opgave template oprettet",
                        "update": "Opgave template opdateret",
                        "destroy": "Opgave template slettet"
                    },
                    "vat": {
                        "index": "Vis moms",
                        "table": "Hent moms tabel data",
                        "get": "Hent moms data",
                        "submit": "Momsangivelse indberettet",
                        "submission": {
                            "update-field": "Opdater momsangivelse felt"
                        }
                    },
                    "outlay": {
                        "index": "Vis Outlay",
                        "login": "Login Outlay",
                        "login-with-user-id": "Login Outlay med bruger ID"
                    },
                    "actuate": {
                        "index": "Vis Actuate",
                        "redirect": "Sendt til Actuate"
                    },
                    "document-ai": {
                        "index": "Vis Actuate",
                        "redirect": "Sendt til Actuate"
                    },
                    "corpay-one": {
                        "index": "Vis Corpay",
                        "redirect": "Sendt til Corpay"
                    },
                    "support": {
                        "index": "Vis support",
                        "redirect": "Sendt til Support"
                    },
                    "administration": {
                        "index": "Vis administration",
                        "table": "Hent administration tabel data",
                        "get": "Hent administration data",
                        "store": "Administration oprettet",
                        "update": "Administration opdateret",
                        "destroy": "Administration slettet"
                    }
                }
            },
            "description": {
                "logged_out": "Logget ud",
                "logged_in": "Logget ind",
                "show_payslip": "Vis lønseddel",
                "handled_cpr": "Håndterede CPR-nummer",
                "show_payroll": "Vis lønkørsel",
                "changed_customer_salaried_employee": "Ændret fastansat medarbejder",
                "changed_customer_employees_bank_details": "Ændret medarbejders bankoplysninger",
                "changed_customer_employees_optional": "Ændret valgfrie medarbejderoplysninger",
                "payroll_field_changed": "Lønkørsel felt ændret",
                "changed_customer_employee": "Ændret medarbejder",
                "changed_customer_employees_pension_details": "Ændret medarbejderpensionsoplysninger",
                "changed_customer_employees_pension_company": "Ændret medarbejderpensionsfirma",
                "payslip_reminder_sent": "Lønseddel påmindelse sendt",
                "payroll_created": "Lønkørsel oprettet",
                "payroll_unlocked": "Lønkørsel låst op",
                "payroll_approved": "Lønkørsel godkendt",
                "payroll_deleted": "Lønkørsel slettet",
                "comment_add_to_employee": "Kommentar tilføjet til medarbejder",
                "employee_removed": "Medarbejder fjernet fra lønkørsel",
                "payroll_approved_by_customer": "Lønliste godkendt af kunde",
                "changed_customer_employees_address": "Ændret medarbejders adresse",
                "changed_customer_hourly_employee": "Ændret timelønnet medarbejder",
                "created_employee": "Medarbejder oprettet",
                "changed_customer_employees_termination": "Ændret medarbejders opsigelse",
                "payroll_data_deleted": "Lønkørselsdata slettet",
                "voucher_statement": "Kontoudtog",
                "voucher": "Bilag"
            },
            "employee_deleted": "Medarbejder slettet",
            "data_deleted": "Data slettet",
            "log_headline": "Log",
            "date_selection": "Dato (Fra/Til)",
            "search": "Søg i periode"
        },
        "auth": {
            "failed": "Der blev ikke fundet nogen matches.",
            "throttle": "Der er foretaget for mange loginforsøg. Prøv igen om {seconds} sekunder.",
            "email_txt": "Venligst indtast din email",
            "pw_txt": "Venligst indtast din adgangskode",
            "remember_txt": "Hold mig logget ind",
            "login_txt": "Log ind",
            "password": "Adgangskode",
            "pw_forgot_txt": "Glemt din adgangskode?",
            "reset_txt": "Nulstil Adgangskode",
            "email": "E-Mail Adresse",
            "link_txt": "Send Adgangskode Nulstil Link",
            "password_confirm": "Bekræft Adgangskode",
            "office365_error": "Fejl, kunne ikke finde bruger. Venligst benyt den almindelige login side.",
            "deactivated_error": "Fejl, brugeren har ingen aktive virksomheder. Venligst kontakt {contact} for nærmere info.",
            "deleted_error": "Fejl, brugeren har ingen aktive virksomheder. Venligst kontakt {contact} for nærmere info.",
            "remember_me": "Husk mig",
            "forgot_password": "Glemt adgangskode",
            "email_placeholder": "Indtast email",
            "password_placeholder": "Indtast adgangskode",
            "email_password_reset_link": "Nulstil adgangskode",
            "or_return_to": "Eller, vend tilbage til",
            "log_in": "Log ind",
            "enter_email_to_receive_password_reset_link": "Indtast email for at modtage et link til at nulstille adgangskoden",
            "link_sent": "Link til at nulstille adgangskoden er blevet sendt",
            "login_with_microsoft": "Log ind med Microsoft",
            "login_error": "Email eller adgangskode er forkert",
            "password_reset_title": "Nulstil adgangskode",
            "password_reset_description": "Indtast din nye adgangskode nedenfor",
            "password_reset_email": "Email",
            "password_reset_password": "Adgangskode",
            "password_reset_confirm_password": "Bekræft adgangskode",
            "password_reset_send": "Nulstil adgangskode",
            "password_reset_resend": "Gentag link",
            "password_reset_resend_description": "En ny link er blevet sendt til dig",
            "no_company": "Du har ingen virksomhed. Venligst kontakt support for at få hjælp.",
            "create_user": "Opret bruger"
        },
        "bi_and_companies": {
            "id": "ID",
            "reporting_account": "Reporting account",
            "reporting_account_nr": "Reporting account nr.",
            "account_mapping": "Account mapping",
            "measurement_calculation": "Measurement calculation",
            "edit_bi_row": "BI report konto",
            "add_bi_row": "Tilføj BI report konto",
            "csv_import_warning": "Venligst vær opmærksom på at \"upload csv\"-metoden sletter alle eksisterende informationer fra tabellen og overskriver med filerne fra csv filen. Såfremt du vil indsætte én række til tabellen, så brug venligst tilføj knappen i stedet.",
            "csv_headers_needed": "Csv-filen skal være semi-kolon separeret, med følgende kolonnenavne:",
            "csv_formatting_error": "Invalid filformat. Venligst sørg for at uploade i korrekt format med følgende kolonner: reporting account;reporting account nr;accounts in mapping;measurement calculation. Csv filen skal være separeret med \";\"",
            "delete_bi_row": "Slet BI report konto",
            "delete_bi_row_content": "Er du sikker på at du vil slette denne BI report konto?"
        },
        "button-text": {
            "save": "Gem",
            "register-economic": "Registrer ændringerne",
            "display-statement": "Vis kontoudtog",
            "uploaded-without-voucher": "Uploaded uden bilag",
            "1": "Ja",
            "0": "Nej",
            "choose_status": "Vælg status"
        },
        "companies": {
            "delete_error_start": "Følgende brugere er knyttet til virksomheden:<br><br> ",
            "delete_error_end": "<br><br>Slet venligst medarbejderne først og derefter virksomheden.",
            "read_from_economic_success": "Indlæst følgende virksomheder fra e-conomic:",
            "no_new_read_from_economic_success": "Ingen nye virksomheder indlæst fra E-conomic",
            "update_frequency_options": {
                "monthly": "Månedligt",
                "quarterly": "Kvartalsvist",
                "yearly": "Årligt",
                "": "Mangler info"
            },
            "vat_frequency_options": {
                "six-monthly": "Halvårligt",
                "monthly": "Månedligt",
                "quarterly": "Kvartalsvist",
                "": "Mangler info",
                "missing_info": "Mangler info",
                "n/a": "Fritaget"
            },
            "price_frequency_options": {
                "hourly": "Timebasis",
                "monthly": "Månedligt"
            },
            "day_frequency_options": {
                "monday": "Mandag",
                "tuesday": "Tirsdag",
                "wednesday": "Onsdag",
                "wedensday": "Onsdag",
                "thursday": "Torsdag",
                "friday": "Fredag",
                "": "Mangler info"
            },
            "kube_data_field_missing": "Mangler info",
            "no_value_defined": "Ingen {placeholder} defineret",
            "update_error_url": "URLen skal have følgende format: \"http://example.com\" <br>",
            "update_error_email": "Email adressen skal have følgende format: \"example@example.com\" <br>",
            "customer_no": {
                "success": "Kundenummer blev gemt og E-conomic data er nu klar til at blive importeret",
                "modal": "Opret kundenummer",
                "label": "Indtast kundenummer (svarende til E-conomic kontoplanens nummer)"
            },
            "working_days": "arbejdsdag",
            "choose": "Vælg kunde",
            "save_success": "Information blev gemt",
            "header": "Virksomheder",
            "read_from_economic": "Opdater eksisterende virksomheder fra e-conomic",
            "economic_tab_text": "E-conomic",
            "setup_tab_text": "Opsætning",
            "plain_account": "Kun KC",
            "api_token": "API token",
            "economic_account": "E-conomic",
            "system_tab_text": "System",
            "services_tab_text": "Service",
            "basic_tab_text": "Basis",
            "api_tab_text": "API data",
            "accounts_tab_text": "Accounts",
            "salary_tab_text": "Løn",
            "two_step_verification": "Brug to-step godkendelse på lønsedler",
            "yes_no": [
                "Nej",
                "Ja"
            ],
            "approver_1": "Godkender 1",
            "approver_2": "Godkender 2",
            "bi_tab_text": "BI",
            "outlay_tab_text": "Outlay",
            "header_user_companies": "Ansatte & Virksomheder",
            "choose_help_text": "Venligst vælg en kunde",
            "missing_info": "Mangler info",
            "form": {
                "name": "Navn",
                "cvr": "CVR nummer:",
                "address": "Adresse:",
                "economic_number": "E-conomic aftalenummer:",
                "customer_no": "Kundenummer",
                "postal_code": "Post nummer",
                "city": "By",
                "telephone": "Telefon",
                "contact": "Kontakt",
                "email": "Email",
                "sign_up_date": "Tilmeldingsdato",
                "website": "Hjemmeside",
                "county": "Kommune",
                "country": "Land",
                "currency": "Valuta",
                "mobile_number": "Mobil",
                "primary_employee": "Primær medarbejder",
                "assistant_id": "Sekundær medarbejder",
                "roger_invoices": "Corpay One faktura email",
                "roger_receipts": "Corpay One kvitteringer",
                "keepers_email": "Keepers email",
                "contract_link": "Kontrakt",
                "data_processor_contract_link": "Databehandler aftale",
                "fax_number": "Fax nummer",
                "vat_number": "Momsnummer",
                "press_to_read": "Tryk her for at læse",
                "system_details": {
                    "num_of_vouchers": "Antal bilag i aftalen",
                    "has_salary": "Løn hos Keepers",
                    "has_app_service": "Outlay",
                    "has_payments": "Betalinger hos Keepers:",
                    "has_f_box": "F-Box hos Keepers:",
                    "has_outsourcing": "Outsourcing:",
                    "to_keepers_kube": "Skal i Keepers Kube:",
                    "fixed_price": "Fast pris",
                    "price_frequency": "Pris frekvens",
                    "voucher_limit": "Grænse for manglende bilag",
                    "report_deadline": "Rapporteringsdeadline",
                    "salary_deadline": "Løn deadline:",
                    "has_power_bi": "Power BI",
                    "update_frequency": "Opdateringsfrekvens",
                    "vat_frequency": "Momsfrekvens",
                    "day_frequency": "Ugentlig frekvens",
                    "has_kube": "Kube",
                    "has_e_income": "E indkomst",
                    "salary_system": "Lønsystem",
                    "kube_data_field_id": "En del af Kube",
                    "has_roger_ai": "Corpay One",
                    "kube_id": "Kube ID"
                },
                "bi": {
                    "economic_token": "E-conomic Token"
                },
                "has_power_bi": "Power BI",
                "num_of_vouchers": "Antal bilag i aftalen",
                "fixed_price": "Fast pris",
                "voucher_limit": "Bilagsgrænse",
                "has_salary": "Løn",
                "has_robotics": "Robotics",
                "has_consulting": "Consulting",
                "has_outsourcing": "Outsourcing",
                "report_deadline": "Rapport deadline",
                "vat_frequency": "Momsfrekvens",
                "update_frequency": "Opdateringsfrekvens",
                "outlay_company_id": "Match med Outlay virksomhed",
                "choose_services": "Vælg services",
                "select": "Select"
            },
            "deactivated": "Inaktiv",
            "outlay": {
                "deselect": "Intet match i Outlay"
            },
            "js": {
                "create": "Opret",
                "company_create": "Opret virksomhed",
                "company_edit": "Ret virksomhed",
                "update": "Opdater",
                "delete": {
                    "title": "Slet virksomhed",
                    "content": "NB! Dette sletter følgende:<br> - alle virksomhedens brugere, medmindre de er knyttet til andre virksomheder<br>- alle lønkørsler<br>- alle lønsedler<br>- alle medarbejdere<br><br>Handlingen kan ikke fortrydes.<br><br>Er du sikker på at du vil slette virksomheden?",
                    "yes": "Ja",
                    "no": "Nej",
                    "header": "Er du sikker på at du vil slette virksomheden?",
                    "will_delete": "Dette sletter følgende:",
                    "deleted_rows": {
                        "users": "alle virksomhedens brugere, medmindre de er knyttet til andre virksomheder",
                        "payrolls": "alle lønkørsler",
                        "pay_slips": "alle lønsedler",
                        "employees": "alle medarbejdere"
                    },
                    "cannot_be_undone": "Handlingen kan ikke fortrydes."
                },
                "restore": {
                    "title": "Gendan virksomhed",
                    "content": "Er du sikker på at du vil gendanne virksomheden?",
                    "yes": "Ja",
                    "no": "Nej",
                    "success": "Virksomheden blev gendannet"
                },
                "deactivate": {
                    "title": "Deaktivér virksomhed",
                    "content": "Er du sikker på at du vil deaktivere virksomheden?",
                    "yes": "Ja",
                    "no": "Nej",
                    "success": "Virksomheden blev deaktiveret"
                },
                "activate": {
                    "title": "Aktivér virksomhed",
                    "content": "Er du sikker på at du vil aktivere virksomheden?",
                    "yes": "Ja",
                    "no": "Nej",
                    "success": "Virksomheden blev aktiveret"
                }
            },
            "table": {
                "id": "Id",
                "name": "Navn",
                "cvr": "CVR nummer",
                "address": "Adresse",
                "economic_number": "E-conomic aftalenummer",
                "customer_no": "E-conomic customer number",
                "num_of_vouchers": "Antal bilag",
                "fixed_price": "Fast pris",
                "vat_frequency": "Momsfrekvens",
                "update_frequency": "Opdateringsfrekvens"
            },
            "companies_table": {
                "id": "Id",
                "name": "Navn",
                "cvr": "CVR nummer",
                "address": "Adresse",
                "economic_number": "E-conomic aftalenummer",
                "customer_no": "E-conomic customer number",
                "economic_customer_number": "E-conomic kundenummer",
                "num_of_vouchers": "Antal bilag",
                "fixed_price": "Fast pris",
                "vat_frequency": "Momsfrekvens",
                "update_frequency": "Opdateringsfrekvens",
                "status": "Status"
            },
            "bi_table": {
                "name": "Navn",
                "cvr": "CVR nummer",
                "address": "Adresse",
                "economic_number": "E-conomic aftalenummer"
            },
            "select": {
                "has_salary": "Løn tilvalgt",
                "no_salary": "Ingen løn",
                "deactivated": "Inactive"
            },
            "clients": "Kunder",
            "accounts": "Konti",
            "dimensions": "Dimensioner",
            "no_dimensions": "Ingen dimensioner",
            "loading_dimensions": "Henter dimensioner",
            "services": "Services",
            "general_settings": "Generelle indstillinger",
            "kube_settings": "Kube indstillinger",
            "employees_assigned": "Tildelte medarbejdere på",
            "created": "Virksomheden blev oprettet",
            "updated": "Virksomheden blev opdateret",
            "deleted": "Virksomheden blev slettet",
            "user_companies_table": {
                "id": "ID",
                "name": "Navn",
                "employees": "Keepers medarbejdere",
                "count": "Antal",
                "has_salary": "Virksomhed har løn"
            },
            "user_companies_edit_title": "Administrer tilknytning",
            "user_companies_edit": "Vælg tilknytnig af Keepers medarbejdere",
            "user_companies_edit_success": "Tilknytningen blev opdateret",
            "user_companies_edit_error": "Der skete en fejl, da tilknytningen blev opdateret",
            "active": "Aktive",
            "non_active": "Ikke aktive",
            "none_selected": "Ingen virksomhed",
            "information": "Stamoplysninger",
            "no_voucher_accounts": "Ingen konti tilknyttet",
            "economic_unauthorized": "E-conomic API token er ikke gyldig"
        },
        "company-affiliation": {
            "nav": {
                "header": "Virksomheder & Koncern"
            },
            "navbar_header": "Virksomheder & Koncern",
            "table": {
                "group_id": "KoncernsId",
                "group": "Koncern",
                "company_id": "VirksomhedsId",
                "companies": "Virksomhed"
            }
        },
        "company-groups": {
            "actions": {
                "create": "Opret",
                "update": "Opdater",
                "delete": "Slet"
            },
            "delete": {
                "title": "Slet koncernen",
                "content": "NB! Dette sletter koncernen. Handlingen kan ikke fortrydes.<br>Er du sikker på at du vil slette koncernen?",
                "yes": "Slet",
                "no": "Fortryd"
            },
            "form": {
                "labels": {
                    "name": "Koncern navn",
                    "companies": "Tilknyttede virksomheder"
                },
                "placeholders": {
                    "name": "Gefion"
                }
            },
            "company_groups_create": "Opret koncern",
            "company_groups_edit": "Opdater koncern",
            "part_of": "En del af",
            "header_companies_groups": "Virksomheder & Koncern",
            "table_headers": {
                "id": "ID",
                "name": "Navn",
                "companies": "Tilknyttede virksomheder",
                "count": "Antal"
            },
            "created": "Koncernen er blevet oprettet",
            "updated": "Koncernen er blevet opdateret",
            "deleted": "Koncernen er blevet slettet"
        },
        "credit-cards": {
            "page_header": "Registrerede kreditkort",
            "table": {
                "name": "Navn",
                "number": "Kortnummer",
                "type": "Korttype",
                "company": "Virksomhed",
                "assigned": "Tilknyttet",
                "last_used": "Sidst anvendt"
            },
            "form": {
                "name": "Navn",
                "number": "Kortnummer",
                "type": "Korttype",
                "employee_ids": "Tilknyttede medarbejder(e)",
                "user_ids": "Tilknyttede bruger(e)",
                "number_min": "Kortnummeret skal være 16 cifre",
                "number_max": "Kortnummeret skal være 16 cifre"
            },
            "create": {
                "title": "Opret kreditkort",
                "success": "Kreditkortet {name} er blevet oprettet"
            },
            "edit": {
                "title": "Ret kreditkort",
                "success": "Kreditkortet {name} er blevet opdateret"
            },
            "delete": {
                "title": "Slet kreditkort",
                "content": "Er du sikker på, at du vil slette kreditkortet?",
                "success": "Kreditkortet er blevet slettet"
            },
            "types": {
                "visa": "Visa",
                "mastercard": "Mastercard",
                "discover": "Discover",
                "unionpay": "Unionpay",
                "jcb": "JCB",
                "other": "Andet"
            }
        },
        "custom-rules": {
            "ids_exists_in_table": {
                "message": "Én eller flere af værdierne for {tableName} er ugyldige."
            },
            "exists_in_table": {
                "message": "Værdien for {tableName} er ugyldig."
            }
        },
        "dashboards": {
            "salery": "Løn",
            "payroll": "Løn",
            "power_bi": "Power BI",
            "app_service": "App",
            "payments": "Betalinger",
            "f_box": "F-Box",
            "salary_app": "Danløn App",
            "e_income": "E indkomst",
            "roger_ai": "Corpay One",
            "outsourcing": "Outsourcing",
            "consulting": "Consulting",
            "robotics": "Robotics",
            "yes": "JA",
            "no": "NEJ",
            "tasks_open": "Åben",
            "tasks_finish": "Færdig",
            "tasks_closed": "Lukket",
            "tasks_recurring": "Gentagende",
            "vouchers": {
                "account_number": "Ingen konto valgt",
                "no_file": "Intet bilag uploaded",
                "has_files": "Bilag uploaded",
                "deadline": "Deadline om {deadline} dage",
                "success": "Godkendt",
                "failure": "Ej godkendt"
            },
            "edit_user_companies": "Tilknyt medarbejder(e)",
            "feed": {
                "info": "Feed info"
            },
            "feed_header": "Feed",
            "vouchers_header": "Manglende Bilag",
            "primary_employees": "Primær medarbejder",
            "assistant": "Sekundær medarbejder",
            "general_info": "Generel info",
            "support": "Support",
            "procedures_header": "Måneds-luk procedure",
            "procedures_create": "Opret procedure",
            "procedures_edit": "Rediger procedure",
            "procedures_delete": "Slet procedure",
            "procedures_delete_confirm": "Er du sikker på at du vil slette denne procedure?",
            "procedures_delete_success": "Procedure slettet",
            "tasks_header": "Aktuelle opgaver",
            "tasks_create": "Opret opgave",
            "tasks_create_from_template": "Opgave fra template",
            "stats_header": "Stats hos Keepers",
            "vouchers_date": "Dato",
            "vouchers_description": "Beskrivelse",
            "vouchers_amount": "Beløb",
            "vouchers_contra_account": "Modkonto",
            "vouchers_status": "Status",
            "vouchers_account": "Konto",
            "vouchers_filename_uploaded": "Filnavn",
            "vouchers_deadline_voucher": "Deadline",
            "tasks_status": "Status",
            "tasks_notification": "Opgave notifikation",
            "tasks_add": "Opgave",
            "tasks_add_from_template": "Opgaver fra template",
            "tasks_delete": "Slet opgave",
            "tasks_delete_confirm": "Er du sikker på at du vil slette denne opgave?",
            "tasks_delete_success": "Opgave slettet",
            "selected_template": "Vælg template",
            "procedures_add": "Procedure",
            "procedures_choose_responsible": "Vælg ansvarlig",
            "tasks_title": "Titel",
            "tasks_description": "Beskrivelse",
            "tasks_deadline": "Deadline",
            "procedures": "Beskrivelse",
            "companies_users": "Vælg tilknytning af Keepers medarbejdere",
            "notification": {
                "send_notification": "Send notifikation",
                "day_in_week": "Dag i ugen",
                "frequency": "Frekvens",
                "choose_odd_or_even_week": "Vælg lige eller ulige uge",
                "choose_start_or_end_month": "Vælg start eller slut i måneden"
            },
            "stats": {
                "num_of_vouchers": "Antal bilag i aftalen:",
                "fixed_price": "Fast pris:",
                "hourly_price": "Timepris:",
                "voucher_limit": "Max antal bortkomne bilag:",
                "has_salary": "Løn hos Keepers:",
                "has_power_bi": "BI:",
                "report_deadline": "Rapporteringsdeadline:",
                "vat_frequency": "Momsfrekvens:",
                "update_frequency": "Opdateringsfrekvens:",
                "price_frequency": {
                    "monthly": "pr. måned",
                    "hourly": "pr. time"
                }
            },
            "customer_stats": {
                "price_frequency": {
                    "monthly": "Pris pr. måned",
                    "hourly": "Pris pr. time"
                },
                "missing_vouchers": "Manglende bilag",
                "vat_frequency": "Momsfrekvens",
                "procedures": "Måneds-luk procedurer",
                "work_days": "{count} arbejdsdage",
                "weekdays": "Ugedage: {days}",
                "actual_tasks": "Aktuelle opgaver"
            },
            "marquee": {
                "keepers_email": "Keepers email",
                "corpay_invoice": "Corpay One faktura",
                "corpay_receipts": "Corpay One kvitteringer"
            },
            "employee": {
                "progress": "Status (%)",
                "docs": "Docs (Dropbox)",
                "payroll_progress": "Løn status",
                "payroll_reported": "Løn rapporteret?",
                "salary_deadline": "Løn deadline",
                "pay_slips_for_approval": "Løn til godkendelse",
                "payslips_approved": "Løn godkendt?",
                "payslips_sent": "Løn sendt?",
                "deadlines_header": "Deadlines",
                "metrics_header": "Metrics",
                "others_header": "Andet",
                "payroll_finalized": "Løn færdig?",
                "hand_in": "Hand-in deadline",
                "reported_deadline": "Rapport deadline",
                "repoting_finised": "Status",
                "next_vat_deadline": "Næste moms deadline",
                "accounting_year": "Regnskabsår",
                "frequency": "Frekvens",
                "vat_reported": "Status",
                "open_tasks": "Åbne opgaver på opgavelisten",
                "no_of_tasks": "Antal opgaver",
                "overdue_tasks": "Overskredne opgaver",
                "product_related_header": "Produktrelateret:",
                "table_company": "Virksomhed",
                "postings": "Posteringer vs. aftale",
                "actual_vs_contract": "Aktuel vs. kontrakt",
                "action": "Handling",
                "active_services": "Aktive produkter",
                "tasks_table_task": "Opgave",
                "tasks_table_file": "Vedhæftet",
                "tasks_table_date": "Deadline",
                "tasks_table_status": "Status",
                "tasks_table_task_responsible_name": "Ansvarlig",
                "no_companies": "Ingen virksomheder tilknyttet",
                "bookkeeping_header": "Bogføring status",
                "vat_header": "Moms status",
                "payroll_header": "Løn status",
                "tasks_table_task_description": "Beskrivelse",
                "book_status": "Status",
                "amount_of_customers": "Antal kunder",
                "amount_of_customers_missing_report": "Antal kunder der mangler rapport",
                "amount_of_customers_missing_salery": "Antal kunder der mangler løn",
                "amount_of_customers_missing_voucher": "Antal kunder der mangler bilag",
                "amount_of_customers_missing_report_within_two_days": "Antal kunder der mangler rapport inden for 2 dage",
                "over_deadline": "Antal kunder over deadline",
                "daily_frequency": "Ugedag",
                "update_frequency": "Opdateringsfrekvens",
                "reporting_finished": "Report status",
                "handled_vouchers": "Håndteret bilag",
                "missing_docs_deadline": "Deadline m.b.",
                "vat_frequency": "Momsfrekvens",
                "reload_on_demand": "Reload on demand",
                "global_search": {
                    "placeholder": "Filtrer virksomheder"
                },
                "weekdays": "Ugedage",
                "stats": {
                    "customers_assigned": "Antal kunder",
                    "customers_missing_vouchers": "Kunder der mangler bilag",
                    "customers_missing_report": "Kunder der mangler rapport",
                    "customers_missing_report_within_two_days": "Kunder der mangler rapport inden for 2 dage",
                    "customers_missing_onboarding": "Kunder der mangler onboarding",
                    "cusomters_over_deadline": "Kunder over deadline",
                    "days_until_accounting_deadline": "Kunder med under 7 dage til bogførings deadline",
                    "days_until_report_deadline": "Kunder med under 7 dage til rapporteringsdeadline",
                    "days_until_vat_deadline": "Kunder med under 7 dage til moms rap. deadline"
                }
            },
            "salary": {
                "output": "Output løn"
            },
            "vouchers_product": "Bilag",
            "dashboards": {
                "employee": {
                    "daily_frequency": "Ugedag"
                }
            },
            "comment": {
                "employees": "Ansatte tilknyttet:",
                "comment_by": "Kommentar af:",
                "body": "Kommentar",
                "comment": "Kommentar",
                "store": "Opret ny kommentar:",
                "update": "Opdater",
                "delete": "Slet",
                "new": "Ny",
                "assigned_to": "Tildelt til",
                "title": "Kommentarer på {company}",
                "placeholder": "Indtast {'@'} for at tagge en bruger"
            },
            "hard_refresh": "Opdater",
            "title": "Dashboard",
            "buttons": {
                "customize_columns": "Tilpas kolonner",
                "collapse": "Luk koncerner",
                "expand": "Udfold koncerner"
            },
            "grouping": {
                "my_clients": "Mine kunder",
                "all": "Alle",
                "outsourcing": "Outsourcing",
                "powerbi": "PowerBI",
                "salary": "Løn",
                "roger_ai": "Corpay One"
            },
            "table_headers": {
                "name": "Virksomhed",
                "keepers_employees": "Tildelt til",
                "status": "Status",
                "deadline": "Deadline Mgl. bilag",
                "report_status": "Rapport status",
                "report_deadline": "Rapport deadline",
                "vat_status": "Moms status",
                "vat_deadline": "Næste moms deadline",
                "accouting_year": "Regnskabsår",
                "output_salary": "Output løn",
                "vat_frequency": "Momsfrekvens",
                "weekday": "Ugedag",
                "update_frequency": "Opdateringsfrekvens",
                "postings": "Posteringer vs. aftale",
                "actual_vs_contract": "Aktuel vs. kontrakt",
                "active_services": "Aktive produkter",
                "handled_vouchers": "Manglende bilag",
                "reload_on_demand": "Reload on demand"
            },
            "datatable": {
                "name": "Virksomhed",
                "keepers_employees": "Tildelt",
                "bookkeeping_status": "Bogføringsstatus",
                "bookkeeping_deadline": "Bogf. deadline",
                "report_status": "Rapporteringsstatus",
                "report_deadline": "Rap. deadline",
                "vat_status": "Moms rapporteringsstatus",
                "vat_deadline": "Moms rap. deadline",
                "pbc_status": "PBC status",
                "pbc_deadline": "PBC deadline",
                "annual_report": "Afstemt til årsrapport",
                "accouting_year": "Regnskabsår",
                "onboarding": "Onboarding",
                "vat_frequency": "Momsfrekvens",
                "weekday": "Ugedag(e)",
                "update_frequency": "Opdateringsfrekvens",
                "postings": "Posteringer vs. aftale",
                "actual_vs_contract": "Faktisk vs. kontrakt",
                "active_services": "Aktive services",
                "handled_vouchers": "Manglende bilag",
                "reload_on_demand": "Genindlæs ved behov"
            },
            "bulk_update_success": "{status} opdateret for {count} virksomheder",
            "tasks_help": "Aktuelle opgaver er åbne opgaver som skal løses indenfor den specificerede deadline.",
            "procedures_help": "Månedsluk procedurer er opgaver der udføres til sidst i måneden.",
            "status_update_failed": "Opdatering af status fejlede",
            "invoices": {
                "title": "Fakturaer",
                "table": {
                    "number": "Faktura nr.",
                    "date": "Dato",
                    "amount": "Pris (ex. moms)",
                    "status": "Status"
                },
                "download": "Se faktura",
                "no_cvr": "Indlæsning af fakturaer kræver at virksomheden har et CVR-nummer"
            }
        },
        "datatables": {
            "display": "Vis",
            "search": "Søg:",
            "thousands": ".",
            "zeroRecords": "Ingen matchende resultater",
            "emptyTable": "Ingen data tilgængelig",
            "info": "Viser side _PAGE_ af _PAGES_",
            "infoEmpty": "Ingen resultater blev fundet",
            "infoFiltered": "",
            "processing": "Arbejder...",
            "show_columns": "Filtrer kolonner",
            "loadingRecords": "Loader...",
            "lengthMenu": "Vis _MENU_ rækker",
            "all": "Alle",
            "paginate": {
                "first": "Første",
                "last": "Sidste",
                "next": "Næste",
                "previous": "Forrige"
            },
            "aria": {
                "sortAscending": ": aktiver for at sortere kolonne efter stigende",
                "sortDescending": ": aktiver for at sortere kolonne efter faldende"
            },
            "search_placeholder": "Søg...",
            "show": "Vis",
            "rows": "rækker",
            "rows_selected": "række(r) valgt",
            "showing": "Viser",
            "to": "til",
            "of": "af",
            "entries": "resultater",
            "page": "Side",
            "loading": "Henter...",
            "expand_all": "Åben grupperinger",
            "collapse_all": "Luk grupperinger",
            "reload_table": "Genindlæs tabel",
            "view_options": {
                "header": "Visninger",
                "add_option": "Tilføj visning",
                "choose_columns": "Vælg kolonner til visning",
                "placeholder": "Unavngivet",
                "default": "Standard",
                "global_views": "Delte visninger",
                "personal_views": "Mine visninger",
                "make_global": "Del med alle",
                "make_personal": "Gør privat",
                "shared": "Delt"
            },
            "no_company": "Ingen virksomhed valgt"
        },
        "dropzone": {
            "dictDefaultMessage": "Drop dine filer her for at upload",
            "dictFallbackMessage": "Din browser understøtter ikke træk-og-slip fil-uploads.",
            "dictFallbackText": "Venligst brug backup formen forneden til at uploade dine filer, ligesom i gamle dage..",
            "dictFileTooBig": "Filen er for stor ({{filesize}}MiB). Maks filestørrelse: {{maxFilesize}}MiB.",
            "dictInvalidFileType": "Du må ikke uploade filer af denne type.",
            "dictResponseError": "Server svarede med en {{statusCode}} kode.",
            "dictCancelUpload": "Fortryd",
            "dictCancelUploadConfirmation": "Er du sikker på at du vil fortryde?",
            "dictRemoveFile": "Fjern",
            "dictMaxFilesExceeded": "Du må kun uploade én fil per bilag.",
            "dictCustomDropMessage": "Drop dine filer her for at upload. Du kan uploade op til 4 filer."
        },
        "economic-period": {
            "table": {
                "company": "Virksomhed",
                "january": "Jan",
                "february": "Feb",
                "march": "Mar",
                "april": "Apr",
                "may": "Maj",
                "june": "Jun",
                "july": "Jul",
                "august": "Aug",
                "september": "Sept",
                "october": "Okt",
                "november": "Nov",
                "december": "Dec",
                "year": "År"
            }
        },
        "economic": {
            "cashbook": {
                "not_found": "Kladden {cashbook} blev ikke fundet."
            },
            "account": {
                "not_found": "En eller flere af kontiene blev ikke fundet."
            },
            "department": {
                "not_found": "En eller flere af afdelingerne blev ikke fundet."
            },
            "default_voucher_error": "Der opstod en fejl ved opdatering af bilaget i E-conomic. Prøv venligst igen eller kontakt support for nærmere info.",
            "voucher_not_found": "Bilaget blev ikke fundet i E-conomic."
        },
        "employee": {
            "validation": {
                "errors_found": "Følgende fejl blev fundet:",
                "first_name": "Venligst indtast fornavn",
                "last_name": "Venligst indtast efternavn",
                "cpr": "Venligst indtast et korrekt cpr",
                "email": "Venligst indtast en korrekt email-adresse",
                "company_id": "Venligst vælg en kunde",
                "employee_id": "Venligst vælg medarbejdere fra tabellen at eksportere. Dette gøres ved at sætte flueben ved medarbejderne",
                "phone_private": "Venligst indtast et korrekt nummer. Maks længde er 12 cifre",
                "phone_cell": "Venligst indtast et korrekt nummer. Maks længde er 12 cifre",
                "employment_date": "Venligst indtast en ansættelsesdato i formattet dd/mm/yyyy",
                "address": "Venligst indtast en adresse",
                "postal_code": "Venligst indtast et postnr.",
                "city": "Venligst indtast en by",
                "country_code": "Venligst vælg et land",
                "bank_reg": "Bank reg. nr. skal være 4 cifre",
                "bank_account": "Bank kontonr. skal være 10 cifre",
                "iban_empty": "Venligt indtast IBAN nummer",
                "swift_empty": "Venligt indtast et SWIFT nummer",
                "employee_contribution": "Venligst indtast medarbejderbidrag til pensionen",
                "company_contribution": "Venligst firmabidrag til pensionen",
                "pension_company": "Venligst indtast pensionsselskab",
                "salary": "Venligst indtast månedsløn",
                "fixed_add_ons": "Venligst indtast faste tillæg",
                "hourly_rate": "Venligst indtast timeløn",
                "production_unit": "Venligst indtast produktionsenhed",
                "days_vacation": "Venligst indtast feriefridage pr. år",
                "flex_savings": "Venligst indtast fritvalgsopsparing",
                "yes": "Ja",
                "no": "Nej",
                "confirm": "er allerede blevet download. Danløn tillader ikke overskrivelser. Download alligevel?",
                "title": "Allerede downloaded",
                "are_you_sure": "Er du sikker?",
                "delete_employee_confirm_text": "Vil du virkelig gerne slette denne medarbejder?",
                "deleted_employee": "Medarbejder slettet",
                "weekly_working_hours": "Venligst indtast ugentlige arbejdstimer",
                "user_id": "En bruger skal vælges eller oprettes, når et kreditkort tilknyttes"
            },
            "page_header": "Medarbejdere",
            "create": {
                "header": "Opret medarbejder"
            },
            "edit": {
                "header": "Ret medarbejder"
            },
            "upload": {
                "header": "Upload medarbejdere",
                "admin_header": "Upload medarbejdere (Admin)",
                "invalid_headers": "Ugyldig fil. Den mangler de korrekte felter.",
                "consent": "Jeg forstår, at jeg er ved at uploade medarbejdere til {name}"
            },
            "address": {
                "header": "Adresse",
                "address": "Adresse",
                "address2": "Adresse 2",
                "postal_code": "Postnr.",
                "city": "By",
                "country_code": "Land",
                "pnumber": "Pnummner",
                "country_codes_array": {
                    "DK": "Danmark",
                    "AF": "Afghanistan",
                    "AL": "Albanien",
                    "DZ": "Algeriet",
                    "AS": "Amerikansk Samoa",
                    "AD": "Andorra",
                    "AO": "Angola",
                    "AI": "Anguilla",
                    "AQ": "Antarctica",
                    "AG": "Antigua and Barbuda",
                    "AR": "Argentina",
                    "AM": "Armenien",
                    "AW": "Aruba",
                    "AU": "Australien",
                    "AZ": "Azerbaijan",
                    "BS": "Bahamas",
                    "BH": "Bahrain",
                    "BD": "Bangladesh",
                    "BB": "Barbados",
                    "BY": "Belarus",
                    "BE": "Belgien",
                    "BZ": "Belize",
                    "BJ": "Benin",
                    "BM": "Bermuda",
                    "BT": "Bhutan",
                    "BO": "Bolivia",
                    "BQ": "Bonaire",
                    "BA": "Bosnien & Herzegovina",
                    "BW": "Botswana",
                    "BV": "Bouvet Island",
                    "BR": "Brasilien",
                    "BN": "Brunei Darussalam",
                    "BG": "Bulgarien",
                    "BF": "Burkina Faso",
                    "BI": "Burundi",
                    "CV": "Cabo Verde",
                    "KH": "Cambodia",
                    "CM": "Cameroun",
                    "CA": "Canada",
                    "KY": "Cayman Islands",
                    "TD": "Chad",
                    "CL": "Chile",
                    "CX": "Christmas Island",
                    "CC": "Cocos Islands",
                    "CO": "Colombia",
                    "KM": "Comoros",
                    "CG": "Congo",
                    "CK": "Cook Islands",
                    "CR": "Costa Rica",
                    "CU": "Cuba",
                    "CW": "Curaçao",
                    "CY": "Cypern",
                    "DJ": "Djibouti",
                    "DM": "Dominica",
                    "AE": "De Forenede Arabiske Emirater",
                    "CF": "Den Centralafrikanske Republik",
                    "CD": "Den Demokratiske Republik Congo",
                    "DO": "Den Dominikanske Republik",
                    "EC": "Ecuador",
                    "EG": "Egypten",
                    "SV": "El Salvador",
                    "CI": "Elfenbenskysten",
                    "ER": "Eritrea",
                    "EE": "Estonia",
                    "SZ": "Eswatini",
                    "ET": "Etiopien",
                    "FK": "Falklandsøerne",
                    "FJ": "Fiji",
                    "FI": "Finland",
                    "FR": "Frankrig",
                    "GF": "Fransk Guiana",
                    "PF": "Fransk Polynesien",
                    "FO": "Færøerne",
                    "GA": "Gabon",
                    "GM": "Gambia",
                    "GE": "Georgien",
                    "GH": "Ghana",
                    "GI": "Gibraltar",
                    "GD": "Grenada",
                    "GR": "Grækenland",
                    "GL": "Grønland",
                    "GP": "Guadeloupe",
                    "GU": "Guam",
                    "GT": "Guatemala",
                    "GG": "Guernsey",
                    "GN": "Guinea",
                    "GW": "Guinea-Bissau",
                    "GY": "Guyana",
                    "HT": "Haiti",
                    "NL": "Holland",
                    "HN": "Honduras",
                    "HK": "Hong Kong",
                    "IS": "Island",
                    "IN": "Indien",
                    "ID": "Indonesien",
                    "IR": "Iran",
                    "IQ": "Irak",
                    "IE": "Irland",
                    "IM": "Isle of Man",
                    "IL": "Israel",
                    "IT": "Italien",
                    "JM": "Jamaica",
                    "JP": "Japan",
                    "JE": "Jersey",
                    "VG": "Jomfruøerne (British)",
                    "VI": "Jomfruøerne (U.S.)",
                    "JO": "Jordan",
                    "KZ": "Kazakhstan",
                    "KE": "Kenya",
                    "CN": "Kina",
                    "KI": "Kiribati",
                    "HR": "Kroatien",
                    "KW": "Kuwait",
                    "KG": "Kyrgyzstan",
                    "LV": "Letland",
                    "LB": "Libanon",
                    "LS": "Lesotho",
                    "LR": "Liberien",
                    "LY": "Libyen",
                    "LI": "Liechtenstein",
                    "LT": "Litauen",
                    "LU": "Luxembourg",
                    "MO": "Macao",
                    "MG": "Madagascar",
                    "MW": "Malawi",
                    "MY": "Malaysia",
                    "MV": "Maldiverne",
                    "ML": "Mali",
                    "MT": "Malta",
                    "MH": "Marshall Islands",
                    "MQ": "Martinique",
                    "MR": "Mauritania",
                    "MU": "Mauritius",
                    "YT": "Mayotte",
                    "MX": "Mexico",
                    "FM": "Micronesia",
                    "MD": "Moldova",
                    "MC": "Monaco",
                    "MN": "Mongoliet",
                    "ME": "Montenegro",
                    "MS": "Montserrat",
                    "MA": "Marokoo",
                    "MZ": "Mozambique",
                    "MM": "Myanmar",
                    "NA": "Namibia",
                    "NR": "Nauru",
                    "NP": "Nepal",
                    "NC": "New Caledonia",
                    "NZ": "New Zealand",
                    "NI": "Nicaragua",
                    "NE": "Niger",
                    "NG": "Nigeria",
                    "NU": "Niue",
                    "MK": "Nordmakedonien",
                    "NF": "Norfolk Island",
                    "NO": "Norge",
                    "MP": "Northern Mariana Islands",
                    "OM": "Oman",
                    "PK": "Pakistan",
                    "PW": "Palau",
                    "PS": "Palæstina",
                    "PA": "Panama",
                    "PG": "Papua New Guinea",
                    "PY": "Paraguay",
                    "PE": "Peru",
                    "PH": "Philipinerne",
                    "PN": "Pitcairn",
                    "PL": "Polen",
                    "PT": "Portugal",
                    "PR": "Puerto Rico",
                    "QA": "Qatar",
                    "RO": "Rumænien",
                    "RU": "Rusland",
                    "RW": "Rwanda",
                    "RE": "Réunion",
                    "BL": "Saint Barthélemy",
                    "SH": "Saint Helena",
                    "KN": "Saint Kitts and Nevis",
                    "LC": "Saint Lucia",
                    "MF": "Saint Martin (French part)",
                    "PM": "Saint Pierre and Miquelon",
                    "VC": "Saint Vincent and the Grenadines",
                    "SB": "Salomonøerne",
                    "WS": "Samoa",
                    "SM": "San Marino",
                    "ST": "Sao Tome and Principe",
                    "SA": "Saudi Arabien",
                    "CH": "Schweiz",
                    "SN": "Senegal",
                    "RS": "Serbien",
                    "SC": "Seychelles",
                    "SL": "Sierra Leone",
                    "SG": "Singapore",
                    "SX": "Sint Maarten",
                    "SK": "Slovakiet",
                    "SI": "Slovenien",
                    "SO": "Somalia",
                    "GS": "South Georgia and the South Sandwich Islands",
                    "ES": "Spanien",
                    "GB": "Storbritannien",
                    "LK": "Sri Lanka",
                    "SD": "Sudan",
                    "SR": "Suriname",
                    "SJ": "Svalbard",
                    "SE": "Sverige",
                    "SS": "Sydsudan",
                    "ZA": "Sydafrika",
                    "KR": "Sydkorea",
                    "SY": "Syrien",
                    "TW": "Taiwan",
                    "TJ": "Tajikistan",
                    "TZ": "Tanzania",
                    "TH": "Thailand",
                    "TL": "Timor-Leste",
                    "CZ": "Tjekkiet",
                    "TG": "Togo",
                    "TK": "Tokelau",
                    "TO": "Tonga",
                    "TT": "Trinidad and Tobago",
                    "TN": "Tunesien",
                    "TM": "Turkmenistan",
                    "TC": "Turks and Caicos Islands",
                    "TV": "Tuvalu",
                    "TR": "Tyrkiet",
                    "DE": "Tyskland",
                    "UG": "Uganda",
                    "UA": "Ukraine",
                    "HU": "Ungarn",
                    "US": "USA",
                    "UM": "USA (Minor Outlying Islands)",
                    "UY": "Uruguay",
                    "UZ": "Uzbekistan",
                    "VU": "Vanuatu",
                    "VE": "Venezuela",
                    "VN": "Vietnam",
                    "WF": "Wallis and Futuna",
                    "EH": "Western Sahara",
                    "YE": "Yemen",
                    "ZM": "Zambia",
                    "ZW": "Zimbabwe",
                    "GQ": "Ækvatorialguinea",
                    "AT": "Østrig",
                    "AX": "Åland Islands"
                },
                "cvr-address-headline": "CVR adresse(r)",
                "cvr-address-import-btn": "Importer adresse"
            },
            "vacation": {
                "months": [
                    "Ingen feriefridage",
                    "Januar",
                    "Februar",
                    "Marts",
                    "April",
                    "Maj",
                    "Juni",
                    "Juli",
                    "August",
                    "September",
                    "Oktober",
                    "November",
                    "December"
                ]
            },
            "bank": {
                "bank_reg": "Bank reg.nr.",
                "bank_account": "Bank kontonr.",
                "iban": "IBAN",
                "swift": "SWIFT",
                "transfer_manually": "Ved valg af IBAN og SWIFT skal lønnen overføres manuelt.",
                "required": "* Kræver dansk bankforbindelse",
                "header": "Bank",
                "international_account": "Jeg har ikke en dansk konto",
                "non_danish_account": "Har ikke en dansk konto"
            },
            "employment": {
                "header": "Ansættelsesforhold",
                "salaried": "Funktionæransat",
                "hourly": "Timelønnet",
                "ceo": "Direktør",
                "b_honorarium_receiver": "B-Honorarmodtager",
                "standard_time": "Arbejdstid pr. uge",
                "salary": "Månedsløn",
                "current_salary": "Nuværende månedsløn",
                "new_salary": "Ny månedsløn",
                "new_salary_starts_at": "Lønændring gældende fra",
                "future_salary_changes": "Fremtidige lønændringer",
                "future_salary_starts_at": "Gældende fra",
                "salary_change_duplicated_date_error": "Der er allerede en lønændring med denne dato",
                "has_free_car": "Fri bil",
                "free_car_monthly": "Bil - Månedligt beløb til beskatning",
                "free_car_file": "Leasingkontrakt",
                "free_car_filename": "Leasingkontrakt",
                "free_car_file_description": "Registreringsnummer",
                "free_car_file_description_warning": "Leasingkontrakt samt registreringsnr. skal oplyses i forbindelse med fri bil",
                "has_free_phone": "Fri telefon",
                "has_health_insurance": "Sundhedsforsikring",
                "hourly_rate": "Timeløn",
                "employment_type": "Ansættelsestype",
                "no_fields": "har ingen felter",
                "with": "med",
                "weekly_working_hours": "Ugentlig arbejdstimer",
                "weekly_working_days": "Ugentlige arbejdsdage",
                "tax_card": "Skattekort",
                "primary_tax_card": "Hovedkort",
                "secondary_tax_card": "Bikort",
                "tax_exemption_card": "Frikort",
                "danmarks_statistik": "Danmarks statistik",
                "disco_code": "Disco-kode",
                "dst_time_limited_employment": "Ansættelse i virksomheden",
                "dst_hired_terms": "Ansættelsesvilkår",
                "dst_job_status": "Jobstatus",
                "dst_salary_form": "Aflønningsform",
                "has_lunch_arrangement": "Frokostordning",
                "lunch_arrangement_monthly": "Frokostordning - Månedligt beløb",
                "fixed_add_ons_monthly": "Fast tillæg - Månedligt beløb",
                "has_fixed_add_ons": "Fast tillæg",
                "pension": "Pension",
                "health_insurance_monthly": "Sundhedsforsikring - Månedligt beløb",
                "free_car_filepath": "Leasingkontrakt - Filsti",
                "time_monday": "Mandag",
                "time_tuesday": "Tirsdag",
                "time_wednesday": "Onsdag",
                "time_thursday": "Torsdag",
                "time_friday": "Fredag",
                "time_saturday": "Lørdag",
                "time_sunday": "Søndag",
                "flex_savings": "Fritvalgsopsparing",
                "days_vacation": "Feriefridage pr. år",
                "allocation_of_vacation_days": "Hvornår tilskrives der feriefridage",
                "production_unit": "Produktionsenhed",
                "health_insurance": "Sundhedsforsikring",
                "has_pension": "Pension",
                "kilometer": "Kilometer",
                "diaeter": "Diæter",
                "employee_contribution": "Pension - medarbejderbidrag",
                "company_contribution": "Pension - firmabidrag",
                "pension_company": "Pensionsselskab:",
                "type": "Angiv pension i:"
            },
            "pension": {
                "header": "Pension",
                "employee_contribution": "Pension - medarbejderbidrag:",
                "company_contribution": "Pension - firmabidrag:",
                "pension_company": "Pensionsselskab:",
                "type": "Angiv pension i:",
                "type_option": "Beløb",
                "type_percentage": "Procent",
                "type_selection": "Kontonr.",
                "type_pbs": "PBS nr.",
                "type_account": "Kontonr.",
                "normal_headline": "Øvrige pensionsordninger",
                "company_headline": "Virksomhedspension",
                "pension_other": "Andet",
                "pension_none": "Ingen",
                "select_pension_company": "Vælg pensionsselskab",
                "amount_warning": "Bemærk at dette beløb ikke vil ændre sig, hvis medarbejderens månedsløn ændrer sig. Hvis Pensionen følger sammen med lønstigning, vælg i så fald procent."
            },
            "required_with": {
                "employee_contribution": "Påkrævet når firmabidrag og pensionsselskab udfyldt",
                "company_contribution": "Påkrævet når medarbejderbidrag og pensionsselskab udfyldt",
                "pension_company": "Påkrævet når firmabidrag og medarbejderbidrag udfyldt"
            },
            "companyPension": {
                "header": "Pension",
                "employee_contribution": "Virksomhedspension - medarbejderbidrag",
                "company_contribution": "Virksomhedspension - firmabidrag",
                "pension_company": "Virksomhedspension - Pensionsselskab",
                "type": "Angiv virksomhedspension i:",
                "type_option": "Beløb",
                "type_selection": "Kontonr.",
                "type_pbs": "PBS nr.",
                "type_account": "Kontonr.",
                "normal_headline": "Øvrige pensionsordninger",
                "company_headline": "Virksomhedspension",
                "has_pension": "Pension"
            },
            "pensionBank": {
                "bank_reg": "Pension - Bank reg.nr.",
                "bank_account": "Pension - Bank kontonr.",
                "header": "Pension",
                "swift": "SWIFT",
                "iban": "IBAN"
            },
            "companyPensionBank": {
                "bank_reg": "Virksomhedspension - Bank reg.nr.",
                "bank_account": "Virksomhedspension - Bank kontonr.",
                "header": "Virksomhedspension",
                "swift": "SWIFT",
                "iban": "IBAN"
            },
            "user": {
                "header": "Bruger",
                "id": "Vælg bruger",
                "create_user": "Opret ny bruger",
                "create_info": "Opretter en ny bruger med navn og e-mail angivet under 'Personlige'. Medarbejderen får tilsendt en e-mail med en adgangskode.",
                "assigned_employee": "Tildelt medarbejder"
            },
            "personal": {
                "employment_type": "Ansættelsesforhold",
                "first_name": "Fornavn",
                "last_name": "Efternavn",
                "cpr": "CPR-nummer",
                "email": "Email (Bruges i forbindelse med App-service)",
                "company_id": "Virksomhed",
                "phone_private": "Telefonnr. (Bruges i forbindelse med App-service)",
                "phone_cell": "Mobil (Bruges i forbindelse med App-service)",
                "job_title": "Jobtitel",
                "employment_date": "Ansættelsesdato",
                "department": "Afdeling",
                "active": "Aktiv",
                "employee_number": "Medarbejder ID",
                "header": "Personlige",
                "deleted_at": "Slettet"
            },
            "changed": {
                "header": "Seneste ændringer"
            },
            "tooltip": {
                "changes_noted": "Ændringer på medarbejderen er blevet registeret."
            },
            "termination": {
                "termination_date": "Fratrædelsesdato",
                "notice_date": "Sidste arbejdsdag",
                "days_vacation_period": "Afholdes ferie i opsigelsesperiode? Hvis nej indtast 0.",
                "header": "Fratrædelse",
                "customer_employee_id": "Bruger ID"
            },
            "optional": {
                "flex_savings": "Fritvalgsopsparing",
                "days_vacation": "Feriefridage pr. år",
                "allocation_of_vacation_days": "Hvornår tilskrives der feriefridage?",
                "production_unit": "Produktionsenhed",
                "danmarks_statistik": "Danmarks statistik",
                "header": "Tilvalg",
                "health_insurance": "Sundhedsforsikring",
                "has_lunch_arrangement": "Frokostordning",
                "has_free_car": "Fri bil",
                "has_pension": "Pension",
                "has_free_phone": "Fri telefon",
                "kilometer": "Kilometer",
                "diaeter": "Diæter",
                "has_fixed_add_ons": "Fast tillæg"
            },
            "header": "Indtast Medarbejderoplysninger",
            "table": {
                "company_id": "KundeId",
                "checkbox": "Vælg",
                "full_name": "Fulde navn",
                "employment_date": "Ansættelsesdato",
                "termination_date": "Fratrædelsesdato",
                "cards_assigned": "Kort tilknyttet",
                "user": "Bruger",
                "changes": "Ændringer",
                "actions": "Muligheder"
            },
            "save_success": "Kundens oplysninger blev gemt",
            "pbs": {
                "pbs": "Pbs nummer",
                "debtor_group": "Debitorgruppe",
                "accounting_group_id": "Kontogruppe"
            },
            "credit_cards": {
                "header": "Kort",
                "assigned": "Kreditkort",
                "credit_card": "Opret kreditkort"
            },
            "changes": {
                "change_date": "Ændringsdato",
                "employment": "Medarbejderen har skiftet ansættelsestype",
                "previous_values": "Gamle forhold",
                "export": "Eksportér ændringer",
                "no_changes_registered": "Ingen ændring",
                "past_salary": "Der er sket en ændring i medarbejderens månedsløn med tilbagevirkende kraft: {amount} pr. {date}"
            },
            "changed_fields": {
                "flex_savings": "Fritvalgsopsparing",
                "days_vacation": "Feriefridage pr. år",
                "allocation_of_vacation_days": "Hvornår tilskrives der feriefridage?",
                "production_unit": "Produktionsenhed",
                "danmarks_statistik": "Danmarks statistik",
                "header": "Ansættelsesforhold",
                "health_insurance": "Sundhedsforsikring",
                "has_lunch_arrangement": "Frokostordning",
                "has_free_car": "Fri bil",
                "has_pension": "Pension",
                "has_free_phone": "Fri telefon",
                "kilometer": "Kilometer",
                "diaeter": "Diæter",
                "employment_type": "Ansættelsestype",
                "first_name": "Fornavn",
                "last_name": "Efternavn",
                "cpr": "CPR-nummer",
                "email": "Email (Bruges i forbindelse med App-service)",
                "company_id": "Virksomhed",
                "phone_private": "Telefonnr. (Bruges i forbindelse med App-service)",
                "phone_cell": "Mobil (Bruges i forbindelse med App-service)",
                "job_title": "Jobtitel",
                "employment_date": "Ansættelsesdato",
                "department": "Afdeling",
                "active": "Aktiv",
                "employee_number": "Medarbejder ID",
                "deleted_at": "Slettet",
                "termination_date": "Fratrædelsesdato",
                "notice_date": "Sidste arbejdsdag",
                "days_vacation_period": "Afholdes ferie i opsigelsesperiode? Hvis nej indtast 0.",
                "customer_employee_id": "Bruger ID",
                "bank_reg": "Pension - Bank reg.nr.",
                "bank_account": "Pension - Bank kontonr.",
                "swift": "SWIFT",
                "iban": "IBAN",
                "employee_contribution": "Virksomhedspension - medarbejderbidrag",
                "company_contribution": "Virksomhedspension - firmabidrag",
                "pension_company": "Virksomhedspension - Pensionsselskab",
                "type": "Angiv virksomhedspension i",
                "type_option": "Beløb",
                "type_selection": "Kontonr.",
                "type_pbs": "PBS nr.",
                "type_account": "Kontonr.",
                "normal_headline": "Øvrige pensionsordninger",
                "company_headline": "Virksomhedspension",
                "salaried": "Funktionæransat",
                "hourly": "Timelønnet",
                "ceo": "Direktør",
                "b_honorarium_receiver": "B-Honorarmodtager",
                "standard_time": "Arbejdstid pr. uge",
                "salary": "Månedsløn",
                "free_car_monthly": "Bil - Månedligt beløb til beskatning",
                "free_car_file": "Leasingkontrakt",
                "free_car_filename": "Leasingkontrakt",
                "free_car_file_description": "Registreringsnummer",
                "has_health_insurance": "Sundhedsforsikring",
                "hourly_rate": "Timeløn",
                "no_fields": "har ingen felter",
                "with": "med",
                "weekly_working_hours": "Ugentlig arbejdstimer",
                "weekly_working_days": "Ugentlige arbejdsdage",
                "tax_card": "Skattekort",
                "primary_tax_card": "Hovedkort",
                "secondary_tax_card": "Bikort",
                "tax_exemption_card": "Frikort",
                "disco_code": "Disco-kode",
                "dst_time_limited_employment": "Ansættelse i virksomheden",
                "dst_hired_terms": "Ansættelsesvilkår",
                "dst_job_status": "Jobstatus",
                "dst_salary_form": "Aflønningsform",
                "lunch_arrangement_monthly": "Frokostordning - Månedligt beløb",
                "pension": "Pension",
                "health_insurance_monthly": "Sundhedsforsikring - Månedligt beløb",
                "free_car_filepath": "Leasingkontrakt - Filsti",
                "time_monday": "Mandag",
                "time_tuesday": "Tirsdag",
                "time_wednesday": "Onsdag",
                "time_thursday": "Torsdag",
                "time_friday": "Fredag",
                "time_saturday": "Lørdag",
                "time_sunday": "Søndag",
                "address": "Adresse",
                "address2": "Adresse 2",
                "postal_code": "Postnr.",
                "city": "By",
                "country_code": "Land",
                "pnumber": "Pnummner",
                "work_calendar": "Arbejdskalender",
                "has_fixed_add_ons": "Fast tillæg",
                "fixed_add_ons": "Fast tillæg",
                "amount": "Månedsløn",
                "starts_at": "Månedsløn gældende fra"
            },
            "employees": "Medarbejdere",
            "pension_type_changed": "Type af pensionskonto ændret"
        },
        "employees-optionals": {
            "table": {
                "id": "Id",
                "name": "Navn",
                "flex_savings": "Fritvalgsopsparing",
                "days_vacation": "Feriefridage pr. år",
                "production_unit": "Arbejdssted (P-enheder)",
                "danmarks_statistik": "Danmarks statistik",
                "health_insurance": "Sundhedsforsikring",
                "has_free_car": "Fri bil",
                "has_free_phone": "Fri telefon",
                "has_lunch_arrangement": "Frokostordning",
                "has_pension": "Pension",
                "kilometer": "Kilometer",
                "diaeter": "Diæter",
                "has_fixed_add_ons": "Fast tillæg",
                "actions": "Handlinger"
            },
            "page_header": "Tilvalg af felter på medarbejdere",
            "update": "Opdater tilvalg",
            "success": "Venligst vær opmærksom på at hvis du har aktiveret felter, skal disse udfyldes på medarbejdere fra {company_name}"
        },
        "errors": {
            "403": {
                "title": "Adgang nægtet",
                "description": "Du har ikke den nødvendige tilladelse til denne handling. Kontakt support, hvis du mener dette er en fejl."
            },
            "404": {
                "title": "Siden findes ikke",
                "description": "Siden du leder efter, kunne ikke findes."
            }
        },
        "fields-company": {
            "table": {
                "headers": {
                    "company_id": "Id",
                    "name": "Navn",
                    "fields_company": "Felter"
                }
            },
            "page_header": "Lønfelter",
            "columns": {
                "units": "Enheder",
                "rate": "Sats",
                "amount": "Beløb",
                "comment": "Kommentar"
            },
            "extras": {
                "header": "Yderligere oplysninger"
            },
            "groups": {
                "timelon": "Timeløn m.m.",
                "periodisk_tillaeg": "Periodiske tillæg",
                "periodisk_fradrag": "Periodiske fradrag",
                "saerlige_tillaeg": "Særlige tillæg",
                "personalegoder": "Personalegoder",
                "sygdom": "Sygdom",
                "ferie_sh": "Ferie & SH",
                "afspadsering_flex": "Afspadsering & flex",
                "andet_fravaer": "Andet fravær",
                "rettelser": "Rettelser"
            },
            "names": {
                "timelon_1": "Timeløn 1",
                "timelon_2": "Timeløn 2",
                "timelon_3": "Timeløn 3",
                "timelon_4": "Timeløn 4",
                "timelon_5": "Timeløn 5",
                "overtid_1": "Overtid 1",
                "overtid_2": "Overtid 2",
                "overtid_3": "Overtid 3",
                "overtid_4": "Overtid 4",
                "overtid_5": "Overtid 5",
                "dage_ferieoptjening": "Dage ferieoptjening",
                "periodisk_tillaeg_1": "Periodisk tillæg 1",
                "periodisk_tillaeg_2": "Periodisk tillæg 2",
                "periodisk_tillaeg_3": "Periodisk tillæg 3",
                "periodisk_tillaeg_4": "Periodisk tillæg 4",
                "periodisk_tillaeg_5": "Periodisk tillæg 5",
                "periodisk_fradrag_1": "Periodisk fradrag 1",
                "periodisk_fradrag_2": "Periodisk fradrag 2",
                "periodisk_fradrag_3": "Periodisk fradrag 3",
                "periodisk_fradrag_4": "Periodisk fradrag 4",
                "periodisk_fradrag_5": "Periodisk fradrag 5",
                "tantieme": "Tantieme",
                "bestyrelseshonorar": "Bestyrelseshonorar",
                "honorar_bidragspligtigt": "Honorar bidragspligtigt",
                "honorar_bidragsfrit": "Honorar bidragsfrit",
                "bidragsfri_a": "Bidragsfri A",
                "jubilaeumsgratiale": "Jubilæumsgratiale",
                "fratraedelsesgodtgorelse": "Fratrædelsesgodtgørelse",
                "diaeter": "Diæter",
                "diaeter_udl": "Diæter udland",
                "kilometerpenge": "Kilometerpenge",
                "refusion_udlaeg": "Refusion udlæg",
                "ikke_ferieberettiget": "Ikke ferieberettiget",
                "rejsegodtgorelse": "Rejsegodtgørelse",
                "fri_kost": "Fri kost",
                "sygedagpenge": "Sygedagpenge",
                "sygelon": "Sygeløn",
                "sygeferiepenge": "Sygeferiepenge",
                "sygedage": "Sygedage",
                "afholdte_feriedage": "Afholdte feriedage",
                "nettoferiepenge_udb": "Nettoferiepenge udb.",
                "ferietillaeg": "Ferietillæg",
                "sh_forskud": "SH forskud",
                "sh_hensat_not_neg": "SH hensat",
                "fritvalg_udb": "Fritvalg udb.",
                "hensat_afspadsering": "Hensat afspadsering",
                "afholdt_afspadsering": "Afholdt afspadsering",
                "planlagt_flex": "Planlagt flex",
                "faktisk_flex": "Faktisk flex",
                "omsorgsdage_udb": "Omsorgsdage udb.",
                "feriefridage_udb": "Feriefridage udb.",
                "ledighedsdage": "Ledighedsdage",
                "a_skat_fradrag_dage": "A-skat fradrag - dage",
                "atp": "ATP",
                "a_skat": "A-skat",
                "gagereduktion": "Lønreduktion",
                "ret_a_skat_feriepenge": "Ret A-skat - feriepenge",
                "ret_sh_opspar": "Ret SH opspar.",
                "ret_sh_forskud": "Ret SH forskud",
                "ret_sh_fritvalg_opspar": "Ret SH fritvalg opspar.",
                "ret_sh_fritvalg_brugt": "Ret SH fritvalg brugt"
            }
        },
        "forms": {
            "fetch": "Hent",
            "search": "Søg",
            "copied_to_clipboard": "Kopieret til udklipsholder",
            "file_delete": {
                "success": "Filen blev slettet",
                "error": "Filen blev ikke slettet. Venligst prøv igen"
            },
            "send": "Send",
            "open": "Åben",
            "log": "Log",
            "current": "Nuværende",
            "previous_value": "Tidligere",
            "updated_at": "Opdateret",
            "field": "Felt",
            "export": "Eksporter",
            "edit": "Ret",
            "delete": "Slet",
            "restore": "Gendan",
            "deactivate": "Deaktivér",
            "activate": "Aktivér",
            "create": "Opret",
            "update": "Opdater",
            "import": "Importer",
            "load": "Hent",
            "loading": "Henter",
            "number": "Nummer",
            "remove": "Fjern fil",
            "files": "Vælg fil",
            "upload": "Upload",
            "re_upload": "Upload påny",
            "final_upload": "Upload endelige",
            "save": "Gem",
            "save_and_close": "Gem og luk",
            "save_changes": "Gem ændringer",
            "approve": "Godkend",
            "approved": "Godkendt",
            "approved-without-customer": "Godkendt (af Keepers)",
            "uploaded": "Sendt til godkendelse",
            "pending": "Afventer godkendelse",
            "not_uploaded": "Ikke uploadet",
            "upload-final": "Færdiggjort",
            "upload-final-without-customer": "Færdiggjort (af Keepers)",
            "reject": "Afvis",
            "rejected": "Afvist",
            "required": "* Feltet er påkrævet",
            "unauthorized": "Du har ikke tilladelse til denne handling. Venligst kontakt os for nærmere info",
            "file_upload": {
                "success": "{filename} blev uploadet",
                "error": "Filen blev ikke uploadet. Venligst prøv igen"
            },
            "file_import": {
                "success": "Upload til databasen blev gennemført. {insert_no} {type} blev indsat"
            },
            "upload_file": "Upload csv fil",
            "import_file": "Importer fil til databasen",
            "close": "Luk",
            "next": "Næste",
            "previous": "Forrige",
            "update_pw": "Opdater din adgangskode",
            "update_pw_confirm": "Bekræft opdatering af adgangskode",
            "password_current": "Nuværende adgangskode",
            "password_new": "Ny adgangskode",
            "password_new_confirm": "Bekræft ny adgangskode",
            "info": "Info",
            "ok": "Ok",
            "yes_no": [
                "Nej",
                "Ja",
                "Henter"
            ],
            "deleted": "{name} blev slettet",
            "restored": "{name} blev gendannet",
            "deactivated": "{name} blev deaktiveret",
            "activated": "{name} blev aktiveret",
            "general": {
                "success": "Ændringerne blev gemt",
                "error": "Ændringerne blev ikke gemt"
            },
            "export_all_changes_title": "Eksportér alle ændringer",
            "export_no_changes": "Der er ingen ændringer på medarbejderne",
            "from": "Fra",
            "to": "Til",
            "optional_to": "Valgfri",
            "note_change": "Ændringer noteret",
            "additional": "Med flere...",
            "additional_w_num": "Med {number} flere...",
            "generic_error": "Noget gik galt. Fejlen kan skyldes flere ting.",
            "possibly": "Måske følgende:",
            "select_all": "Vælg alle",
            "unselect_all": "Fravælg alle",
            "selected_options": "valgt",
            "company_mismatch": "Noget gik galt, venligst genindlæs siden. Kontakt support hvis problemet fortsætter.",
            "download_template": "Hent skabelon",
            "system_error": "Der opstod en fejl. Prøv venligst igen, og ellers kontakt support.",
            "select_placeholder": "Vælg..",
            "on": "Til",
            "off": "Fra",
            "no_options": "Ingen muligheder",
            "found_no_options": "Intet match fundet",
            "delete_confirmation": {
                "header": "Er du sikker?",
                "description": "Denne handling kan ikke fortrydes. Den valgte data vil blive slettet permanent.",
                "cancel": "Annuller",
                "continue": "Slet",
                "error": "Der opstod en fejl. Prøv venligst igen, og ellers kontakt support.",
                "success": "Data blev slettet"
            },
            "yes": "Ja",
            "no": "Nej",
            "home": "Gå til startside",
            "clear_selection": "Fjern valg",
            "cancel": "Annuller",
            "is_deleted": "slettet",
            "days_in_week": {
                "monday": "Mandag",
                "tuesday": "Tirsdag",
                "wednesday": "Onsdag",
                "thursday": "Torsdag",
                "friday": "Fredag",
                "saturday": "Lørdag",
                "sunday": "Søndag"
            },
            "no_results": "Ingen resultater fundet for {term}"
        },
        "global-search": {
            "placeholder": "Søg",
            "searching": "Søger...",
            "no_results": "Ingen resultater fundet"
        },
        "headers": {
            "confirm-user": "Bekræft oprettelsen",
            "dashboard": "Velkommen {username}",
            "upload-statement": "Upload kontoudtog",
            "voucher": "Bilag",
            "salary-data": {
                "id": "Id",
                "first_name": "Fornavn",
                "last_name": "Efternavn",
                "salary": "Månedsløn",
                "employee_contribution": "Pension medarb. (%)",
                "company_contribution": "Pension arbg. (%)",
                "hourly_hours": "Timer (timelønnede)",
                "hourly_rate": "Sats (timelønned)",
                "b_contribution": "B-honorar",
                "vacation_days": "Afholdte feriedage",
                "employee_outlay": "Udlæg til udbetaling"
            }
        },
        "help": {
            "vouchers": {
                "btn-help-text": "Mangler du hjælp til uploads?"
            }
        },
        "holiday-pay-obligations": {
            "file_import_warning": "Venligst vær opmærksom på at upload overskriver eksisterende værdier med værdierne fra excel filen.",
            "file_headers_needed": "Excel-filen skal indeholde følgende kolonner: Navn, Til import (dage tilgode).",
            "file_formatting_error": "Ugyldigt filformat. Venligst sørg for at uploade i korrekt format med følgende kolonner: Nummer og Til import (dage tilgode).",
            "page_header": "Feriepengeforpligtigelser",
            "create": "Opret forpligtelser",
            "export": "Eksportér til E-conomic",
            "upload": "Upload forpligtelser",
            "missing_employees_text": "OBS! Følgende medarbejdere blev ikke fundet i KC: {employees}",
            "exists_error": "OBS! Der eksisterer allerede en forpligtelse for den givne periode.",
            "incorrect_employment": "OBS! Medarbejderen er ikke funktionæransat.",
            "last_month": "Sidste måned",
            "headers": {
                "id": "Id",
                "year": "År",
                "month": "Måned",
                "num_of_employees": "Antal medarbejdere",
                "file_actions": "Fil",
                "actions": "Åben"
            },
            "entries": {
                "page_header": "Feriepengeforpligtigelsen per medarbejder",
                "headers": {
                    "id": "Id",
                    "name": "Medarbejder",
                    "department": "Afdeling",
                    "days_outstanding": "Dage tilgode",
                    "basic_salary": "Grundløn",
                    "obligation": "Nuværende forpligtelse (DKK)",
                    "last_months_obligation": "Sidste måned",
                    "export_difference": "Difference"
                },
                "tooltip": {
                    "basic_salary": {
                        "salary": "Månedsløn",
                        "fixed_add_ons": "Faste tillæg",
                        "company_pension": "Virksomhedspension",
                        "free_car_monthly": "Fri bil",
                        "free_phone_monthly": "Fri telefon",
                        "company_atp": "Virksomheds-ATP",
                        "health_insurance_monthly": "Sundhedsforsikring"
                    },
                    "obligation": {
                        "basic_salary": "Grundløn",
                        "days_outstanding": "Dage tilgode",
                        "work_days": "Arbejdsdage"
                    }
                },
                "economic": {
                    "pl_account": "Driftskonto",
                    "balance_sheet_account": "Balancekonto",
                    "export": {
                        "title": "Eksportér feriepengeforpligtigelse",
                        "content": "Er du sikker på at du vil eksportere feriepengeforpligtigelserne?",
                        "completed": "E-conomic eksporten blev fuldført."
                    }
                }
            }
        },
        "holidays": {
            "table": {
                "id": "Id",
                "name": "Navn",
                "date": "Dato",
                "actions": "Handlinger"
            },
            "page_header": "Helligdage",
            "delete": {
                "title": "Slet helligdag",
                "content": "Er du sikker på at du vil fjerne denne helligdag?"
            },
            "create": "Opret helligdag",
            "update": "Opdater helligdag",
            "error_date_format": "Fejl i datoformatering. Venligst udfyld med formattet dd/mm/yyyy."
        },
        "kube": {
            "table": {
                "id": "Id",
                "name": "Navn",
                "number": "Nummer",
                "actions": "Handlinger"
            },
            "page_header": "Kube datafelter",
            "delete": {
                "title": "Slet datafelt",
                "content": "Er du sikker på at du vil fjerne dette datafelt?"
            },
            "create": "Opret datafelt",
            "update": "Opdater datafelt",
            "create_kube": "Tilføj datafelt",
            "edit": "Ret datafelt",
            "form": {
                "name": "Navn på datafelt",
                "number": "Nummer på datafelt"
            }
        },
        "mails": {
            "user": {
                "greeting": "Kære {username}",
                "description": "Der er oprettet en bruger til dig i Keepers kundecenteret. Venligst klik på linket nedenunder for at færdiggøre oprettelsen af din bruger ved at indtaste et nyt password.",
                "link": "Klik her for at logge ind"
            },
            "voucher": {
                "headers": {
                    "voucher_no": "Nummer",
                    "text": "Tekst",
                    "amount": "Beløb"
                },
                "subject": "Keepers - Upload af bilag",
                "list_info_txt": "Du mangler at aflevere <strong>{count}</strong> bilag for {company} til Keepers.",
                "deadline": "Venligst vær opmærksom på at deadline er om <strong>{daysToDeadline} dage</strong>, d.",
                "delivery_details": "Manglende bilag afleveres via Keepers' kundecenter.",
                "btn": "Klik her for at uploade bilag",
                "overdue": {
                    "subject": "Keepers - Deadline på manglende bilag overskredet",
                    "deadline": "Venligst vær opmærksom på at deadline er overskredet med <strong>{daysOverdue} dage</strong>. Deadline var d."
                }
            },
            "salary": {
                "delivery_details": "Lønkørsler skal godkendes via Keepers' kundecenter.",
                "subject": "Keepers - Godkendelse af løn",
                "btn": "Klik her for at godkende løn",
                "payroll_details": "Løn for {month}/{year} mangler at blive godkendt"
            },
            "user_created": {
                "subject": "Keepers - Bruger oprettet"
            },
            "resets": {
                "title": "Nulstil adgangskode",
                "msg": "Hej {name}. Du har fortalt os at du har glemt din Keepers adgangskode. Bare rolig, klik knappen nedenfor for at lave et nyt.",
                "expire_text": "NB! Bemærk venligst at dette link kun er gyldigt i fem dage.",
                "subject": "Keepers - Nyt password"
            },
            "success": "Mailen blev sendt",
            "monthly_close_procedures": {
                "subject": "Deadline for måneds-luk procedurer",
                "title": "Husk at der er deadline for måneds-luk procedurer",
                "description": "Det gælder for følgende procedurer:",
                "btn": "Klik her for flere detaljer"
            },
            "mention_in_comment": {
                "subject": "{user} nævnte dig i en kommentar.",
                "greeting": "Hej,",
                "introduction": "{user} nævnte dig i en kommentar på virksomheden {company}:",
                "comment": "{comment}",
                "action": "Gå til dashboard"
            }
        },
        "menu": {
            "settings": "Indstillinger",
            "logout": "Log ud",
            "dashboard": "Dashboard",
            "dashboards": "Dashboards",
            "salary": "Løn",
            "payrolls": "Lønkørsel",
            "payroll_activity_log": "Aktivitetslog",
            "pay_slips": "Lønsedler",
            "salary_setup": "Lønopsætning",
            "employees": "Ansatte",
            "vouchers": "Bilag",
            "voucher": "Manglende bilag",
            "administration": "Administration",
            "companies": "Virksomheder",
            "users": "Brugere",
            "power_bi": "Power BI",
            "system": "System",
            "translations": "Oversættelser",
            "bi_and_companies": "BI Mapping",
            "activities": "Aktiviteter",
            "fields_company": "Lønfelter",
            "power_bi_settings": "BI Mapping",
            "bi_client": "BI Mapping",
            "employees-optionals": "Tilvalgsfelter på medarbejdere",
            "status": "Løn status",
            "holidays": "Helligdage",
            "roles": "Roller",
            "economic-period": "Economic Perioder",
            "work-calendars": "Arbejdskalendere",
            "task-templates": "Opgave Templates",
            "holiday-pay-obligations": "Feriepengeforpligtigelser",
            "help": "Send en mail til support@keepers.dk for at få hjælp",
            "vat": "Moms",
            "bank": "Bank",
            "actuate": "Actuate",
            "support": "Support",
            "customer_employees": "Medarbejdere",
            "outlay": "Outlay",
            "corpay_one": "Corpay One",
            "customer_dashboard": "Kunde Dashboard",
            "employee_dashboard": "Medarbejder Dashboard",
            "pay_setup": "Lønopsætning",
            "credit_cards": "Kreditkort",
            "onboarding": "Onboarding",
            "power_bi_dashboard": "Dashboard",
            "power_bi_mapping": "Mapping",
            "choose_client": "Vælg venligst en kunde"
        },
        "month-picker": {
            "year": "År",
            "prevYear": "Forrige",
            "nextYear": "Næste år",
            "next12Years": "Gå frem 12 år",
            "prev12Years": "Gå tilbage 12 år",
            "nextLabel": "Næste",
            "prevLabel": "Forrige",
            "buttonText": "Åben",
            "jumpYears": "Gå til år",
            "backTo": "Tilbage til",
            "months": [
                "Jan.",
                "Feb.",
                "Mar.",
                "Apr.",
                "Maj",
                "Juni",
                "Juli",
                "Aug.",
                "Sep.",
                "Okt.",
                "Nov.",
                "Dec."
            ]
        },
        "months": {
            "january": "Januar",
            "february": "Februar",
            "march": "Marts",
            "april": "April",
            "may": "Maj",
            "june": "Juni",
            "july": "Juli",
            "august": "August",
            "september": "September",
            "october": "Oktober",
            "november": "November",
            "december": "December"
        },
        "onboarding": {
            "page_header": "Onboarding flow",
            "create_step": "Opret onboarding punkt",
            "edit_step": "Ret onboarding punkt",
            "status_update_failed": "Opdatering af status fejlede",
            "delete": {
                "title": "Er du sikker på du vil slette dette onboarding punkt?"
            },
            "download": {
                "title": "Download bilag ({count})"
            },
            "table": {
                "service": "Service",
                "description": "Beskrivelse",
                "comment": "Kommentar",
                "files": "Bilag",
                "status": "Status"
            },
            "services": {
                "e-conomic": "E-conomic",
                "vat": "Moms",
                "e-income": "eIndkomst",
                "salary": "Løn",
                "bank": "Bank",
                "other": "Øvrige"
            },
            "statuses": {
                "pending": "Afventer svar",
                "completed": "Ja",
                "rejected": "Nej"
            },
            "form": {
                "service": "Service",
                "title": "Service navn",
                "description": "Beskrivelse",
                "description_placeholder": "Ex. Bekræft, at Keepers har fået adgang til..",
                "allow_comments": "Tillad tekstfelt",
                "allow_files": "Tillad upload af bilag"
            },
            "guide": {
                "title": "Onboarding - status på forbindelser"
            },
            "assistant": {
                "title": "Adgange til systemer",
                "completed": "Vi har nu alt hvad vi skal bruge. Du kan nu fortsætte med at bruge kundecenterplatformen."
            },
            "steps_intro": {
                "title": "Hej {name}",
                "subtitle": "Velkommen til Keepers",
                "content": "Vi glæder os over at have dig med og ser frem til at støtte dig med dine regnskabsbehov. For at sikre, at vi kan hjælpe dig bedst muligt, har vi behov for at gennemgå nogle trin, hvor du bekræfter, at vi har de nødvendige adgange til følgende systemer:",
                "button": "Lad os starte"
            },
            "steps_intro_missing": {
                "title": "Hej igen, {name}",
                "subtitle": "Vi mangler adgang til ét eller flere systemer",
                "content": "For at sikre, at vi kan hjælpe dig bedst muligt, har vi brug for at gennemgå de trin, hvor vi mangler noget fra dig. Har du spørgsmål er du naturligvis velkommen til at kontakte os.",
                "skip": "Spring over",
                "button": " Fortsæt"
            },
            "steps": {
                "e-conomic": {
                    "title": "E-conomic",
                    "description": "Bekræft, at du har givet Keepers adgang til din E-conomic konto, så vi kan håndtere dine regnskabsdata.",
                    "accept": [
                        "Ja - Keepers har fået adgang til vores e-conomic konto",
                        "Keepers skal oprette en e-conomic aftale for os"
                    ],
                    "reject": "Nej - Keepers har endnu ikke fået adgang til vores e-conomic konto"
                },
                "vat": {
                    "title": "Moms",
                    "description": "Bekræft, at du har givet Keepers adgang til dine momsinformationer via SKAT, så vi kan hjælpe med momsafregning.",
                    "accept": [
                        "Ja - vi har givet Keepers adgang til vores momsinformationer"
                    ],
                    "reject": "Nej - vi har endnu ikke givet Keepers adgang til vores momsinformationer",
                    "give_access": "Giv Keepers adgang til moms"
                },
                "e-income": {
                    "title": "eIndkomst",
                    "description": "Bekræft, at Keepers har adgang til eIndkomst via SKAT, så vi kan indberette løndata korrekt.",
                    "accept": [
                        "Ja - vi har givet Keepers adgang til vores eIndkomst"
                    ],
                    "reject": "Nej - vi har endnu ikke givet Keepers adgang til eIndkomst",
                    "give_access": "Giv Keepers adgang til eIndkomst via SKAT"
                },
                "salary": {
                    "title": "Løn",
                    "description": "Bekræft, at Keepers har fået adgang til dit lønsystem, så vi kan sikre korrekt lønkørsel og indberetning.",
                    "accept": [
                        "Ja - vi har givet Keepers adgang til vores lønsytem",
                        "Keepers skal oprette et lønsystem for os"
                    ],
                    "reject": "Nej - vi har endnu ikke givet Keepers adgang til vores lønsystem"
                },
                "bank": {
                    "title": "Bank",
                    "description": "Bekræft, at Keepers har de nødvendige tilladelser til at tilgå din bankinformation til bogføring og afstemning.",
                    "accept": [
                        "Ja - vi har givet Keepers adgang til vores bank"
                    ],
                    "reject": "Nej - vi har endnu ikke givet Keepers adgang til vores bank"
                },
                "other": {
                    "title": "Øvrige",
                    "accept": [
                        "Ja - jeg har nu givet Keepers adgang til øvrige"
                    ],
                    "reject": "Nej - jeg har ikke givet Keepers adgang til øvrige",
                    "description": ""
                }
            },
            "steps_completed": {
                "title": "Tak for dine oplysninger!",
                "subtitle": "Du kan nu fortsætte til kundecenterplatformen.",
                "button": "Gå til kundecenter"
            },
            "steps_completed_missing": {
                "title": "Tak for dine oplysninger!",
                "subtitle": "Vi mangler adgang til ét eller flere systemer",
                "content": "Vi har noteret os, at vi fortsat mangler adgang til ét eller flere systemer. Vi vil bede dig om hurtigst muligt at give Keepers de nødvendige adgange. Det drejer sig om følgende:",
                "back": "Tilbage",
                "button": " Gå til kundecenter "
            },
            "next": "Næste",
            "back": "Tilbage",
            "close": "Luk",
            "complete": "Færdiggør",
            "help": "Hjælp",
            "help_title": "Sådan gør du",
            "comment": "Kommentarer",
            "files": "Upload bilag"
        },
        "outlay": {
            "company": {
                "missing_integration": "Kunne ikke finde Outlay for den angivne virksomhed",
                "no_client_selected": "Vælg venligst en kunde"
            },
            "invalid_token": "Koden er ugyldig",
            "validation": {
                "phone": {
                    "required": "Telefonnummer er påkrævet.",
                    "integer": "Telefonnummer er ugyldigt.",
                    "digits": "Telefonnummer skal være på præcist 8 tal og uden mellemrum."
                }
            },
            "connect": {
                "title": "Forbind denne konto med din Outlay konto ved at logge ind.",
                "subtitle": "Du giver herved Keepers tilladelse til at tilgå data fra din Outlay konto.",
                "invalid_credentials": "E-Mail eller adgangskode er forkert."
            }
        },
        "pagination": {
            "previous": "« Forrige",
            "next": "Næste »"
        },
        "passwords": {
            "change": "Skift adgangskode",
            "reset": "Din adgangskode er blevet nulstillet!",
            "sent": "Vi har sendt dig en email med et link til at nulstille!",
            "token": "Nulstil-nøglen til adgangskoden er ugyldig.",
            "throttled": "Vent venlist før du prøver igen.",
            "user": "Vi kan ikke finde en bruger med denne email adresse."
        },
        "pay-slips": {
            "delete": "Slet lønsedler",
            "headers": {
                "upload": "Upload lønsedler"
            },
            "reminder-text": "Send påmindelse",
            "last_sent": "Sidst sendt",
            "comment": "Kommentar",
            "upload_final": "Upload endelig",
            "approve": "Godkend",
            "awaiting_approval": "Afventer din godkendelse",
            "awaiting_other_approver": "Afventer anden godkendelse",
            "upload": "Upload",
            "upload_consent": "Jeg forstår, at jeg er ved at uploade lønsedler for {name}",
            "show_comment": "Vis kommentar",
            "open": "Åben",
            "reject": "Afvis",
            "mail": {
                "headers": {
                    "month": "Måned",
                    "year": "År",
                    "status": "Status",
                    "type": "Type",
                    "num_of_employees": "Antal medarbejdere",
                    "created_at": "Oprettet"
                },
                "subject": "Lønsedler - {company}",
                "btn": "Klik for at godkende lønsedler",
                "info": "Se oversigten for flere oplysninger om indberetninger:",
                "info-approval": "Der er lønsedler til godkendelse for {company} på Keepers.",
                "info-done": "Der er lønsedler, der er færdigbehandlede for {company} på Keepers."
            },
            "response-mail": {
                "title": "Lønsedler for {company}",
                "body": "{user} har {status} lønsedler for {period}",
                "subject": "lønsedler {status} - {company}",
                "btn": "Klik for at gå til oversigten",
                "comment": "med følgende kommentar: {comment}"
            },
            "confirm": {
                "involved": "Det gælder for følgende lønsedler:",
                "confirm": "Er du sikker på at du vil sende en påmindelse?",
                "yes": "Ja",
                "no": "Nej",
                "title": "Send påmindelse på godkendelse af lønsedler",
                "error": "Ingen lønsedler valgt. Venligst vælg en eller flere for at sende påmindelse",
                "last_reminded_at": "Sidst påmindet: ",
                "comment": "Tilføj kommentar"
            },
            "toggle_sent": {
                "title": "Løn sendt til Nets/Bank",
                "confirm": "Er løn sendt til Nets/Bank?",
                "warning": "NB! Lønnen er ikke blevet godkendt endnu! Er du sikker på at du vil omgå godkendelse af lønnen?"
            },
            "no-comments": "Ingen kommentarer"
        },
        "payrolls": {
            "page_header": "Løn",
            "payroll_header": "Lønkørsel",
            "mail": {
                "subject": "{company} - lønkørsel godkendt",
                "body": "{company} har færdiggjort lønkørslen for {period}. Klik på linket forneden for at gå til oversigten, hvor Danløn csv-filen kan downloades.",
                "title": "Lønkørslen godkendt af {user}"
            },
            "filter": "Filtrer",
            "grouping": {
                "open": "Åbne",
                "closed": "Lukkede",
                "all": "Alle"
            },
            "existing": {
                "not_approved": "Ikke godkendt",
                "no_data_fields": "{company} mangler opsætning. Venligst tilføj lønfelter inden oprettelse af lønkørsler.",
                "no_honorarium_fields": "Honorarkørsler kræver at en eller flere lønfelter er valgt: Bestyrelseshonorar, Honorar bidragspligt, Honorar bidragsfrit, Refusion udlæg.",
                "headers": {
                    "id": "Id",
                    "year": "År",
                    "month": "Måned",
                    "type": "Type",
                    "num_of_employees": "Antal medarbejdere",
                    "approved_by": "Løninput godkendt af",
                    "payslip_approved_by": "Lønkørsel godkendt af",
                    "last_reminded_at": "Sidst påmindet",
                    "payslip_actions": "Lønsedler",
                    "actions": "Lønkørsel"
                },
                "data_updated": "Opdateret",
                "data_not_updated": "Ikke Opdateret"
            },
            "edit": {
                "header": "Løn for {company}",
                "unlock": "Fortryd godkendelse",
                "created_success": "Lønkørslen blev oprettet.",
                "created_info_exists": "Lønkørslen for denne måned er allerede oprettet. Du kan nu finde den i tabellen.",
                "updated_success": "Medarbejderens oplysninger blev gemt. Du kan nu finde den i tabellen.",
                "approved": "Lønkørslen blev godkendt",
                "approval_denied": "Lønkørslen blev ikke godkendt da der mangler at opdateres data. Se statusser i tabellen",
                "sent_to_approval": "Lønkørslen blev sendt videre til godkendendelse.",
                "approval_not_sent": "Lønkørslen blev ikke sendt til godkendelse. Venligst tjek at alt er udfyldt korrekt",
                "help-text": "Udfyld nedenstående med præcise oplysninger.",
                "help-text-table": "Udfyld tabellen med præcise oplysninger.",
                "help-text-bold": "Keepers er ikke ansvarlig for rigtigheden af oplysningerne og laver kun sanity checks på kørslen.",
                "awaiting-text": "Lønkørslen er nu sendt videre til Keepers. Når lønnen er bearbejdet vil Keepers uploade lønsedler. Disse kan findes under <a class=\"btn btn-primary btn-flat btn-icon\" href=\"{url}\">\"Lønkørsel\"</a> i menuen \"Løn\".",
                "awaiting-text-table": "Lønkørslen er nu sendt videre til Keepers. Når lønnen er bearbejdet vil Keepers uploade lønsedler. Disse kan findes under \"Lønkørsel\" i menuen \"Løn\".",
                "not_allowed": "Lønkørslen blev ikke slettet fordi løndataen allerede er godkendt.",
                "comment": "* Skriv en kommentar vedrørende løn",
                "blueprint": "Format",
                "sheets": "Lønkørsel",
                "open": "Åben",
                "download": "Eksporter til Danløn",
                "approved_text": "Godkendt",
                "not_approved_text": "Ikke godkendt",
                "comment_from_customer": "Kommentar fra {customer}",
                "approve": "Send løninput til Keepers",
                "send_to_approval": "Send til godkendelse",
                "choose": "Vælg format",
                "create": "Opret Lønkørsel",
                "edit": "Rediger eksisterende Lønkørsel",
                "mintues_short": "min",
                "summary": "Oversigt",
                "months": {
                    "1": "Januar",
                    "2": "Februar",
                    "3": "Marts",
                    "4": "April",
                    "5": "Maj",
                    "6": "Juni",
                    "7": "Juli",
                    "8": "August",
                    "9": "September",
                    "10": "Oktober",
                    "11": "November",
                    "12": "December"
                },
                "upload": "Upload til {format}",
                "download_excel": "Download excel",
                "employee": "Medarbejder:",
                "employee_already_in_payroll": "Medarbejderen er allerede i lønkørslen",
                "no_employee_selected": "Ingen medarbejder valgt. Vælg en medarbejder først.",
                "employee_added_to_payroll": "Medarbejderen blev tilføjet",
                "select_employee_to_add": "Ingen medarbejder valgt. Handlingen blev ikke udført.",
                "modal": {
                    "title": "Månedsløn opdateret",
                    "header": "Lønkørsel",
                    "body_1": "Månedslønnen er blevet opdateret for",
                    "body_2": "vil du opdatere månedslønnen i stamdata på denne medarbejder?",
                    "cancel": "Opdater ikke",
                    "confirm": "Opdater stamdata"
                },
                "lunch_arrangement_modal": {
                    "title": "Frokostordning opdateret",
                    "header": "Frokostordning",
                    "body_1": "Frokostordning er blevet opdateret for",
                    "body_2": "vil du opdatere Frokostordning i stamdata på denne medarbejder?",
                    "cancel": "Opdater ikke",
                    "confirm": "Opdater stamdata"
                },
                "fixed_add_ons_modal": {
                    "title": "Fast tillæg opdateret",
                    "header": "Fast tillæg",
                    "body_1": "Fast tillæg er blevet opdateret for",
                    "body_2": "vil du opdatere fast tillæg i stamdata på denne medarbejder?",
                    "cancel": "Opdater ikke",
                    "confirm": "Opdater stamdata"
                },
                "hourly_rate_modal": {
                    "title": "Timeløn opdateret",
                    "header": "Timeløn",
                    "body_1": "Timeløn er blevet opdateret for",
                    "body_2": "vil du opdatere timeløn i stamdata på denne medarbejder?",
                    "cancel": "Opdater ikke",
                    "confirm": "Opdater stamdata"
                }
            },
            "table": {
                "headers": {
                    "id": "Id",
                    "first_name": "Fornavn",
                    "last_name": "Efternavn",
                    "employment_details": "Ansættelsesdetaljer",
                    "status": "Status",
                    "employee_total": "Medarbejderestimat",
                    "actions": "Handlinger"
                }
            },
            "unlock": {
                "confirm": "Er du sikker?",
                "yes": "Ja",
                "no": "Nej",
                "title": " Fortryd din godkendelse af lønkørslen."
            },
            "summary": {
                "company": "Virksomhed:",
                "data": "data",
                "summary": "oversigt",
                "title": "Lønkørsel",
                "month": "Måned:",
                "year": "År:",
                "approved": "Lønkørslen er godkendt af:",
                "total": "Samlet lønudgift estimeret i perioden:",
                "approved_user_name": "Lønkørslen er godkendt af: {username}",
                "num_of_employees": "Antal medarbejdere:",
                "employees": "medarbejder(e)",
                "updated_at": "Sidst ændret:"
            },
            "no_salary": "<h5>Er ikke tilmeldt løn</h5>",
            "missing_deadline": "Ingen deadline sat",
            "other_buttons": {
                "create_employee": "Opret medarbejder",
                "add_employee_to_payroll": "Tilføj medarbejder til lønkørsel",
                "remove_employee_from_payroll": "Fjern medarbejder fra lønkørsel"
            },
            "add_employee_to_payroll": {
                "header": "Tilføj medarbejdere til lønkørsel",
                "employees": "Medarbejdere",
                "add_employee": "Tilføj medarbejder",
                "select_employee": "Vælg medarbejder"
            },
            "remove_employee_from_payroll": {
                "header": "Fjern medarbejder fra lønkørsel",
                "employees": "Medarbejdere",
                "remove_employee": "Fjern medarbejder",
                "select_employee": "Vælg medarbejder",
                "terminate": "Fratræd medarbejder",
                "employee_not_found": "Ingen medarbejder valgt."
            },
            "no_negative_value": "Værdierne må ikke være negative.",
            "changes": {
                "confirm_1": "Der er ikke indtastet oplysninger for følgende medarbejdere:",
                "confirm_2": "Godkend lønkørsel alligevel?"
            },
            "deleted": {
                "success": "Lønkørsel blev slettet"
            },
            "activity_log": {
                "header": "Payroll log for {company}",
                "actions": {
                    "payroll_created": "Lønkørsel oprettet",
                    "show_payroll": "Vis lønkørsel",
                    "comment_add_to_employee": "Kommentar tilføjet til medarbejder",
                    "payroll_unlocked": "Løninput genåbnet",
                    "payroll_approved": "Løninput sendt til lønbehandling",
                    "payroll_field_changed": "Løninput ændret",
                    "employee_removed": "Medarbejder fjernet fra lønkørsel",
                    "changed_customer_salaried_employee": "Fastansatte medarbejderere ændret"
                },
                "table_headers": [
                    "Dato",
                    "Subjekt",
                    "User",
                    "Description",
                    "Content"
                ],
                "table": {
                    "date": "Dato",
                    "subject": "Subjekt",
                    "user": "User",
                    "description": "Description",
                    "content": "Content"
                }
            }
        },
        "payslips_log": {
            "entries": {
                "page_header": "Lønkørselslog",
                "headers": {
                    "company_name": "Virksomhed",
                    "month": "Måned",
                    "year": "År",
                    "description": "Status",
                    "user_name": "Godkender",
                    "type": "Type",
                    "date_created": "Dato godkendt"
                }
            }
        },
        "permissions": {
            "crud_with_group": {
                "view": "Se {group}",
                "create": "Opret {group}",
                "update": "Opdater {group}",
                "delete": "Slet {group}"
            },
            "crud": {
                "view": "Se",
                "create": "Opret",
                "update": "Opdater",
                "delete": "Slet",
                "crud": "Se-Opret-Opdater-Slet",
                "payslips-log": "Download pdf af lønkørselslog",
                "receive-notifications": "Modtag notifikationer",
                "receive-invite": "Modtag invitation",
                "update-status": "Opdater status",
                "search": "Søg",
                "administrate-cards": "Administrer bilag kort",
                "administrate-fallback": "Administrer bilag fallback",
                "dimensions-view": "Se bilag dimensioner",
                "share-global": "Del visninger"
            },
            "groups": {
                "users": {
                    "name": "Brugere",
                    "description": ""
                },
                "companies": {
                    "name": "Virksomheder",
                    "description": ""
                },
                "roles": {
                    "name": "Roller",
                    "description": ""
                },
                "holidays": {
                    "name": "Helligdage",
                    "description": ""
                },
                "powerbi": {
                    "name": "Power BI",
                    "description": ""
                },
                "powerbi-setup": {
                    "name": "Power BI opsætning",
                    "description": ""
                },
                "translations": {
                    "name": "Oversættelser",
                    "description": ""
                },
                "system": {
                    "name": "System",
                    "description": ""
                },
                "dashboard": {
                    "name": "Dashboard",
                    "description": ""
                },
                "dashboard-admin": {
                    "name": "Dashboard admin",
                    "description": ""
                },
                "vouchers": {
                    "name": "Bilag",
                    "description": ""
                },
                "vouchers-admin": {
                    "name": "Bilag admin",
                    "description": ""
                },
                "vouchers-own": {
                    "name": "Bilag (egne))",
                    "description": ""
                },
                "activities": {
                    "name": "Aktiviteter",
                    "description": ""
                },
                "kube": {
                    "name": "Kube",
                    "description": ""
                },
                "employees": {
                    "name": "Medarbejdere",
                    "description": ""
                },
                "salary-payrolls": {
                    "name": "Løn - Lønkørsler",
                    "description": ""
                },
                "salary-payslips": {
                    "name": "Løn - Lønsedler",
                    "description": ""
                },
                "salary-company": {
                    "name": "Løn - Dataopsætning",
                    "description": ""
                },
                "salary-status": {
                    "name": "Løn - Status",
                    "description": ""
                },
                "keepers-companies": {
                    "name": "Keepers virksomheder",
                    "description": "Adgang til tilknytning af ansatte med Keepers virksomheder"
                },
                "economic-period": {
                    "name": "Economic-perioder",
                    "description": "Status for perioder og år"
                },
                "work-calendars": {
                    "name": "Arbejdskalendere",
                    "description": "Adgang til at tilgå Arbejdskalendere"
                },
                "task-templates": {
                    "name": "Opgave templates",
                    "description": ""
                },
                "vouchers-earlier-releases": {
                    "name": "Bilag: Tidligere frigivelser",
                    "description": "Adgang til at se tidligere bilag"
                },
                "bank-module": {
                    "name": "Bank modul",
                    "description": "Adgang til bank modulet"
                },
                "holiday-pay-obligations": {
                    "name": "Feriepengeforpligtigelser",
                    "description": "Adgang til feriepengeforpligtigelser"
                },
                "employees-import": {
                    "name": "Upload af medarbejdere",
                    "description": "Adgang til at uploade medarbejdere fra excel-fil"
                },
                "employees-admin-import": {
                    "name": "Upload af medarbejdere (Admin)",
                    "description": "Adgang til at uploade medarbejdere fra excel-fil (Admin)"
                },
                "vat": {
                    "name": "Moms",
                    "description": "Adgang til moms modulet"
                },
                "credit-cards": {
                    "name": "Kreditkort",
                    "description": "Adgang til kreditkort"
                },
                "onboarding": {
                    "name": "Onboarding",
                    "description": "Adgang til onboarding"
                },
                "global-search": {
                    "name": "Global søgning",
                    "description": "Adgang til global søgning"
                },
                "outlay": {
                    "name": "Outlay",
                    "description": "Adgang til Outlay login menupunkt"
                },
                "payslips-log": {
                    "name": "Lønkørselslog",
                    "description": "Adgang til lønkørselslog"
                },
                "notifications": {
                    "name": "Notifikationer",
                    "description": ""
                }
            }
        },
        "power_bi": {
            "missing_workspace_id": "Workspace ID mangler!",
            "choose_company": "Vælg firma...",
            "no_power_bi_data_found": "Ingen Power BI data fundet",
            "please_contact_support": "Kontakt support",
            "error_fetching_power_bi_data": "Fejl ved hentning af Power BI data",
            "power_bi_reports": "BI rapporter",
            "create_power_bi_report": "Tilføj BI rapport konto",
            "upload_power_bi_report": "Upload CSV"
        },
        "procedures": {
            "table": {
                "deadline": "Deadline",
                "deadline_text": "Deadline",
                "task": "Opgave",
                "responsible": "Ansvarlig"
            },
            "deadline_text": "{day}. arbejdsdag i mdr."
        },
        "profile": {
            "picture_upload": "Vær venligst opmærksom på at upload af nyt profilbillede overskriver dit gamle.",
            "page_header": "Personlige indstillinger",
            "edit_picture": "Tilføj/Ret Profilbillede",
            "edit_profile": "Ret i dine informationer",
            "save_success": "Dine oplysninger blev opdaterede",
            "upload_failed": "Filen blev ikke slettet eller blev byttet ud...",
            "failed": "Upload fejlede",
            "your_information": "Dine oplysninger",
            "update_password": "Opdater adgangskode",
            "profile_settings": "Profilindstillinger",
            "picture_upload_success": "Profilbillede opdateret",
            "picture_upload_failed": "Profilbillede upload fejlede",
            "picture_upload_error": "Det billede, du prøver at uploade, er for stort. Prøv med et mindre billede."
        },
        "roger-ai": {
            "teams": {
                "missing": "OBS! {kc_name} ikke fundet i Corpay One. Du er derfor logget ind i Corpay One som : roger_name"
            },
            "login": {
                "successful": "Du er nu logget ind i Corpay One",
                "credential_error": "E-Mail adresse eller adgangskode forkert",
                "unknown_error": "Fejl, kontakt venligst support",
                "invalid_token": "Fejl, kontakt venligst support",
                "user_not_approved": "Fejl, bruger er ikke godkendt endnu. Venligst kontakt support hvis fejlen fortsætter."
            },
            "loading-teams": "Loader dine Corpay One data. Dette kan tage et øjeblik."
        },
        "roles": {
            "table": {
                "id": "Id",
                "permissions": "Rettigheder",
                "companies": "Virksomheder",
                "name": "Navn",
                "display_name": "Visningsnavn",
                "description": "Beskrivelse",
                "is_client_text": "Kunderolle",
                "permissions_text": "Rettigheder",
                "companies_text": "Virksomheder",
                "actions": "Handlinger"
            },
            "page_header": "Roller",
            "delete": {
                "title": "Slet rolle",
                "content": "Er du sikker på at du vil fjerne denne rolle? Advarsel! Brugere med denne rolle vil potentielt ikke længere have en rolle."
            },
            "create": "Opret rolle",
            "edit": "Ret rolle",
            "update": "Opdater rolle",
            "select": {
                "permissions": {
                    "placeholder": "Vælg tilladelser",
                    "search_options": {
                        "default": "Søg tilladelser"
                    }
                },
                "companies": {
                    "placeholder": "Vælg Virksomheder",
                    "search_options": {
                        "default": "Søg på virksomhed"
                    }
                },
                "roles": {
                    "placeholder": "Vælg Roller",
                    "search_options": {
                        "default": "Søg Roller"
                    }
                },
                "texts": {
                    "placeholder": "Valg",
                    "search": "Søg",
                    "selectedOptions": " valgt",
                    "selectAll": "Vælg alle",
                    "unselectAll": "Fravælg alle",
                    "noneSelected": "Ingen valgt"
                }
            },
            "general_tab_text": "Generel information",
            "permissions_tab_text": "Rettigheder"
        },
        "salary": {
            "payroll": {
                "not_updated": "Ikke opdateret",
                "month": "Måned",
                "year": "År",
                "type": "Type",
                "employees": "Medarbejdere",
                "updated": "Opdateret",
                "add_comment": "Tilføj kommentar",
                "comment": "Kommentar",
                "remove": "Fjern",
                "change_comment": "Ændrer kommentar",
                "show_comment": "Vis kommentar",
                "comment_success": "Kommentar opdateret",
                "remove_employee": "Fjern medarbejder fra lønkørsel?",
                "are_you_sure": "Er du sikker på at du vil fjerne medarbejderen fra lønkørslen?",
                "yes_and_remove": "Ja, og fratræd",
                "cancel": "Annuller",
                "terminate": "Fratræd",
                "create": "Opret lønkørsel",
                "start": "Opret lønkørsel",
                "table_headings": {
                    "gage_amount": "Månedsløn",
                    "timelon_2_units": "Timer",
                    "timelon_2_rate": "Sats",
                    "timelon_2_amount": "Total timeløn",
                    "timelon_3_units": "Timer 3",
                    "timelon_3_rate": "Sats 3",
                    "timelon_3_amount": "Total løn 3",
                    "timelon_4_units": "Timer 4",
                    "timelon_4_rate": "Sats 4",
                    "timelon_4_amount": "Total løn 4",
                    "timelon_5_units": "Timer 5",
                    "timelon_5_rate": "Sats 5",
                    "timelon_5_amount": "Total løn 5",
                    "overtid_1_units": "Overtid timer",
                    "overtid_1_rate": "Overtid rate",
                    "overtid_1_amount": "Overtid total løn",
                    "overtid_2_units": "Overtid timer 2",
                    "overtid_2_rate": "Overtid rate 2",
                    "overtid_2_amount": "Overtid total løn 2",
                    "overtid_3_units": "Overtid timer 3",
                    "overtid_3_rate": "Overtid rate 3",
                    "overtid_3_amount": "Overtid total løn 3",
                    "overtid_4_units": "Overtid timer 4",
                    "overtid_4_rate": "Overtid rate 4",
                    "overtid_4_amount": "Overtid total løn 4",
                    "overtid_5_units": "Overtid timer 5",
                    "overtid_5_rate": "Overtid rate 5",
                    "overtid_5_amount": "Overtid total løn 5",
                    "periodisk_tillaeg_1_units": "Periodisk tillæg timer",
                    "periodisk_tillaeg_1_rate": "Periodisk tillæg rate",
                    "periodisk_tillaeg_1_amount": "Periodisk tillæg total løn",
                    "periodisk_tillaeg_2_units": "Periodisk tillæg timer 2",
                    "periodisk_tillaeg_2_rate": "Periodisk tillæg rate 2",
                    "periodisk_tillaeg_2_amount": "Periodisk tillæg total løn 2",
                    "periodisk_tillaeg_3_units": "Periodisk tillæg timer 3",
                    "periodisk_tillaeg_3_rate": "Periodisk tillæg rate 3",
                    "periodisk_tillaeg_3_amount": "Periodisk tillæg total løn 3",
                    "periodisk_tillaeg_4_units": "Periodisk tillæg timer 4",
                    "periodisk_tillaeg_4_rate": "Periodisk tillæg rate 4",
                    "periodisk_tillaeg_4_amount": "Periodisk tillæg total løn 4",
                    "periodisk_tillaeg_5_units": "Periodisk tillæg timer 5",
                    "periodisk_tillaeg_5_rate": "Periodisk tillæg rate 5",
                    "periodisk_tillaeg_5_amount": "Periodisk tillæg total løn 5",
                    "periodisk_fradrag_1_amount": "Periodisk fradrag total",
                    "periodisk_fradrag_2_amount": "Periodisk fradrag total 2",
                    "periodisk_fradrag_3_amount": "Periodisk fradrag total 3",
                    "periodisk_fradrag_4_amount": "Periodisk fradrag total 4",
                    "periodisk_fradrag_5_amount": "Periodisk fradrag total 5",
                    "tantieme_amount": "Tantieme",
                    "bestyrelseshonorar_amount": "Bestyrelseshonorar",
                    "honorar_bidragspligtigt_amount": "B-honorar",
                    "honorar_bidragsfrit_amount": "B-honorar (bidragsfrit)",
                    "bidragsfri_a_amount": "Bidragsfri A",
                    "jubilaeumsgratiale_amount": "Jubilæumsgratiale",
                    "fratraedelsesgodtgorelse_amount": "Fratrædelsesgodtgørelse",
                    "diaeter_units": "Diæter enheder",
                    "diaeter_rate": "Diæter rate",
                    "diaeter_amount": "Diæter total",
                    "diaeter_udl_amount": "Diæter, udland",
                    "diaeter_kroner_amount": "Diæter i kr.",
                    "kilometerpenge_units": "Antal KM",
                    "kilometerpenge_amount": "Antal KM",
                    "refusion_udlaeg_amount": "Refusion udlæg",
                    "ikke_ferieberettiget_amount": "Ikke ferieberettiget",
                    "rejsegodtgorelse_units": "Rejsegodtgørelse enheder",
                    "rejsegodtgorelse_rate": "Rejsegodtgørelse rate",
                    "rejsegodtgorelse_amount": "Rejsegodtgørelse total",
                    "fri_kost_units": "Fri kost enheder",
                    "fri_kost_rate": "Fri kost rate",
                    "fri_kost_amount": "Fri kost total",
                    "sygedagpenge_units": "Sygedagpenge enheder",
                    "sygedagpenge_rate": "Sygedagpenge rate",
                    "sygedagpenge_amount": "Sygedagpenge total",
                    "sygelon_units": "Sygeløn enheder",
                    "sygelon_rate": "Sygeløn rate",
                    "sygelon_amount": "Sygeløn total",
                    "sygeferiepenge_amount": "Sygeferiepenge",
                    "sygedage_units": "Sygedage",
                    "afholdte_feriedage_units": "Feriedage",
                    "nettoferiepenge_udb_amount": "Nettoferiepenge udbetalt",
                    "ferietillaeg_amount": "Ferietillæg",
                    "sh_forskud_units": "SH forskud enheder",
                    "sh_forskud_rate": "SH forskud rate",
                    "sh_forskud_amount": "SH forskud total",
                    "sh_hensat_not_neg_amount": "SH hensat",
                    "fritvalg_udb_amount": "Fritvalg udb.",
                    "hensat_afspadsering_units": "Hensat afspadsering enheder",
                    "hensat_afspadsering_amount": "Hensat afspadsering total",
                    "afholdt_afspadsering_units": "Afholdt afspadsering enheder",
                    "afholdt_afspadsering_amount": "Afholdt afspadsering total",
                    "planlagt_flex_units": "Planlagt flex",
                    "faktisk_flex_units": "Faktisk flex",
                    "omsorgsdage_udb_units": "Omsorgsdage udb. enheder",
                    "omsorgsdage_udb_rate": "Omsorgsdage udb. rate",
                    "omsorgsdage_udb_amount": "Omsorgsdage udb. total",
                    "feriefridage_udb_units": "Feriefridage udb. enheder",
                    "feriefridage_udb_rate": "Feriefridage udb. rate",
                    "feriefridage_udb_amount": "Feriefridage udb. total",
                    "ledighedsdage_units": "Ledighedsdage enheder",
                    "ledighedsdage_rate": "Ledighedsdage rate",
                    "ledighedsdage_amount": "Ledighedsdage total",
                    "a_skat_fradrag_dage_units": "A-skat fradrag - dage",
                    "atp_units": "ATP enheder",
                    "atp_amount": "ATP total",
                    "a_skat_amount": "A-skat",
                    "gagereduktion_amount": "Lønreduktion",
                    "ret_a_skat_feriepenge_amount": "Ret A-skat feriepenge",
                    "ret_sh_opspar_amount": "Ret SH opsparet",
                    "ret_sh_forskud_amount": "Ret SH forskud",
                    "ret_sh_fritvalg_opspar_amount": "Ret SH Fritvalg opsparet",
                    "ret_sh_fritvalg_brugt_amount": "Ret SH Fritvalg brugt",
                    "bonus_amount": "Bonus U/pension",
                    "afholdte_feriedage_amount": "Afholdte feriedage",
                    "pension": "Pension",
                    "hourly_rate_amount": "Timeløn",
                    "lunch_arrangement_monthly_amount": "Frokostordning",
                    "fixed_add_ons_monthly_amount": "Fast tillæg",
                    "working_hours_amount": "Timer",
                    "free_car_amount": "Fri bil",
                    "afholdte_feriefridage_amount": "Afholdte feriefridage",
                    "status": "Status",
                    "name": "Navn",
                    "employment_date": "Ansættelsesdato",
                    "termination": "Fratrædelsesdato",
                    "comment": "Kommentar"
                }
            },
            "sheets": {
                "created_success": "Lønsedler blev oprettet. Du kan nu finde den under de eksisterende lønsedler",
                "created_info_exists": "Lønsedler for denne måned er oprettet. Du kan finde den under eksisterende lønsedler",
                "updated_success": "Medarbejderens oplysninger blev gemt.",
                "approved": "Lønsedler blev godkendt",
                "approval_denied": "Lønsedler blev ikke godkendt",
                "sent_to_approval": "Lønsedler blev sendt videre til godkendelse.",
                "approval_not_sent": "Lønsedler blev ikke sendt til godkendendelse. Venligst tjek at alt er udfyldt korrekt",
                "help-text": "Udfyld nedenstående med præcise oplysninger.",
                "help-text-bold": "Keepers er ikke ansvarlig for rigtigheden af oplysningerne og laver kun sanity checks på kørslen.",
                "awaiting-text": "Lønkørslen er nu sendt videre til Keepers. Når lønnen er bearbejdet vil Keepers uploade lønsedler. Disse kan findes under <a class=\"btn btn-primary btn-flat btn-icon\" href=\"{url}\">\"Lønkørsel\"</a> i menuen \"Løn\".",
                "not_allowed": "Kørslen blev ikke slettet fordi dataen allerede er godkendt.",
                "comment": "* Skriv en kommentar vedrørende løn",
                "blueprint": "Format",
                "sheets": "Lønsedler",
                "open": "Åben",
                "download": "Download {format} format",
                "approved_text": "Godkendt",
                "not_approved_text": "Kladde - ikke godkendt",
                "comment_from_customer": "Kommentar fra {customer}",
                "approve": "Godkend lønsedler",
                "send_to_approval": "Send til godkendelse",
                "choose": "Vælg format",
                "create": "Opret Lønkørsler",
                "edit": "Rediger eksisterende lønsedler",
                "employee": "medarbejder",
                "employees": "medarbejdere",
                "employees_plural": "Ingen medarbejdere | {count} medarbejder | {count} medarbejdere",
                "months": {
                    "1": "Januar",
                    "2": "Februar",
                    "3": "Marts",
                    "4": "April",
                    "5": "Maj",
                    "6": "Juni",
                    "7": "Juli",
                    "8": "August",
                    "9": "September",
                    "10": "Oktober",
                    "11": "November",
                    "12": "December"
                },
                "upload": "Upload til {format}",
                "download_excel": "Download excel"
            },
            "excel": {
                "data": "data",
                "summary": "oversigt",
                "title": "Lønoplysningsseddel",
                "month": "Måned:",
                "year": "År:",
                "type": "Type",
                "types": {
                    "primary": "Almindelig",
                    "extra": "Ekstra",
                    "honorarium": "Honorar"
                },
                "email_types": {
                    "primary": "Almindelig kørsel af",
                    "extra": "Ekstra-kørsel af",
                    "honorarium": "Honorar-kørsel af"
                },
                "approved": "Lønoplysningerne er godkendt af:",
                "total": "Samlet lønudgift i perioden:",
                "approved_user_name": "Lønoplysningerne er godkendt af: {username}",
                "templates": {
                    "danlon": {
                        "customer_employees": {
                            "id": "Id",
                            "first_name": "Fornavn",
                            "last_name": "Efternavn"
                        },
                        "customer_salaried_employees": {
                            "salary": "Månedsløn"
                        },
                        "customer_employees_pension_details": {
                            "employee_contribution": "Pension medarb. (%)",
                            "company_contribution": "Pension arbg. (%)"
                        },
                        "hours": "Timer (timelønnede)",
                        "customer_hourly_employees": {
                            "hourly_rate": "Sats (timelønned)"
                        },
                        "b_contribution": "B-honorar",
                        "days_vacation": "Antalt afholdte feriedage i lønperioden (fastansatte)",
                        "outlays": "Udlæg til udbetaling via lønsedler (beløb)"
                    }
                }
            },
            "modal": {
                "title": "Rediger medarbejderløn"
            },
            "page_header": "Lønkørsler",
            "js": {
                "confirm": "Er du sikker på at du vil godkende denne lønkørsel?",
                "yes": "Ja",
                "no": "Nej",
                "delete_title": "Slet lønkørsel",
                "delete_content": "Er du sikker på at du vil slette din lønkørsel? Alle indtastede løndata vil blive slettet og kan ikke genskabes"
            },
            "pay_slips": {
                "header": "Lønsedler",
                "headers": {
                    "id": "Id",
                    "checkbox": "Vælg",
                    "year": "År",
                    "month": "Måned",
                    "type": "Type",
                    "name": "Kunde",
                    "comment": "Kommentar",
                    "status": "Status",
                    "filename": "Filnavn",
                    "last_reminded_at": "Seneste påmindelse",
                    "actions": "Handlinger"
                },
                "approve": {
                    "success": "Lønsedler blev godkendt",
                    "error": "Noget gik galt. Lønsedler blev ikke godkendt"
                },
                "reject": {
                    "alert": "Venligst skriv en detajleret forklaring på hvorfor du ikke kan godkende lønsedlerne",
                    "header": "Afvis lønsedler",
                    "success": "Lønsedler blev afvist",
                    "error": "Noget gik galt. Lønsedler blev ikke afvist"
                },
                "delete": {
                    "success": "Lønsedler blev slettet",
                    "error": "Noget gik galt. Lønsedler blev ikke slettet",
                    "status_error": "Lønsedler ikke slettet. Det er ikke tilladt at slette lønsedler der er godkendte eller færdiggjorte."
                },
                "two_step_approval": {
                    "cannot_approve": "Du kan ikke godkende denne lønseddel før første godkender har godkendt.",
                    "cannot_reject": "Du kan ikke afvise denne lønseddel før første godkender har godkendt."
                },
                "js": {
                    "delete": {
                        "confirm": "Er du sikker på at du vil slette disse lønsedler?",
                        "yes": "Ja",
                        "no": "Nej",
                        "title": "Slet lønsedlerne",
                        "content": "Er du sikker på at du vil slette disse lønsedler? Filen vil blive slettet og kan ikke genskabes."
                    },
                    "approve": {
                        "confirm": "Er du sikker på at du vil godkende disse lønsedler?",
                        "yes": "Ja",
                        "no": "Nej",
                        "title": "Godkend lønsedler",
                        "content": "Er du sikker på at du vil godkende disse lønsedler? Ved at klikke ja erklærer du dig enig i at lønsedlerne er korrekt udfyldt."
                    },
                    "reject": {
                        "confirm": "Er du sikker på at du vil afvise disse lønsedler?",
                        "yes": "Ja",
                        "no": "Nej",
                        "title": "Afvis lønsedlerne",
                        "content": "Er du sikker på at du vil afvise disse lønsedler? Du siger dermed at lønsedlerne ikke er udfyldt korrekt."
                    }
                }
            }
        },
        "status": {
            "bookingcompleted": "Bogføring afsluttet",
            "bookinginprogressind": "Bogføring i gang IND",
            "bookingcompletedind": "Bogføring afsluttet IND",
            "missingdocsreadyind": "Manglende dokumenter klar IND",
            "missingdocsreleased": "Manglende dokumenter frigivet",
            "na": "N/A",
            "notstarted": "Ikke begyndt",
            "periodclosed": "Periode lukket",
            "readyforreview": "Klar til gennemgang",
            "reconstarted": "Recon startet",
            "reconciliationcompleted": "Reconciliation afsluttet",
            "reconciliationstarted": "Reconciliation startet",
            "reportingcompleted": "Rapportering afsluttet",
            "reviewed": "Gennemgået",
            "vatapproved": "Moms godkendt",
            "vatdeclared": "Moms erklæret",
            "vatreadyforreview": "Moms klar til gennemgang",
            "vatrecondone": "Moms genkontrol afsluttet",
            "vatsentforapproval": "Moms sendt til godkendelse",
            "missing": "Mangler",
            "delivered": "Leveret",
            "reconciled": "Afstemt"
        },
        "success-msgs": {
            "voucher-db-save": "Ændringer gemt i database"
        },
        "system": {
            "vat_deadlines": {
                "month": "Frekvens",
                "deadline": "Deadline",
                "settle_period": "Afregningsperiode"
            },
            "dropbox": {
                "access_token": "Access Token",
                "client_identifier": "Client Identifier",
                "root_folder": "Root Folder",
                "success": "Config blev opdateret",
                "folder_path_example": "Folder Sti Eksempel"
            },
            "add_vat_deadline": "Tilføj moms deadline",
            "edit_vat_deadline": "Ret moms deadline",
            "vat_deadlines_header": "Frekvens",
            "settlement_period": "Afregningsperiode",
            "settlement_period_from": "Afregningsperiode - Fra",
            "settlement_period_to": "Afregningsperiode - Til",
            "data_fields": {
                "id": "ID",
                "status_text": "Navn",
                "group": "Datafelt gruppe",
                "color": "Status farvekode"
            },
            "data_field_name": "Navn på datafelt",
            "add_data_field": "Tilføj datafelt",
            "edit_data_field": "Ret datafelt",
            "data_field_approve": "Er datafeltet en status for godkendt eller færdig?",
            "bookkeeping_status": "Bogføring status",
            "report_status": "Rapport status",
            "vat_status": "Moms status",
            "pbc_status": "PBC status",
            "annual_report": "Årsrapport",
            "approved": "Felt er status - færdig eller godkendt",
            "data_fields_title": "Datafelter",
            "dropbox_config_title": "Dropbox config",
            "vat_deadlines_title": "Moms deadlines",
            "data_field_groups": {
                "bookkeeping_status": "Bogføring status",
                "report_status": "Rapport status",
                "vat_status": "Moms status",
                "pbc_status": "PBC status",
                "annual_report": "Årsrapport"
            },
            "data_field_colors": {
                "yellow": "Gul",
                "red": "Rød",
                "green": "Grøn",
                "blue": "Blå",
                "baby_blue": "Lyseblå",
                "bright_yellow": "Lysegul"
            }
        },
        "tables": {
            "actions": "Handlinger",
            "edit": "Ret",
            "create": "Opret",
            "delete": "Slet",
            "view": "Vis",
            "customize_columns": "Tilpas kolonner",
            "reset": "Nulstil",
            "update": "Opdater tabel",
            "filters": {
                "filters": "Filtrering",
                "date_from_to": "Dato (fra/til)",
                "amount_from_to": "Beløb (fra/til)"
            },
            "export": {
                "copy": "Kopier"
            }
        },
        "task-templates": {
            "table": {
                "id": "Id",
                "name": "Navn",
                "description": "Beskrivelse",
                "tasks_string": "Opgaver",
                "actions": "Handlinger"
            },
            "page_header": "Opgave templates",
            "delete": {
                "title": "Slet opgave template",
                "content": "Er du sikker på at du vil fjerne denne opgave template?"
            },
            "create": "Opret opgave template",
            "update": "Opdater opgave template",
            "add_task": "Tilføj opgave til template",
            "title": "Titel",
            "required": "Venligst tilføj minimum én opgave til template",
            "statuses": {
                "Open": "Åben",
                "Finish": "Færdig",
                "Closed": "Lukket",
                "Recurring": "Gentagende"
            },
            "days_in_week": {
                "monday": "Mandag",
                "tuesday": "Tirsdag",
                "wednesday": "Onsdag",
                "thursday": "Torsdag",
                "friday": "Fredag",
                "saturday": "Lørdag",
                "sunday": "Søndag"
            },
            "frequency_options": {
                "0": "Kun en gang",
                "1": "Ugentligt",
                "2": "Hver anden uge",
                "4": "Månedligt"
            },
            "odd_or_even_week_options": {
                "1": "Lige uge",
                "0": "Ulige uge"
            },
            "start_or_end_month_options": {
                "1": "Starten af måneden",
                "0": "Slutningen af måneden"
            },
            "email": {
                "info": "Det her er en påmindelse om at tage handling på følgende opgave:",
                "info_with_name": "Det her er en påmindelse om at tage handling på følgende opgave for {name}:",
                "subject": "Påmindelse for opgave"
            },
            "responsible": "Ansvarlig for opgaven",
            "no_responsible_selected": "OBS! Ingen ansvarlig medarbejder valgt. Hvis du har valgt at sende notifikation vil denne blive sendt til virksomhedsmailen. Hvis ",
            "responsible_selected_first": "OBS! Du har valgt ",
            "responsible_selected_second": ". Hvis du har valgt at sende notifikation vil denne brugers email blive brugt",
            "no_notifications": "Hvis du ikke har valgt at sende notifikationer, vil ingen modtage mails om denne opgave",
            "weekdays": "Ugedage",
            "task": {
                "task": "Opgave",
                "title": "Opgave titel",
                "description": "Opgave beskrivelse",
                "task_notification": "Opgave notifikation",
                "send_notification": "Send notifikation",
                "notification_frequency": "Frekvens",
                "notification_odd_or_even_week": "Lige eller ulige uger",
                "notification_start_or_end_month": "I starten eller slutningen af måneden",
                "status": "Status",
                "title_required": "Opgave titel er påkrævet",
                "description_required": "Opgave beskrivelse er påkrævet"
            },
            "edit_txt": "Ret opgave template",
            "attach": "Vedhæft"
        },
        "termination": {
            "success-msg": "Ændringerne blev gemt. Medarbejderen {name} fratræder pr. {date}",
            "error-msg": "Der gik noget galt. Medarbejderens fratrædelsesoplysninger blev ikke gemt. Venligst kontakt administrator",
            "cancel-success-msg": "Medarbejderen er ikke længere fratrådt",
            "cancel-error-msg": "Der gik noget galt. Medarbejderens fratrædelse er stadig registreret. Venligst kontakt administrator",
            "table": {
                "btns": {
                    "edit": "Ret",
                    "terminated": "Fratrådt",
                    "dismiss": "Fratræd"
                },
                "0": "Ret",
                "1": "Fratræd",
                "2": "Fratrådt"
            },
            "cancel-termination": "Fortryd opsigelsen",
            "js": {
                "confirm_title": "Bekræft fratrædelsen af: ",
                "confirm_msg": "Er du sikker på at du vil gennemføre fratædelsen af: ",
                "yes": "Ja",
                "no": "Nej",
                "undo_title": "Bekræft fortrydelse af fratrædelsen af: ",
                "undo_msg": "Godkend fortrydelsen:",
                "input_title": "Indtast fratrædelsesoplysninger for: "
            }
        },
        "translations": {
            "warning": "Advarsel, oversættelser er ikke synlige før de er blevet eksporteret til app/lang filen, ved brug af enten 'php artisan translation{export}' kommandoen eller udgiv knappen.",
            "finished": "Import færdig, behandlede <strong class=\"counter\">N</strong> emner! Genindlæs denne side for at opdatere grupperne!",
            "search_finished": "Søgning af oversættelser færdig, fandt <strong class=\"counter\">N</strong> emner!",
            "group_finished": "Færdig med oversættelserne af gruppen '{group}'!",
            "append": "Tilføj nye oversættelser",
            "replace": "Erstat eksisterende oversættelser",
            "group_import": "Importér grupper",
            "scan_confirm": "Er du sikker på at du vil scanne din app folder? Alle fundne oversættelsesnøgler vil blive tilføjet til databasen.",
            "search": "Find oversættelser i filer",
            "publish": "Gem oversættelser",
            "publish_confirm": "Er du sikker på at du vil gemme oversættelsesgruppen '{group}'? Dette vil overskrive de eksisterende sprogfiler.",
            "back": "Tilbage",
            "add_no_prefix": "Tilføj 1 nøgle per linje, uden gruppens prefix",
            "result": "Total: {numTranslations}, ændrede: {numChanged}",
            "key": "Nøgle",
            "enter": "Indtast oversættelse",
            "add": "Tilføj nøgler",
            "delete_confirm": "Are you sure you want to delete the translations for '{key}'?",
            "choose_group": "Vælg en gruppe for at vise gruppeoversættelserne. I tilfælde af at der ikke er nogen synlige grupper så tjek at 'migrations' er kørt og oversættelserne er importeret",
            "js": {
                "yes": "Ja",
                "no": "Nej",
                "delete_title": "Slet ",
                "delete_content": "Er du sikker på at du vil slette "
            },
            "status": {
                "active": "Aktiv",
                "inactive": "Inaktiv",
                "paid": "Betalt",
                "unpaid": "Ikke betalt"
            },
            "kr": "Kr.",
            "you": "Dig",
            "deleted": "Slettet"
        },
        "upload": {
            "content": "Vælg eller træk filer ind i uploadzonen",
            "file_size_exceeds": "Filstørrelse overskrider {max_size}",
            "file_type_not_accepted": "Filtype ikke accepteret. Tilladte: {allowed}",
            "max_uploads_exceeded": "Maksimum {max_uploads} filer tilladt",
            "file_already_added": "Fil {file_name} allerede tilføjet",
            "no_upload_route_specified": "Ingen upload url specificeret",
            "upload_failed": "Upload fejlet: {status_text}",
            "upload_failed_general": "Upload fejlet",
            "file_too_large": "Filen er for stor",
            "network_error": "Netværksfejl"
        },
        "user-affiliation": {
            "nav": {
                "header": "Ansatte & Virksomheder"
            },
            "navbar_header": "Ansatte & Virksomheder",
            "employee-groups": "Ansatte & Grupper"
        },
        "user-groups": {
            "actions": {
                "create": "Opret",
                "update": "Opdater",
                "delete": "Slet"
            },
            "delete": {
                "title": "Slet gruppen",
                "content": "NB! Dette sletter gruppen. Handlingen kan ikke fortrydes.<br>Er du sikker på at du vil slette gruppen?",
                "yes": "Slet",
                "no": "Fortryd"
            },
            "form": {
                "labels": {
                    "name": "Gruppe navn",
                    "users": "Gruppemedlemmer"
                },
                "placeholders": {
                    "name": "Løn"
                }
            },
            "groups": "Grupper",
            "employees": "A - Z",
            "user_groups_create": "Opret gruppe",
            "user_groups_edit": "Opdater gruppe",
            "part_of": "En del af",
            "header_users_groups": "Ansatte & Grupper",
            "table_headers": {
                "id": "ID",
                "name": "Navn",
                "users": "Gruppemedlemmer"
            },
            "created": "Gruppe oprettet",
            "updated": "Gruppe opdateret",
            "deleted": "Gruppe slettet"
        },
        "users": {
            "create": {
                "success": "{username} blev oprettet",
                "error": {
                    "no_companies": "Bruger blev ikke oprettet fordi ingen kunder blev valgt",
                    "contact_person": "Kontaktpersonen matcher ikke nogen af de valgte kunder",
                    "company_name": "Kunde ikke fundet: {company}",
                    "role_name": "Rollen findes ikke: {role}",
                    "role_not_assigned": "Rollen {role} er ikke tildelt til {company}"
                }
            },
            "delete": {
                "success": "{username} blev slettet",
                "error": "{username} blev ikke slettet"
            },
            "update": {
                "success": "{username} blev opdateret",
                "error": {
                    "deactivated": "Brugeren er deaktiveret og kan ikke opdateres"
                }
            },
            "reset": {
                "success": "Adgangskode for {username} blev nulstillet og en mail er blevet sendt"
            },
            "personal_tab_text": "Personlige",
            "rights_tab_text": "Roller",
            "table": {
                "company_id": "Kundeid",
                "company_ids": "Kundeid'er",
                "name": "Navn",
                "company": "Virksomhed",
                "companies": "Virksomheder",
                "roles_display_name": "Roller",
                "permissions_display_name": "Beskrivelse",
                "has_accepted_invite": "Accepteret invite",
                "actions": "Handlinger",
                "status": "Status"
            },
            "create_txt": "Opret bruger",
            "edit_txt": "Ret bruger",
            "header": "Brugere",
            "grouping": {
                "active": "Aktive",
                "deactivated": "Inaktive",
                "all": "Alle"
            },
            "filter_label": "Filtrér brugere",
            "form": {
                "name": "Navn",
                "email": "Email",
                "phone": "Telefon",
                "company_id": "Virksomhed",
                "company_ids": "Virksomheder",
                "role_id": "Roller",
                "language": "Sprog",
                "notifications": "Notifikationer",
                "contact_persons": "Kontaktpersoner"
            },
            "language": {
                "da": "Dansk",
                "en": "Engelsk"
            },
            "notifications": {
                "1": "Til",
                "0": "Fra"
            },
            "js": {
                "reset": {
                    "title": "Nulstil adgangskode",
                    "content1": "Er du sikker på at du vil nulstille adgangskode for ",
                    "content2": "? Brugeren vil blive sendt en mail om at adgangskoden er nulstillet.",
                    "content_1": "Er du sikker på at du vil nulstille adgangskode for {name}?",
                    "content_2": "Brugeren vil blive sendt en mail om at adgangskoden er nulstillet.",
                    "success": "Adgangskode for {username} blev nulstillet og en mail er blevet sendt"
                },
                "delete": {
                    "title": "Slet bruger",
                    "content": "Er du sikker på at du vil slette brugeren? Handlingen kan ikke fortrydes."
                },
                "no": "Nej",
                "yes": "Ja",
                "company_id": "Venligst vælg en kunde først"
            },
            "deactivate": {
                "title": "Deaktivér bruger",
                "content": "Er du sikker på at du vil deaktivere brugeren?",
                "yes": "Ja",
                "no": "Nej",
                "success": "Brugeren blev deaktiveret"
            },
            "activate": {
                "title": "Aktivér bruger",
                "content": "Er du sikker på at du vil aktivere brugeren?",
                "yes": "Ja",
                "no": "Nej",
                "success": "Brugeren blev aktiveret"
            },
            "page_header": "Registrerede brugere"
        },
        "validation": {
            "accepted": "{Attribute} skal være accepteret.",
            "accepted_if": "{Attribute} skal være accepteret når {other} er {value}.",
            "active_url": "{Attribute} skal være en valid URL.",
            "after": "{Attribute} skal være en dato efter {date}.",
            "after_or_equal": "{Attribute} skal være en dato efter eller lig med {date}.",
            "alpha": "{Attribute} må kun indeholde bogstaver.",
            "alpha_dash": "{Attribute} må kun indeholde bogstaver, numre, bindestreger og understreger.",
            "alpha_num": "{Attribute} må kun indeholde bogstaver og numre.",
            "array": "{Attribute} skal være an array.",
            "ascii": "{Attribute} må kun indeholde enkelt byte alfanumeriske bogstvaver og symboler.",
            "before": "{Attribute} skal være en dato før {date}.",
            "before_or_equal": "{Attribute} skal være en dato før eller lig med {date}.",
            "between": {
                "array": "{Attribute} skal have mellem {min} og {max} items.",
                "file": "{Attribute} skal være mellem {min} og {max} kilobytes.",
                "numeric": "{Attribute} skal være mellem {min} og {max}.",
                "string": "{Attribute} skal være mellem {min} og {max} karakterer."
            },
            "boolean": "{Attribute} field skal være true or false.",
            "can": "{Attribute} indeholder en unauthoriseret værdi.",
            "confirmed": "{Attribute} confirmation does ikke match.",
            "contains": "{Attribute} mangler en af følgende: {values}.",
            "current_password": "Det nuværende adgangskode er forkert.",
            "date": "{Attribute} skal være en valid dato.",
            "date_equals": "{Attribute} skal være lig {date}.",
            "date_format": "{Attribute} skal passe med formattet {format}.",
            "decimal": "{Attribute} skal have {decimal} decimaler.",
            "declined": "{Attribute} skal være afvist.",
            "declined_if": "{Attribute} skal være afvist når {other} er {value}.",
            "different": "{Attribute} og {o} skal være different.",
            "digits": "{Attribute} skal være {digits} karakterer lang.",
            "digits_between": "{Attribute} skal være mellem {min} og {max} karakterer.",
            "dimensions": "{Attribute} has ugyldigt image dimensions.",
            "distinct": "{Attribute} feltet har en duplekeret værdi.",
            "doesnt_end_with": "{Attribute} må ikke slutte med en af følgende: {values}.",
            "doesnt_start_with": "{Attribute} må ikke starte med en af følgende: {values}.",
            "email": "{Attribute} skal være en valid email adresse.",
            "ends_with": "{Attribute} skal ende med en af følgende værdier: {values}",
            "enum": "Den valgte {attribute} er ikke valid.",
            "exists": "{attribute} er ugyldig.",
            "extensions": "{Attribute} skal være en af følgende extensions: {values}.",
            "file": "{Attribute} skal være en file.",
            "filled": "{Attribute} skal have en værdi.",
            "gt": {
                "array": "{Attribute} skal have mere end {value} items.",
                "file": "{Attribute} skal være større end {value} kilobytes.",
                "numeric": "{Attribute} skal være større end {value}.",
                "string": "{Attribute} skal være større end {value} characters."
            },
            "gte": {
                "array": "{Attribute} skal have {value} items eller mere.",
                "file": "{Attribute} skal være større end eller lig med {value} kilobytes.",
                "numeric": "{Attribute} skal være større end eller lig med {value}.",
                "string": "{Attribute} skal være større end eller lig med {value} characters."
            },
            "hex_color": "{Attribute} skal være en valid hexadecimal farve.",
            "image": "{Attribute} skal være et billede.",
            "in": "{attribute} er ugyldig.",
            "in_array": "{Attribute} skal existere i {other}.",
            "integer": "{Attribute} skal være et tal.",
            "ip": "{Attribute} skal være en valid IP adresse.",
            "ipv4": "{Attribute} skal være en valid IPv4 address.",
            "ipv6": "{Attribute} skal være en valid IPv6 address.",
            "json": "{Attribute} skal være en valid JSON string.",
            "list": "{Attribute} skal være en liste.",
            "lowercase": "{Attribute} skal være med små bogstaver.",
            "lt": {
                "array": "{Attribute} skal have mindre end {value} items.",
                "file": "{Attribute} skal være mindre end {value} kilobytes.",
                "numeric": "{Attribute} skal være mindre end {value}.",
                "string": "{Attribute} skal være mindre end {value} characters."
            },
            "lte": {
                "array": "{Attribute} må ikke have mere end {value} items.",
                "file": "{Attribute} skal være mindre end or equal {value} kilobytes.",
                "numeric": "{Attribute} skal være mindre end or equal {value}.",
                "string": "{Attribute} skal være mindre end or equal {value} characters."
            },
            "mac_address": "{Attribute} skal være en valid MAC address.",
            "max": {
                "array": "{Attribute} må ikke have flere end {max} items.",
                "file": "{Attribute} må ikke være større end {max} kilobytes.",
                "numeric": "{Attribute} må ikke være større end {max}.",
                "string": "{Attribute} må ikke være større end {max} karakterer."
            },
            "max_digits": "{Attribute} må ikke indeholde mere end {max} cifre.",
            "mimes": "{Attribute} skal være en fil af typen: {values}.",
            "mimetypes": "{Attribute} skal være en fil af typen: {values}.",
            "min": {
                "array": "{Attribute} must have minimum {min} items.",
                "file": "{Attribute} skal være minimum {min} kilobytes.",
                "numeric": "{Attribute} skal være minimum {min}.",
                "string": "{Attribute} skal være minimum {min} karakterer."
            },
            "min_digits": "{Attribute} skal have mindst {min} cifre.",
            "missing": "{Attribute} må ikke være tilstede.",
            "missing_if": "{Attribute} må ikke være tilstede når {other} er {value}.",
            "missing_unless": "{Attribute} må ikke være tilstede medmindre {other} er {value}.",
            "missing_with": "{Attribute} må ikke være tilstede når {values} er tilstede.",
            "missing_with_all": "{Attribute} må ikke være tilstede når {values} er tilstede.",
            "multiple_of": "{Attribute} skal kunne gå op i {value}.",
            "not_in": "{attribute} er ugyldigt.",
            "not_regex": "{Attribute} format er et validt format.",
            "numeric": "{Attribute} skal være et nummer.",
            "password": {
                "letters": "{Attribute} skal indeholde mindst et bogstav.",
                "mixed": "{Attribute} skal indeholde mindst et stort og et lille bogstav.",
                "numbers": "{Attribute} skal indeholde mindst et ciffer.",
                "symbols": "{Attribute} skal indeholde mindst et symbol.",
                "uncompromised": "Den givne {Attribute} har været en del af et datalæk. Vælg venligst en anden {attribute}."
            },
            "present": "{Attribute} field skal være tilstede.",
            "present_if": "{Attribute} skal være tilstede hvis {other} er {value}.",
            "present_unless": "{Attribute} skal være tilstede medmindre {other} er {value}.",
            "present_with": "{Attribute} skal være tilstede når {values} er tilstede.",
            "present_with_all": "{Attribute} skal være tilstede når {values} er tilstede.",
            "prohibited": "{Attribute} feltet er forbudt.",
            "prohibited_if": "{Attribute} feltet er forbudt når {other} er {value}.",
            "prohibited_unless": "{Attribute} feltet er forbudt medmindre {other} er i {values}.",
            "prohibits": "{Attribute} feltet forbyder {other} fra at være til stede.",
            "regex": "{Attribute} format er ugyldigt.",
            "required": "{Attribute} skal udfyldes.",
            "required_array_keys": "{Attribute} skal indeholde items for: {values}.",
            "required_if": "{Attribute} skal udfyldes når {o} er {value}.",
            "required_if_accepted": "{Attribute} feltet er påkrævet når {other} er accepteret.",
            "required_if_declined": "{Attribute} feltet er påkrævet når {other} er afvist.",
            "required_unless": "{Attribute} skal udfyldes medmindre {o} er i {values}.",
            "required_with": "{Attribute} skal udfyldes når {values} er til stede.",
            "required_with_all": "{Attribute} skal udfyldes når {values} er til stede.",
            "required_without": "{Attribute} skal udfyldes når {values} ikke er til stede.",
            "required_without_all": "{Attribute} skal udfyldes når ingen af {values} er til stede.",
            "same": "{Attribute} og {o} must match.",
            "size": {
                "array": "{Attribute} skal indeholde {size} items.",
                "file": "{Attribute} skal være {size} kilobytes.",
                "numeric": "{Attribute} skal være {size}.",
                "string": "{Attribute} skal være {size} karakterer."
            },
            "starts_with": "{Attribute} skal starte med en af følgende værdier: {values}.",
            "string": "{Attribute} skal være en tekststreng.",
            "timezone": "{Attribute} skal være en valid tidszone.",
            "unique": "{Attribute} er allerede taget.",
            "uploaded": "{Attribute} blev ikke uploadet.",
            "uppercase": "{Attribute} skal være med store bogstaver.",
            "url": "{Attribute} skal være en gyldig url.",
            "ulid": "{Attribute} skal være et validt ULID.",
            "uuid": "{Attribute} skal være et validt UUID.",
            "custom": {
                "check-recurring-week": "Den valgte frekvens tillader kun en dag",
                "task-weekdays-required": "Opgave ugedage er påkrævet.",
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "customer_employees.email": {
                    "unique": "{attribute} {input} findes allerede."
                },
                "invalid-company-id-role-rule": "Du har ikke tilladelse til at bruge virksomhed {input}.",
                "company_ids": {
                    "company_ids_changed": "Du har ikke tilladelse til at give brugere adgang til virksomheder."
                }
            },
            "attributes": {
                "name": "Navn",
                "phone": "Telefon",
                "holiday_pay_obligations": "feriepengeforpligtigelser",
                "customer_employees.first_name": "Fornavn",
                "customer_employees.last_name": "Efternavn",
                "customer_employees.email": "Email",
                "customer_employees.cpr": "CPR",
                "customer_employees.company_id": "Kunde",
                "customer_employees.employment_date": "Ansættelsesdato",
                "address.main.address": "Adresse",
                "address.main.city": "By",
                "address.main.country_code": "Land",
                "address.main.postal_code": "Postnr",
                "companyPension.company_contribution": "Virksomhedspension - firmabidrag",
                "companyPension.employee_contribution": "Virksomhedspension - medarbejderbidrag",
                "companyPension.pension_company": "Virksomhedspension - pensionsselskab",
                "companyPension.type": "Virksomhedspension - type",
                "pension.company_contribution": "Øvrig pension - medarbejderbidrag",
                "pension.employee_contribution": "Øvrig pension - firmabidrag",
                "pension.pension_company": "Øvrig pension - pensionsselskab",
                "employment": {
                    "employment_type": "Type",
                    "tax_card": "Skattekort",
                    "salary": "Månedsløn",
                    "hourly_rate": "Timeløn",
                    "weekly_working_hours": "Ugentlige arbejdstimer",
                    "weekly_working_days": "Ugentlige arbejdsdage",
                    "lunch_arrangement_monthly": "Frokostordning - Månedligt beløb",
                    "fixed_add_ons_monthly": "Fast tillæg - Månedligt beløb",
                    "disco_code": "Disco-kode",
                    "dst_hired_terms": "Ansættelsesvilkår",
                    "dst_job_status": "Jobstatus",
                    "dst_salary_form": "Aflønningsform",
                    "dst_time_limited_employment": "Ansættelse i virksomheden"
                },
                "obligation": "Forpligtelse",
                "bank.iban": "IBAN",
                "bank.swift": "SWIFT",
                "optional.allocation_of_vacation_days": "Hvornår tilskrives feriefridage?",
                "optional.flex_savings": "Fritvalgsopsparing",
                "optional.days_vacation": "Feriefridage",
                "bank.bank_reg": "Bank reg.nr.",
                "bank.bank_account": "Bank kontonr",
                "Kundenavn": "kundenavn",
                "CvrNummer": "CVR-nummer",
                "Adresse": "adresse",
                "Postnummer": "postnummer",
                "By": "by",
                "Land": "land",
                "Telefon": "telefon",
                "Faxnummer": "faxnummer",
                "Mobilnummer": "mobilnummer",
                "Email": "email",
                "CorpayOneFakturaEmail": "Corpay One faktura email",
                "CorpayOneKvittering": "Corpay One kvittering",
                "KeepersEmail": "Keepers email",
                "services": "tjenester",
                "services.AntalBilagIAftalen": "antal bilag i aftalen",
                "services.BetalingerHosKeepers": "har betainger hos Keepers",
                "services.FastPris": "fast pris",
                "services.PrisFrekvens": "pris frekvens",
                "services.Rapportteringsdeadline": "rapportering deadline",
                "services.LønDeadline": "løndealine",
                "services.UgentligFrekvens": "ugentlig frekvens",
                "services.Momsfrekvens": "momsfrekvens",
                "services.Opdateringsfrekvens": "opdateringsfrekvens",
                "services.GrænseForManglendeBilag": "grænse for manglende bilag",
                "services.CorpayOne": "Corpay One",
                "services.Kube": "Kube",
                "services.Outlay": "Outlay",
                "services.Lønsystem": "lønsystem",
                "services.SkalIKeepersKube": "skal i Keepers Kube",
                "services.EIndkomst": "E-indkomst",
                "services.HarOutsourcing": "har outsourcing",
                "services.HarConsulting": "har consulting",
                "services.HarLøn": "har løn",
                "services.HarRobotics": "har robotics",
                "services.HarPowerBI": "har Power BI",
                "services.KubeID": "Kube ID",
                "roger_invoices": "Corpay One faktura mail",
                "roger_receipts": "Corpay One kviteringer",
                "cvr": "CVR nummer",
                "address": "Adresse",
                "postal_code": "Postnummer",
                "city": "By",
                "country": "Land",
                "contact": "Kontakt",
                "email": "Email",
                "description": "Beskrivelse",
                "display_name": "Visningsnavn",
                "permission_ids": "Tilladelser",
                "role_company_ids": "Virksomheder",
                "is_client": "Er klient",
                "period": "Frekvens",
                "settlement_period": "Afregningsperiode",
                "settlement_period_from": "Afregningsperiode fra",
                "settlement_period_to": "Afregningsperiode til",
                "deadline": "Deadline",
                "data_field_name": "Navn på datafelt",
                "data_field_status": "Datafelt status",
                "data_field_group": "Datafelt gruppe",
                "data_field_color": "Status farvekode",
                "number": "Nummer",
                "role_ids": "Roller",
                "company_ids": "Virksomheder",
                "cashbook_id": "Kasseklade",
                "account": "Konto",
                "comment": "Kommentar",
                "employee_id": "Medarbejder",
                "task_title": "Titel",
                "task_description": "Beskrivelse",
                "weekdays": "Dag i ugen",
                "task_status": "Status",
                "send_notification": "Send notifikation",
                "notification_recurring_week": "Frekvens",
                "responsible_ids": "Ansvarlig for opgaven",
                "procedure_task": "Beskrivelse",
                "procedure_deadline": "Deadline",
                "selected_template": "Template",
                "tasks_deadline": "Deadline"
            },
            "unique_employee_email_for_company": "En medarbejder med denne e-mail er allerede blevet oprettet for denne virksomhed."
        },
        "vat": {
            "actions": "Handlinger",
            "total": "Total",
            "specify_amount": "Indtast beløb",
            "submit": "Indberet til skat",
            "edit": "Ret",
            "company_cvr_not_set": "Virksomhedens CVR nummer ikke sat",
            "submission_successful": "Indberetningen er blevet gemt",
            "submission_failed": "Indberetningen fejlede. Prøv igen.",
            "see_submission": "Se indberetning",
            "show_previous_submission": "Vis seneste indberetning",
            "previous_submission": "Seneste indberetning",
            "vat_deadline_not_found": "Moms deadline ikke fundet",
            "deadline_passed": "Deadlinen for denne momsangivelse er overskredet. Redigering og indberetning er ikke længere tilladt.",
            "group_headers": {
                "danish_sales_and_purchase_vat": "Dansk salgs- og købsmoms",
                "trade_with_abroad": "Handel med udlandet",
                "energy_taxes": "Energiafgifter",
                "vat_total": "Moms i alt"
            },
            "columns": {
                "company": "Virksomhed",
                "company_group": "Koncern",
                "period": "Periode",
                "total_vat": "Total",
                "sales_vat": "Salgsmoms (udgående moms)",
                "purchase_vat": "Købsmoms (indgående moms)",
                "vat_on_purchase_of_goods_abroad": "Moms af varekøb i udlandet",
                "vat_on_purchase_of_services_abroad": "Moms af ydelseskøb i udlandet med omvendt betalingspligt",
                "box_a_goods": "Rubrik A - varer",
                "box_a_services": "Rubrik A - ydelser",
                "box_b_goods_reported": "Rubrik B - varer - indberettes til \"EU-salg uden moms\"",
                "box_b_goods_not_reported": "Rubrik B - varer - Indberettes ikke til \"EU-salg uden moms\"",
                "box_b_services": "Rubrik B - ydelser",
                "box_c": "Rubrik C",
                "oil_and_bottled_gas_tax": "Olie- og flaskegasafgift",
                "electricity_tax": "Elafgift",
                "natural_gas_and_town_gas_tax": "Naturgas- og bygasafgift",
                "coal_tax": "Kulafgift",
                "co2_tax": "CO2-afgift",
                "water_tax": "Vandafgift"
            },
            "column_helpers": {
                "vat_on_purchase_of_goods_abroad": "Både EU og lande uden for EU",
                "box_a_goods": "Værdien uden moms af varekøb i andre EU-lande - EU-erhvervelser",
                "box_a_services": "Værdien uden moms af ydelseskøb i andre EU-lande",
                "box_b_goods_reported": "Værdien af varesalg uden moms til andre EU-lande. Skal også indberettes til systemet \"EU-salg uden moms\"",
                "box_b_goods_not_reported": "Værdien af varesalg uden moms, der ikke skal indberettes til systemet \"EU-salg uden moms\", fx værdien af installation og montage, fjernsalg og nye transportmidler til ikke-momsregistrerede kunder i andre EU-lande",
                "box_b_services": "Værdien af visse ydelsessalg uden moms til andre EU-lande. Skal også indberettes til systemet \"EU-salg uden moms\"",
                "box_c": "Værdien af andre varer og ydelser, der leveres uden afgift her i landet, i andre EU-lande og i lande uden for EU (Gælder også visse salg i Danmark)"
            }
        },
        "vendor": {
            "print": "Print Table"
        },
        "viia": {
            "attach_bank": "Tilknyt bank",
            "select_a_cashbook": "Vælg en kassekladde...",
            "transfer": "Overfør",
            "table": {
                "id": "#",
                "account_name": "Kontonavn",
                "account_number": "Kontonr",
                "currency": "Valuta",
                "balance": "Balance",
                "owner": "Ejer",
                "available": "Tilgængeligt",
                "features": "Features",
                "synced_at": "Opdateret",
                "status": "Status",
                "attach_account": "Tilknyt e-conomic konto",
                "automatic_transfer": "Overfør automatisk til kassekladde"
            },
            "accounts": {
                "page_header": "Konti",
                "attach": "Tilknyt e-conomic konto",
                "account_attached": "Konto tilknyttet",
                "account_detached": "Kontotilknytning fjernet",
                "detach": "Fjern tilknytning",
                "attach_cashbook": "Tilknyt kassekladde",
                "from_date": "Fra dato",
                "pick_daybook": "Vælg kassekladde",
                "automatic_transfer_activated": "Automatisk overførsel af transaktioner til e-conomic er blevet aktiveret.",
                "automatic_transfer_updated": "Automatisk overførsel af transaktioner til e-conomic er blevet opdateret.",
                "automatic_transfer_deactivated": "Automatisk overførsel af transaktioner til e-conomic er blevet deaktiveret."
            },
            "transaction": "Transaktion",
            "transactions": {
                "page_header": "Transaktioner",
                "transfer-economic": "Overfør til kassekladde",
                "cashbook": "Kassekladde",
                "cashbook-type": "Posteringstype",
                "transferredToCashBook": "Overført til kassekladde",
                "assign_bank_account": "For at overføre transaktioner til en kassekladde, skal du først tilknytte en e-conomic bankkonto. Du kan tilknytte din konto på 'Bank' siden.",
                "account_id": "Kontoid",
                "bban_number": "BBan nummer",
                "iban_number": "IBan nummer",
                "state": "Status",
                "search": "Søg i transaktioner",
                "table": {
                    "date": "Dato",
                    "originalText": "Originaltekst",
                    "text": "Tekst",
                    "message": "Besked",
                    "type": "Type",
                    "amount": "Beløb",
                    "balance": "Saldo",
                    "detail": "Detaljer",
                    "transferred_at": "Overført d.",
                    "cashbook": "Kassekladde"
                },
                "inner_table": {
                    "transaction_id": "Transaktionsid",
                    "account_id": "Kontoid",
                    "estimated_balance": "Estimeret saldo",
                    "is_deleted": "Slettet",
                    "api_transaction_id": "API Transaktionsid",
                    "original_text": "Originaltekst",
                    "creation_date": "Oprettelsesdato"
                },
                "transaction_account_id_required": "Venligst vælg en konto",
                "transaction_from_amount": "Fra beløb",
                "transaction_to_amount": "Til beløb",
                "transaction_from_date": "Fra dato",
                "transaction_to_date": "Til dato",
                "transaction_amount_larger_than": "{field} skal være større end {field2}",
                "transaction_filter_required_with": "{field} er påkrævet sammen med {field2}",
                "transaction_filter_invalid_format": "{field} har et ugyldigt format",
                "update_table": "Opdater tabel",
                "estimated": "Estimeret",
                "contra_account_nr_required": "Tilknyt en e-conomic konto før du kan overføre transaktioner til kassekladde."
            },
            "mail-synchronization": {
                "subject": "{company_name} - Login påkrævet for at synkronisere dine bank data i Keepers KC",
                "description": "For at holde dine bank data med transaktioner synkroniseret er det vigtigt at du logger ind via nedenstående link."
            },
            "mail-consent-revoked": {
                "subject": "{company_name} - Dine bank data er ikke længere tilgængelige i Keepers KC",
                "description": "Bemærk at I har fjernet adgangen til jeres bank data i Keepers KC. Hvis dette skyldes en fejl, venligst kontakt Keepers for nærmere information."
            },
            "api-error-messages": {
                "400": "Der er en fejl med forespørgslen til Nordisk API Gateway. Kontakt support for nærmere info.",
                "400-token": "Der er en fejl med forespørgslen til Nordisk API Gateway. Token er udløbet.",
                "401": "Der er en fejl med adgangen til Nordisk API Gateway. Det skyldes formentlig en forkert token eller manglende adgang til kontoen.",
                "500": "Vi oplever pt. fejl med Nordisk API Gateway. Hvis problemet fortsætter kontakt venligst support."
            },
            "cash-book-types": {
                "finance_voucher": "Finansbilag",
                "creditor_payment": "Leverandørbetaling",
                "debtor_payment": "Kundeindbetaling",
                "creditor_invoice": "Leverandørfaktura",
                "manual_debtor_invoice": "Manuel kundefaktura"
            },
            "deactivate": {
                "deactivate_bank_connection": "Deaktiver bankforbindelse",
                "deactivate_bank_connection_success": "Bankforbindelse deaktiveret",
                "deactive_bank_connection_failed": "Noget gik galt. Bankforbindelse kunne ikke deaktiveres. Kontakt support hvis problemet fortsætter.",
                "deactive_bank_connection_no_token": "Ingen valid bank forbindelse fundet. Kontakt support hvis problemet fortsætter.",
                "js": {
                    "deactive_bank_connection_title": "Deaktiver bankforbindelse",
                    "deactive_bank_connection_confirm": "Er du sikker på at du vil deaktivere din bankforbindelse?",
                    "yes": "Ja",
                    "no": "Nej"
                }
            },
            "header": "Registrerede konti",
            "date_selection": "Pr. dato",
            "connect_economic": "Tilknyt e-conomic",
            "economic_account": "E-conomic konto",
            "connect_economic_success": "E-conomic konto tilknyttet",
            "connect_economic_success_no_contra_account": "E-conomic konto tilknytning fjernet",
            "connect_economic_error": "Noget gik galt. E-conomic konto kunne ikke tilknyttes. Kontakt support hvis problemet fortsætter.",
            "kr": "Kr.",
            "transactions_table": {
                "date": "Dato",
                "originalText": "Tekst",
                "message": "Besked",
                "currency": "Valuta",
                "amount": "Beløb (valuta)",
                "transaction_rate": "Transaktionskurs",
                "amount_dkk": "Beløb (DKK)",
                "card": "Kort",
                "by": "Foretaget af",
                "transaction_type": "Transaktionstype",
                "reference": "Reference",
                "balance": "Saldo"
            },
            "transaction_types": {
                "Card": "Kort",
                "BankTransfer": "Bankoverførsel",
                "DirectDebit": "Betalingsservice",
                "PeerToPeer": "Person-til-person",
                "Unknown": "Ukendt",
                "CashWithdrawal": "Kontanthævning"
            },
            "dato_help": "Der kan være afvigelser fra den faktiske saldo i Balance og Tilgængeligt"
        },
        "vouchers-earlier-releases": {
            "header": "Tidligere frigivelser"
        },
        "vouchers": {
            "page_header": "Manglende bilag",
            "account_handle": "Konto",
            "department_handle_number": "Afdeling:",
            "department_handle_number_optional": "Afdeling (valgfri)",
            "project_handle_number_optional": "Projekt (valgfri)",
            "assigned_optional": "Ansvarlig (valgfri)",
            "choose_account": "Venligst vælg en konto",
            "choose_department": "Venligst vælg en afdeling",
            "comment": "Kommentarer til bilag",
            "comment_optional": "Kommentarer til bilag (valgfri)",
            "comment_required": "Kommentarer til bilag (påkrævet)",
            "missing_reason": "Venligst skriv årsagen til manglende bilag",
            "missing-text": "bilag mangler i perioden",
            "lost": "Bilag bortkommet",
            "comment_reason": "<strong>NB!</strong> Venligst vær opmærksom på at vi bruger kontoudtoget til manglende bilag og det er dit ansvar at bilaget ikke er fundet.",
            "comment_reason_lost": "Venligst vær opmærksom på at vi bruger kontoudtoget til manglende bilag og det er dit ansvar at bilaget ikke er fundet.",
            "show": "Vis bilag",
            "press_to_show": "Tryk på miniaturebilledet for at se billede",
            "attachment_number": "Vedhæftning {number}",
            "missing_txt": "Behandl bilag",
            "see": "Se bilag",
            "missing_voucher_text": "Der er ingen manglende bilag i perioden",
            "help_text": "Samlede udgifter uden dokumentation i form af bilag må ikke overstige {voucher_limit} uden samtykke om, at det er jeres eget ansvar og Keepers ikke kan holdes ansvarlig hvis udgifterne ikke er afholdt i virksomhedsøjemed.",
            "close_period": "Afslut perioden",
            "release": "Frigiv bilag fra e-conomic",
            "statement_upload": "Upload kontoudtog",
            "approve_all": "Godkend alle registrerede bilag",
            "clear_list": "Ryd liste",
            "clear_list_done": "Listen ryddet",
            "service_down": "Upload af bilag er desværre ikke muligt pt. Vi arbejder på sagen!",
            "tables": {
                "company_id": "KundeId",
                "select": "Vælg",
                "date": "Dato",
                "voucher": "Bilag",
                "text": "Tekst",
                "amount": "Beløb",
                "account": "Posteringskonto",
                "contra_account": "Modkonto",
                "department": "Afdeling",
                "comment": "Kommentar",
                "actions": "Handlinger"
            },
            "cashbook": {
                "not_found": "Bilagskladden \"Manglende bilag\" blev ikke fundet"
            },
            "release_success": "Bilagene er frigivet. Venligst find dem i tabellen",
            "release_error": "Bilagene blev ikke frigivet. Venligst sikre at kundens e-conomic token er korrekt. Hvis problemet fortsætter, så kontakt support.",
            "close_success": "Listen er blevet ryddet og perioden er afsluttet",
            "close_error": "Der er mangler stadig bilag. Venligst upload kontoudtog for alle konti der er manglende bilag ved",
            "multi_registration": {
                "error": "Et eller flere af bilagene er allerede uploadet tidligere. Kontakt os venligst for nærmere info",
                "success": "{number} nye pdf-filer blev uploadet",
                "no_uploads": "Ingen nye filer blev uploadet",
                "register_success": "Bilagene er blevet registreret"
            },
            "single_registration": {
                "success": "Registreringen blev godkendt.",
                "error": "Registeringen gik galt. Venligst tjek at alt er udfyldt korrekt",
                "exists_error": "Et bilag eksisterer allerede i E-conomic. Kontakt os venligst for nærmere info",
                "entry_not_exists": "Bilaget findes ikke i E-conomic længere. Det anbefales at få opdateret kladden med nuværende bilag. Kontakt os evt. for nærmere info.",
                "pdf_wrong_format": "PDF' har et forkert format. Venligst upload filen igen i et korrekt format og prøv igen.",
                "connection_error": "Der er fejl i forbindelsen.",
                "entry_not_of_type_finans_voucer": "Den valgte konto tager kun imod bilag af typen \"Finansbilag\". Venligst tjek at bilaget er af typen \"Finansbilag\"."
            },
            "js": {
                "period_title": "Afslut perioden",
                "period_content": "Vil du afslutte perioden? Bemærk venligst at hvis du vælger ja, vil kundens bilag blive ryddet fra tabellen.",
                "period_text": "Der er ingen manglende bilag i perioden",
                "clear_list": "Sikker på du vil rydde listen ? Listen kan ikke genoprettes efterfølgende.",
                "clear_list_done": "Listen ryddet",
                "clear_list_title": "Ryd listen",
                "send_to_customer": "Send til kunde?",
                "send_to_customer_content": "Er du sikker på at du vil sende det til kunden?",
                "yes": "Ja",
                "no": "Nej",
                "cancel": "Annuller",
                "missing_voucher_text_default": "Der er ingen manglende bilag i perioden",
                "still_missing": "Der mangler fortsat",
                "vouchers": "bilag",
                "company_id": "Venligst vælg en kunde først",
                "release_title": "Frigiv bilag",
                "release_content": "Vil du frigive bilagene fra e-conomic?",
                "release_alert": "Venligst sæt en dato for deadline",
                "release_label": "Indtast deadline for aflevering",
                "limit_agreement": "Jeg erklærer mig enig i at det er mit ansvar...",
                "limit_amount": "NB! mængden overstiger din grænse på ",
                "limit_alert": "Venligst accepter betingelserne for at uploade",
                "upload_title": "Upload alle pdf-filer",
                "upload_content": "Vil du uploade alle dine bilagsfiler? Bemærk venligst at hvis du vælger ja, vil du ikke kunne ændre i bilagene længere.",
                "account_select": "Vælg venligst konto",
                "department_select": "Vælg evt. afdeling",
                "input_valid": "Alt er udfyldt korrekt",
                "uploads_processing_title": "Igangværende uploads",
                "uploads_processing_content": "Du har igangværende uploads. Er du sikker på at du vil lukke vinduet? Venligst bemærk at alle ændringer vil blive slettet.",
                "approve_title": "Godkend bilag: ",
                "approve_content": "Vil du uploade denne bilagsfil?",
                "approve_alert": "Venligst accepter betingelserne for at uploade"
            },
            "select": {
                "invalid": "Valgte bilag kan ikke slettes. Følgende bilag er ikke gyldige: {body} Venligst fjern markering på dem og prøv igen.",
                "title": "Slet de valgte bilag",
                "content": "Slet bilagene: {body} fra KC og E-conomic. Venligst vær opmærksom på at ændringerne er permanente og at det ikke er muligt at fortryde. Fortsæt alligevel?",
                "delete_confirm": {
                    "description": "Sletter bilagene fra KC kladden og E-conomic."
                },
                "delete_voucher_confirm": "Er du sikker på, at du vil slette bilagsvedhæftningen? Denne handling kan ikke fortrydes.",
                "deleted": {
                    "success": "Bilag blev slettet",
                    "error": "Bilag blev ikke slettet"
                },
                "removed": {
                    "success": "Bilag blev fjernet fra kladden i Kundecenteret",
                    "error": "Bilag blev ikke fjernet."
                },
                "ignored": {
                    "success": "Bilag blev ignoreret i KC",
                    "error": "Blev ikke ignorereret i KC"
                },
                "closed": {
                    "success": "Bilag blev lukket i KC",
                    "error": "Blev ikke lukket i KC"
                },
                "mark_as_missing_responses": {
                    "success": "Bilag blev markeret som bortkommet",
                    "error": "Bilag blev ikke markeret som bortkommet",
                    "comment_min": "Kommentaren skal være mindst 10 tegn."
                },
                "mark_as_missing_response": {
                    "success": "Bilag blev markeret som bortkommet",
                    "error": "Bilag blev ikke markeret som bortkommet",
                    "comment_min": "Kommentaren skal være mindst 10 tegn."
                },
                "other_options": "Bulk handlinger",
                "delete": "Slet valgte bilag fra KC og E-conomic",
                "close": "Afslut valgte bilag i KC kladden",
                "approve": "Godkend valgte bilag",
                "remove": "Fjern valgte bilag fra KC kladden",
                "ignore": "Ignorer valgte bilag i KC kladden",
                "mark_as_missing": "Markér valgte bilag som bortkommet",
                "assign_assigned": "Tildel ansvarlig(e) til valgte bilag",
                "assign_project": "Tildel projekt til valgte bilag",
                "yes": "Ja",
                "no": "Nej",
                "upload": {
                    "invalid": "Valgte bilag kan ikke godkendes. Følgende bilag er ikke gyldige: {body} Venligst fjern markering på dem og prøv igen.",
                    "title": "Godkend de valgte bilag",
                    "content": "Godkend bilagene: {body} fra KC og E-conomic. ",
                    "description": "Bemærk venligst at hvis du vælger ja, vil du ikke kunne ændre i bilagene længere. Bilagene vil blive uploadet til E-conomic.",
                    "invalid_header": "Valgte bilag kan ikke godkendes",
                    "invalid_description": "Følgende bilag er ikke gyldige: {body}. Venligst fjern markering på dem og prøv igen."
                },
                "remove_confirm": {
                    "invalid": "Valgte bilag kan ikke fjernes. Følgende bilag er ikke gyldige: {body} Venligst fjern markering på dem og prøv igen.",
                    "title": "Fjern de valgte bilag fra Kundecenteret",
                    "content": "Fjern bilagene: {body} fra den nuværende kladde.",
                    "description": "Denne handling kan bl.a. bruges hvis bilag ikke eksisterer i E-conomic længere. Den fjerner bilaget fra KC kladden.",
                    "invalid_header": "Valgte bilag kan ikke fjernes",
                    "invalid_description": "Følgende bilag er ikke gyldige: {body}. Venligst fjern markering på dem og prøv igen."
                },
                "ignore_confirm": {
                    "invalid": "Valgte bilag kan ikke ignoreres. Følgende bilag er ikke gyldige: {body} Venligst fjern markering på dem og prøv igen.",
                    "title": "Ignorer de valgte bilag fra Kundecenteret",
                    "content": "Ignorer bilagene: {body} fra den nuværende kladde.",
                    "description": "Denne handling kan bl.a. bruges hvis der allerede eksisterer et bilag på posteringerne i E-conomic. Hvis du trykker ja vil valgte konto og afdeling gemmes i E-conomic, hvorefter det er eget ansvar at uploade bilaget fra E-conomic til Dropbox. Vær desuden opmærksom på at du ikke kan fortryde denne handling.",
                    "invalid_header": "Valgte bilag kan ikke ignoreres",
                    "invalid_description": "Følgende bilag er ikke gyldige: {body}. Venligst fjern markering på dem og prøv igen."
                },
                "close_confirm": {
                    "invalid": "Valgte bilag kan ikke afsluttes. Følgende bilag er ikke gyldige: {body} Venligst fjern markering på dem og prøv igen.",
                    "title": "Afslut de valgte bilag fra Kundecenteret",
                    "content": "Afslut bilagene: {body} fra den nuværende kladde.",
                    "description": "Denne handling kan bl.a. bruges til at mindske listen af tilbageværende bilag, så den er mere overskuelig da den lukker bilaget i perioden ved at fjerne den fra listen.",
                    "invalid_header": "Valgte bilag kan ikke afsluttes",
                    "invalid_description": "Følgende bilag er ikke gyldige: {body}. Venligst fjern markering på dem og prøv igen."
                },
                "mark_as_missing_confirm": {
                    "invalid": "Valgte bilag kan ikke markeres som bortkommet. Følgende bilag er ikke gyldige: {body} Venligst fjern markering på dem og prøv igen.",
                    "title": "Markér de valgte bilag som bortkommet",
                    "content": "Markér bilagene som bortkommet: {body} fra den nuværende kladde.",
                    "description": "Denne handling kan bør kun bruges til at markere de valgte bilag som bortkommet, hvis årsagen til at de er bortkommet er den samme og kontonummer er det samme!",
                    "invalid_header": "Valgte bilag kan ikke markeres som bortkommet",
                    "invalid_description": "Følgende bilag er ikke gyldige: {body}. Venligst fjern markering på dem og prøv igen."
                },
                "assign_confirm": {
                    "title": "Tildel ansvarlig",
                    "content": "{amount} valgte bilag",
                    "assigned": "Tildelt",
                    "success": "Bilag blev tildelt",
                    "error": "Bilag blev ikke tildelt",
                    "assignees_required": "Vælg mindst én medarbejder eller bruger"
                },
                "project_confirm": {
                    "title": "Tildel projekt",
                    "content": "{amount} valgte bilag",
                    "project": "Projekt",
                    "success": "Bilag blev tildelt",
                    "error": "Bilag blev ikke tildelt"
                }
            },
            "current_vouchers": {
                "header": "Aktuelle bilag"
            },
            "earlier_releases": {
                "header": "Tidligere frigivelser"
            },
            "economic_connection_down": "Forbindelsen til E-conomic er nede. Prøv venligst igen senere, eller kontakt support for nærmere info.",
            "missing_economic_token": "Handlingen kunne ikke udføres. Integrationen til E-conomic er muligvis blevet slettet.",
            "missing_account": "Det ser ud til at den valgte konto ikke eksisterer i E-conomic. Venligst vælg en anden konto eller kontakt support for nærmere info.",
            "missing_entry": "Det valgte bilag eksisterer ikke i E-conomic.",
            "period_barred": "Det valgte bilag ligger i en spærret periode. For at godkende bilaget skal perioden først åbnes igen.",
            "delete_failed": "Opdatering af bilaget i E-conomic fejlede. Prøv venligst igen senere, eller kontakt support for nærmere info.",
            "recreate_failed": "Opdatering af bilaget i E-conomic fejlede. Dette har resulteret i at bilaget er blevet slettet i E-conomic. Systemet vil inden for 5 minutter forsøge at gendanne bilaget. Kontakt venligst support hvis dette ikke sker.",
            "file_too_big": "Filen er for stor. Maks fil størrelse er 8MB.",
            "delete": "Slet bilag",
            "help": {
                "title": "Mangler du hjælp til uploads?",
                "content": "Samlede udgifter uden dokumentation i form af bilag må ikke overstige uden samtykke om, at det er jeres eget ansvar og Keepers ikke kan holdes ansvarlig hvis udgifterne ikke er afholdt i virksomhedsøjemed."
            },
            "voucher_table": {
                "date": "Dato",
                "voucher": "Bilag",
                "text": "Tekst",
                "amount": "Beløb",
                "account": "Posteringskonto",
                "contra_account": "Modkonto/Udgiftstype",
                "assigned_to": "Ansvarlig",
                "project": "Projekt",
                "card": "Kort",
                "department": "Afdeling",
                "comment": "Kommentar"
            },
            "administrate": {
                "title": "Administrer",
                "subtitle": "Administrer automatisk tildeling af manglende bilag ud fra kreditkort",
                "administrate_cards": "Administrer kort",
                "search": "Søg efter kreditkort",
                "general": "Generelt",
                "fallback": "Fallback personer",
                "voucher_assignment_rule": "AI tildeling af fallback personer",
                "voucher_assignment_rules_prompt": "Beskrivelse",
                "add_voucher_assignment_rule": "Tilføj AI fallback",
                "success": "Tildeling af bilag er blevet opdateret",
                "error": "Der sket en fejl ved opdatering af tildeling af bilag",
                "validation_errors": {
                    "voucher_assignment_rules_prompt_required": "Beskrivelse er påkrævet",
                    "voucher_assignment_rules_user_ids_required": "Medarbejder(e) er påkrævet",
                    "voucher_assignment_rules_user_ids_exists": "Medarbejder(e) eksisterer ikke",
                    "voucher_assignment_rules_employee_ids_exists": "Medarbejder(e) eksisterer ikke",
                    "fallback_employee_ids_array": "Fallback medarbejder(e) skal være en array",
                    "fallback_employee_ids_exists": "Fallback medarbejder(e) eksisterer ikke",
                    "fallback_user_ids_array": "Fallback bruger(e) skal være en array",
                    "fallback_user_ids_exists": "Fallback bruger(e) eksisterer ikke",
                    "cards_id_exists": "Kort eksisterer ikke"
                },
                "no_cards": "Virksomheden har ingen kreditkort tilknyttet"
            },
            "release_all": {
                "title": "Vil du frigive bilagene fra e-conomic?",
                "content": "Vil du sende bilagene til kunden?",
                "send_to_customer": "Send til kunde",
                "release_label": "Indtast deadline for aflevering",
                "button": "Frigiv bilag"
            },
            "upload_statement": "Upload bilag (max {max_uploads} filer)",
            "assigned_by": {
                "credit_card": "Fandt matchende kreditkort",
                "transaction": "Transaktion matchet via dato og beløb",
                "api": "Matchet via AI fallback {fallback}",
                "fallback": "Fallback medarbejder(e)"
            }
        },
        "work-calendars": {
            "table": {
                "id": "Id",
                "name": "Navn",
                "actions": "Handlinger"
            },
            "page_header": "Arbejdskalendere",
            "delete": {
                "title": "Slet arbejdskalender",
                "content": "Er du sikker på at du vil fjerne denne arbejdskalender?"
            },
            "create": "Opret arbejdskalender",
            "update": "Opdater arbejdskalender"
        }
    },
    "en": {
        "activities": {
            "page_header": "Activities",
            "handled_cpr": "Handled Cpr number",
            "count": "Count",
            "expand": "Expand All",
            "collapse": "Collapse All",
            "logged_out": "Logged out",
            "table": {
                "id": "Id",
                "by": "Done by user",
                "description": "Description",
                "action": "Action",
                "for": "Done on",
                "content": "Content",
                "created_column": "Date"
            },
            "filterTable": {
                "by": "Done by user",
                "description": "Description",
                "action": "Action",
                "for": "Done on"
            },
            "action": {
                "downloaded": "Downloaded Danlon file",
                "displayed": "Displayed employee",
                "updated": "Updated employee",
                "created": "Created employee",
                "upload-final": "Upload final payroll",
                "displayed_cpr_number": "Displayed cpr number",
                "display_changes": "Displayed changes on employee",
                "uploaded_voucher_statement": "Voucher statement uploaded",
                "updated_voucher": "Voucher updated",
                "approved_voucher": "Voucher approved",
                "deleted_voucher_attachment": "Voucher attachment deleted",
                "v2": {
                    "index": "View dashboard",
                    "search": "Global search",
                    "powerbi": {
                        "index": "View Power BI",
                        "get": "Get Power BI data",
                        "dashboard": {
                            "index": "View Power BI"
                        },
                        "setup": {
                            "index": "View BI Mapping",
                            "table": "Get BI Mapping table data",
                            "get": "Get BI Mapping data",
                            "store": "BI report account created",
                            "update": "BI report account updated",
                            "destroy": "BI report account deleted",
                            "upload": "BI report account CSV uploaded"
                        }
                    },
                    "kube": {
                        "index": "View Kube table",
                        "table": "Get Kube table data",
                        "options": "Get Kube data",
                        "store": "Kube data field created",
                        "update": "Kube data field updated",
                        "destroy": "Kube data field deleted"
                    },
                    "dashboard": {
                        "table": "Get dashboard data",
                        "index": "View dashboard",
                        "selected": {
                            "set": "Set selected dashboard"
                        },
                        "status": {
                            "update": "Dashboard status updated",
                            "bulk-update": "Dashboard status bulk updated"
                        },
                        "reload-on-demand": {
                            "update": "Dashboard reload-on-demand updated"
                        },
                        "comments": "View company comments",
                        "comments.store": "Company comment created",
                        "vat": {
                            "update": "Dashboard VAT updated",
                            "bulk-update": "Dashboard VAT bulk updated"
                        },
                        "customer": {
                            "index": "View customer dashboard"
                        },
                        "tasks": {
                            "get": "Get company tasks",
                            "create": "Task created",
                            "update": "Task updated",
                            "destroy": "Task deleted",
                            "delete": "Task deleted",
                            "employees": "Get employees for task",
                            "vouchers": {
                                "get": "Get vouchers for task",
                                "create": "Voucher for task created",
                                "update": "Voucher for task updated",
                                "destroy": "Voucher for task deleted",
                                "delete": "Voucher for task deleted"
                            },
                            "create.from-template": "Tasks created from template"
                        },
                        "procedures": {
                            "get": "Get company procedures",
                            "create": "Procedure created",
                            "update": "Procedure updated",
                            "destroy": "Procedure deleted",
                            "delete": "Procedure deleted",
                            "employees": {
                                "get": "Get employees for procedure"
                            }
                        },
                        "procedure": {
                            "employees": {
                                "get": "Get employees for procedure"
                            }
                        },
                        "view-options": {
                            "toggle-active": "Toggle active dashboard view",
                            "store": "Dashboard view created",
                            "update": "Dashboard view updated",
                            "destroy": "Dashboard view deleted"
                        }
                    },
                    "users": {
                        "table": "Get users table data",
                        "index": "View users table",
                        "store": "User created",
                        "update": "User updated",
                        "destroy": "User deleted",
                        "deactivate": "User deactivated",
                        "activate": "User activated",
                        "reset-password": "User password reset",
                        "roles": {
                            "options": "Get roles for select menu"
                        }
                    },
                    "user": {
                        "profile-picture": {
                            "uploaded": "Profile picture uploaded",
                            "upload": "Upload profile picture",
                            "delete": "Delete profile picture"
                        },
                        "select-month": "Changed displayed month",
                        "get": "Get user"
                    },
                    "roles": {
                        "table": "Get roles table data",
                        "index": "View roles",
                        "store": "Role created",
                        "update": "Role updated",
                        "destroy": "Role deleted",
                        "permissions": {
                            "options": "Get permissions for select menu"
                        }
                    },
                    "user-companies": {
                        "table": "Get employees & companies table data",
                        "index": "View employees & companies",
                        "update": "Keepers employees for company updated"
                    },
                    "user-groups": {
                        "table": "Get employees & groups table data",
                        "index": "View employees & groups table",
                        "store": "Keepers employee group created",
                        "update": "Keepers employee group updated",
                        "destroy": "Keepers employee group deleted"
                    },
                    "voucher": {
                        "store": "Voucher processed",
                        "upload": {
                            "specific": "Single voucher uploaded",
                            "selection": "Selected vouchers uploaded",
                            "all": "All vouchers uploaded"
                        },
                        "admin": {
                            "contra-accounts": {
                                "get": "Get contra accounts"
                            },
                            "statement": {
                                "register": "Voucher statement registered",
                                "upload": "Voucher statement uploaded",
                                "delete": "Voucher statement deleted"
                            },
                            "close-period": "Close period",
                            "release": {
                                "all": "Release vouchers"
                            },
                            "ignore": {
                                "selection": "Ignore selected vouchers"
                            },
                            "remove": {
                                "selection": "Remove selected vouchers"
                            },
                            "close": {
                                "selection": "Close selected vouchers"
                            },
                            "mark-as-missing": {
                                "selection": "Mark selected vouchers as missing"
                            },
                            "attachment": {
                                "delete": "Voucher attachment deleted"
                            },
                            "assign": {
                                "selection": "Assign selected vouchers"
                            },
                            "clear-list": "Clear voucher list"
                        },
                        "files": {
                            "info": "Get voucher files info"
                        },
                        "file": {
                            "download": "Download voucher file"
                        },
                        "statement": {
                            "file": {
                                "download": "Download voucher statement file"
                            }
                        },
                        "approved-accounts": {
                            "get": "Get approved e-conomic accounts"
                        },
                        "departments": {
                            "get": "Get departments"
                        },
                        "accounts": {
                            "all": "Get all company accounts"
                        }
                    },
                    "vouchers": {
                        "table": "Get vouchers table data",
                        "index": "View vouchers table",
                        "approved-accounts": {
                            "get": "Get approved e-conomic accounts"
                        },
                        "files": {
                            "info": "Get voucher files info"
                        },
                        "departments": {
                            "get": "Get departments"
                        },
                        "departments-data": "Get departments data",
                        "earlier-releases": {
                            "index": "View previously released vouchers",
                            "table": "Get previously released vouchers table data",
                            "get": "Get previously released vouchers data",
                            "load-table": "Get previously released vouchers"
                        }
                    },
                    "companies": {
                        "table": "Get companies table data",
                        "index": "View companies",
                        "get": "Get companies",
                        "update": "Company updated",
                        "store": "Company created",
                        "destroy": "Company deleted",
                        "options": {
                            "get": "Get companies for select menu"
                        },
                        "keepers-employees": {
                            "get": "Get Keepers employees data"
                        },
                        "all-keepers-employees": {
                            "index": "View Keepers employees",
                            "get": "Get Keepers employees data"
                        },
                        "voucher-assignment": {
                            "edit": "View voucher administration",
                            "update": "Voucher employees updated"
                        },
                        "all-company-clients": {
                            "get": "Get company employees"
                        },
                        "with-group": {
                            "get": "Get companies with corporate group"
                        }
                    },
                    "company": {
                        "table": "Get company data",
                        "index": "View company",
                        "keepers-employees": {
                            "get": "Get Keepers employees data for company"
                        }
                    },
                    "company-groups": {
                        "index": "View companies & corporate group",
                        "table": "Get companies & corporate group table data",
                        "get": "Get company groups data",
                        "store": "Corporate group created",
                        "update": "Corporate group updated",
                        "destroy": "Corporate group deleted"
                    },
                    "credit-cards": {
                        "index": "View credit cards",
                        "table": "Get credit cards table data",
                        "get": "Get credit cards data",
                        "update": "Credit card updated",
                        "store": "Credit card created",
                        "destroy": "Credit card deleted"
                    },
                    "bank": {
                        "table": "Get bank table data",
                        "index": "View bank table",
                        "company-accounts": "Get company accounts",
                        "transactions": {
                            "all": "Get bank transactions",
                            "journals": "Get journals",
                            "cash-book-types": "Get cash book types"
                        }
                    },
                    "salary": {
                        "index": "View salary",
                        "employees": {
                            "index": "View employees",
                            "table": "Get employees table data",
                            "get": "Get employees data",
                            "store": "Employee created",
                            "edit": "View edit employee",
                            "update": "Employee updated",
                            "destroy": "Employee deleted",
                            "companies-for-select-data": "Get companies for select menu",
                            "for-current-company": "Get employees for company",
                            "departments-data": "Get departments for employees",
                            "unmasked-social-security-number": "Display CPR number",
                            "import-template": "Get employee import template",
                            "import": "Employee import from file",
                            "danmarks-statistik-data": "Get Statistics Denmark data"
                        },
                        "employee": {
                            "changes": {
                                "show": "View employee changes",
                                "noted": "Employee changes noted",
                                "export": "Export employee changes"
                            },
                            "terminate": {
                                "create": "Employee terminated"
                            }
                        },
                        "employees-optionals": {
                            "index": "View optional fields",
                            "table": "Get optional fields table data",
                            "get": "Get optional fields data",
                            "store": "Optional field created",
                            "update": "Optional field updated",
                            "destroy": "Optional field deleted"
                        },
                        "payrolls": {
                            "index": "View payroll runs",
                            "table": "Get payroll runs table data",
                            "get": "Get payroll runs data",
                            "show": "View payroll run",
                            "approve": "Payroll run approved",
                            "store": "Payroll run created",
                            "update": "Payroll run updated",
                            "destroy": "Payroll run deleted"
                        },
                        "payroll": {
                            "index": "View payroll run",
                            "table": "Get payroll run data",
                            "get": "Get payroll run data"
                        },
                        "payslip": {
                            "get": "Get payslip",
                            "reminder": "Payslip reminder sent",
                            "upload": "Payslip uploaded",
                            "delete": "Payslip deleted",
                            "mark-as-read": "Payslip marked as read",
                            "mark-as-read-by-first-approver": "Payslip marked as read by first approver",
                            "mark-as-read-by-next-approver": "Payslip marked as read by next approver",
                            "reject": "Payslip rejected",
                            "approve": "Payslip approved"
                        },
                        "status": {
                            "index": "View salary status",
                            "table": "Get salary status table data",
                            "get": "Get salary status data"
                        },
                        "holiday-pay-obligations": {
                            "index": "View holiday pay obligations",
                            "table": "Get holiday pay obligations table data",
                            "get": "Get holiday pay obligations data",
                            "upload": "Holiday pay obligations file uploaded",
                            "edit": "View single holiday pay obligation",
                            "export": "Export holiday pay obligations to e-conomic",
                            "entries": {
                                "get": "Get holiday pay obligations per employee"
                            }
                        },
                        "data-fields": {
                            "index": "View data fields",
                            "table": "Get data fields table data",
                            "get": "Get data fields data"
                        },
                        "holidays": {
                            "index": "View holidays",
                            "table": "Get holidays table data",
                            "get": "Get holidays data",
                            "update": "Holiday updated"
                        },
                        "work-calendars": {
                            "index": "View work calendars",
                            "table": "Get work calendars table data",
                            "store": "Work calendar created",
                            "update": "Work calendar updated",
                            "destroy": "Work calendar deleted"
                        },
                        "log": {
                            "table": "Get payroll table data",
                            "index": "View payroll log",
                            "activities": "Get log data"
                        }
                    },
                    "log": {
                        "table": "Get log table data",
                        "index": "View log",
                        "activities": "Get log data"
                    },
                    "onboarding": {
                        "index": "View onboarding flow",
                        "table": "Get onboarding flow table data",
                        "get": "Get onboarding flow data",
                        "store": "Onboarding item created",
                        "services": {
                            "get": "Get onboarding flow services"
                        },
                        "customer": {
                            "index": "View customer onboarding flow",
                            "table": "Get customer onboarding flow table data",
                            "get": "Get customer onboarding flow data",
                            "store": "Customer onboarding flow created",
                            "update": "Customer onboarding flow updated",
                            "destroy": "Customer onboarding flow deleted",
                            "complete": "Customer onboarding flow completed"
                        }
                    },
                    "profile": {
                        "index": "View profile",
                        "update": "Update profile",
                        "password.update": "Update password"
                    },
                    "vat-deadlines": {
                        "index": "View VAT deadlines",
                        "table": "Get VAT deadlines table data",
                        "update": "Update VAT deadline",
                        "delete": "Delete VAT deadline",
                        "destroy": "VAT deadline deleted",
                        "store": "VAT deadline created"
                    },
                    "data-fields": {
                        "index": "View data fields",
                        "table": "Get data fields table data",
                        "get": "Get data fields data",
                        "store": "Data field created",
                        "update": "Data field updated",
                        "destroy": "Data field deleted"
                    },
                    "transactions": {
                        "index": "View transactions",
                        "table": "Get transactions table data",
                        "get": "Get transactions data",
                        "all": "Get transactions",
                        "journals": "Get journals",
                        "cash-book-types": "Get cash book types",
                        "transfer-economic": "Transfer transactions to e-conomic"
                    },
                    "task-templates": {
                        "index": "View task templates",
                        "table": "Get task templates table data",
                        "get": "Get task templates data",
                        "store": "Task template created",
                        "update": "Task template updated",
                        "destroy": "Task template deleted"
                    },
                    "vat": {
                        "index": "View VAT",
                        "table": "Get VAT table data",
                        "get": "Get VAT data",
                        "submit": "VAT submitted",
                        "submission": {
                            "update-field": "Update VAT submission field"
                        }
                    },
                    "outlay": {
                        "index": "View Outlay",
                        "login": "Login to Outlay",
                        "login-with-user-id": "Login to Outlay with user id"
                    },
                    "actuate": {
                        "redirect": "Sent to Actuate"
                    },
                    "document-ai": {
                        "index": "View Document AI",
                        "redirect": "Sent to Document AI"
                    },
                    "corpay-one": {
                        "index": "View Corpay",
                        "redirect": "Sent to Corpay"
                    },
                    "support": {
                        "index": "View support",
                        "redirect": "Sent to Support"
                    },
                    "administration": {
                        "index": "View administration"
                    }
                }
            },
            "description": {
                "logged_out": "Logged out",
                "logged_in": "Logged in",
                "show_payslip": "Show Payslip",
                "handled_cpr": "Handled CPR",
                "show_payroll": "Show Payroll",
                "changed_customer_salaried_employee": "Salaried Employee Changed",
                "changed_customer_employees_bank_details": "Employee Bank Details Changed",
                "changed_customer_employees_optional": "Optional Employee Details Changed",
                "payroll_field_changed": "Payroll Field Changed",
                "changed_customer_employee": "Employee Changed",
                "changed_customer_employees_pension_details": "Employee Pension Details Changed",
                "changed_customer_employees_pension_company": "Employee Pension Company Changed",
                "payslip_reminder_sent": "Payslip Reminder Sent",
                "payroll_created": "Payroll Created",
                "payroll_unlocked": "Payroll Unlocked",
                "payroll_approved": "Payroll Approved",
                "payroll_deleted": "Payroll Deleted",
                "comment_add_to_employee": "Comment Added to Employee",
                "employee_removed": "Employee removed from payslip",
                "payroll_approved_by_customer": "Payroll Approved by Customer",
                "changed_customer_employees_address": "Changed employee address",
                "changed_customer_hourly_employee": "Changed hourly employee",
                "created_employee": "Created employee",
                "changed_customer_employees_termination": "Changed employee termination",
                "payroll_data_deleted": "Payroll data deleted",
                "voucher_statement": "Voucher statement",
                "voucher": "Voucher"
            },
            "employee_deleted": "Employee deleted",
            "data_deleted": "Data deleted",
            "log_headline": "Log",
            "date_selection": "Date (From/To)",
            "search": "Search in period"
        },
        "auth": {
            "email": "E-Mail Address",
            "email_txt": "Please input your e-mail",
            "link_txt": "Send Password reset link",
            "login_txt": "Login",
            "password_confirm": "Confirm Password",
            "pw_forgot_txt": "Forgotten your password?",
            "pw_txt": "Please input your password",
            "remember_txt": "Keep me logged in",
            "reset_txt": "Reset Password",
            "office365_error": "Error, could not find user. Please use normal login page",
            "deactivated_error": "Error, the user does not have any active companies. Please contact {contact} for further info.",
            "deleted_error": "Error, the user does not have any active companies. Please contact {contact} for further info.",
            "remember_me": "Remember me",
            "forgot_password": "Forgot password",
            "email_placeholder": "Enter email",
            "password_placeholder": "Enter password",
            "email_password_reset_link": "Reset password",
            "or_return_to": "Or, return to",
            "log_in": "Log in",
            "enter_email_to_receive_password_reset_link": "Enter email to receive a password reset link",
            "link_sent": "A password reset link has been sent",
            "login_with_microsoft": "Log in with Microsoft",
            "login_error": "These credentials do not match our record",
            "password_reset_title": "Reset password",
            "password_reset_description": "Enter your new password below",
            "password_reset_email": "Email",
            "password_reset_password": "Password",
            "password_reset_confirm_password": "Confirm password",
            "password_reset_send": "Reset password",
            "password_reset_resend": "Resend link",
            "password_reset_resend_description": "A new link has been sent to you",
            "no_company": "You have no company. Please contact support for help.",
            "create_user": "Create user"
        },
        "bi_and_companies": {
            "id": "ID",
            "reporting_account": "Reporting account",
            "reporting_account_nr": "Reporting account nr",
            "account_mapping": "Account mapping",
            "measurement_calculation": "Measurement calculation",
            "edit_bi_row": "BI reporting account",
            "add_bi_row": "Add BI reporting account",
            "csv_import_warning": "Please be aware that the \"upload csv\" method deletes all existing information from the table and overwrites this information with the entries from the csv file. If you want to insert an extra row in the table, then please use the add button instead.",
            "csv_headers_needed": "The csv file has to be semi-colon separated, with the following column names:",
            "csv_formatting_error": "Invalid file format. Please ensure to upload a file in a correct format with the following columns: reporting account;reporting account nr;accounts in mapping;measurement calculation. The csv filen needs to be separated with \";\"",
            "delete_bi_row": "Delete BI report account",
            "delete_bi_row_content": "Are you sure you want to delete this BI report account?"
        },
        "button-text": {
            "display-statement": "Display statement",
            "register-economic": "Register changes",
            "save": "Save",
            "uploaded-without-voucher": "Uploaded without voucher",
            "1": "Yes",
            "choose_status": "Select status"
        },
        "companies": {
            "accounts_tab_text": "Accounts",
            "salary_tab_text": "Salary",
            "two_step_verification": "Use two-step verification on pay-slips",
            "yes_no": [
                "No",
                "Yes"
            ],
            "approver_1": "Approver 1",
            "approver_2": "Approver 2",
            "economic_tab_text": "E-conomic",
            "api_tab_text": "API data",
            "setup_tab_text": "Setup",
            "plain_account": "Only KC",
            "api_token": "API token",
            "economic_account": "E-conomic",
            "bi_tab_text": "BI",
            "outlay_tab_text": "Outlay",
            "missing_info": "Missing info",
            "form": {
                "address": "Adresse",
                "city": "City",
                "contact": "Contact",
                "country": "Country",
                "county": "County",
                "currency": "Currency",
                "customer_no": "Customer Number",
                "economic_customer_number": "E-conomic customer number",
                "cvr": "CVR number",
                "economic_number": "E-conomic number",
                "email": "Email",
                "fax_number": "Fax Number",
                "has_power_bi": "Power BI",
                "has_salary": "Payroll",
                "has_robotics": "Robotics",
                "has_consulting": "Consulting",
                "has_outsourcing": "Outsourcing",
                "mobile_number": "Mobile number",
                "primary_employee": "Primary Employee",
                "assistant_id": "Secondary Employee",
                "roger_invoices": "Corpay One invoice email",
                "roger_receipts": "Corpay One receipts",
                "keepers_email": "Keepers email",
                "contract_link": "Contract",
                "data_processor_contract_link": "Data processor contract",
                "fixed_price": "Fixed price",
                "name": "Name",
                "num_of_vouchers": "Number of vouchers",
                "postal_code": "Zip/Postal code",
                "report_deadline": "Report deadline",
                "sign_up_date": "Sign-up date",
                "telephone": "Telephone",
                "update_frequency": "Update frequency",
                "vat_frequency": "Vat frequency",
                "vat_number": "Vat number",
                "voucher_limit": "Voucher limit",
                "website": "Website",
                "press_to_read": "Press here to read",
                "system_details": {
                    "num_of_vouchers": "Number of vouchers in agreement:",
                    "fixed_price": "Fixed price:",
                    "price_frequency": "Price frequency",
                    "voucher_limit": "Missing voucher limit:",
                    "has_salary": "Salary at Keepers:",
                    "has_app_service": "Outlay",
                    "has_payments": "Payments at Keepers:",
                    "has_f_box": "F-Box at Keepers:",
                    "has_outsourcing": "Outsourcing:",
                    "has_power_bi": "Power BI selected:",
                    "to_keepers_kube": "Include in Keepers Kube:",
                    "report_deadline": "Report deadline:",
                    "salary_deadline": "Salary deadline:",
                    "vat_frequency": "Vat frequency:",
                    "update_frequency": "Update frequency:",
                    "day_frequency": "Weekly frequency",
                    "has_kube": "Kube",
                    "has_e_income": "E income",
                    "salary_system": "Salary system",
                    "kube_data_field_id": "Part of cube",
                    "has_roger_ai": "Corpay One",
                    "kube_id": "Kube ID"
                },
                "bi": {
                    "economic_token": "E-conomic Token"
                },
                "outlay_company_id": "Match with Outlay company",
                "choose_services": "Choose service",
                "select": "Select"
            },
            "read_from_economic": "Update existing companies from E-conomic",
            "read_from_economic_success": "Read the following companies from E-conomic",
            "no_new_read_from_economic_success": "No new companies read from E-conomic",
            "system_tab_text": "System",
            "services_tab_text": "Services",
            "basic_tab_text": "Basic",
            "update_frequency_options": {
                "": "Missing info",
                "monthly": "Monthly",
                "quarterly": "Quarterly",
                "yearly": "Yearly"
            },
            "vat_frequency_options": {
                "": "Missing info",
                "missing_info": "Missing info",
                "monthly": "Monthly",
                "quarterly": "Quarterly",
                "six-monthly": "Every 6 months",
                "n/a": "Exempt"
            },
            "price_frequency_options": {
                "hourly": "Hourly",
                "monthly": "Monthly"
            },
            "day_frequency_options": {
                "monday": "Monday",
                "tuesday": "Tuesday",
                "wednesday": "Wednesday",
                "wedensday": "Wednesday",
                "thursday": "Thursday",
                "friday": "Friday",
                "": "Missing info"
            },
            "header": "Companies",
            "choose": "Choose client",
            "choose_help_text": "Please choose a client",
            "deactivated": "inactive",
            "outlay": {
                "deselect": "No match in Outlay"
            },
            "js": {
                "create": "Create",
                "company_create": "Create company",
                "company_edit": "Edit company",
                "update": "Update",
                "delete": {
                    "title": "Delete company",
                    "content": "Warning! This deletes the following:<br> - all company users, unless they are attached to other companies <br>- all payrolls<br>- all pay slips<br>- all employees<br><br>The action cannot be undone.<br><br>Are you sure you want to delete the company?",
                    "yes": "Yes",
                    "no": "No"
                },
                "restore": {
                    "title": "Restore company",
                    "content": "Are you sure you want to restore the company?",
                    "yes": "Yes",
                    "no": "No",
                    "success": "Company restored"
                },
                "deactivate": {
                    "title": "Deactivate company",
                    "content-2": "Are you sure you want to deactivate the company?",
                    "yes": "Yes",
                    "no": "No",
                    "success": "Company deactivated"
                },
                "activate": {
                    "title": "Activate company",
                    "content": "Are you sure you want to activate the company?",
                    "content-2": "Are you sure you want to activate the company?",
                    "yes": "Yes",
                    "no": "No",
                    "success": "Company activated"
                }
            },
            "table": {
                "id": "Id",
                "name": "Name",
                "cvr": "CVR number",
                "address": "Address",
                "economic_number": "E-conomic agreement number",
                "customer_no": "E-conomic customer number",
                "num_of_vouchers": "Number of vouchers",
                "fixed_price": "Fixed price",
                "vat_frequency": "Vat frequency",
                "update_frequency": "Update frequency"
            },
            "companies_table": {
                "id": "Id",
                "name": "Name",
                "cvr": "CVR number",
                "address": "Address",
                "economic_number": "E-conomic agreement number",
                "customer_no": "E-conomic customer number",
                "economic_customer_number": "E-conomic customer number",
                "num_of_vouchers": "Number of vouchers",
                "fixed_price": "Fixed price",
                "vat_frequency": "Vat frequency",
                "update_frequency": "Update frequency",
                "status": "Status"
            },
            "delete_error_start": "The following users are attached to the company:<br><br> ",
            "delete_error_end": "<br><br>Please remove the users before deleting the company.",
            "kube_data_field_missing": "Missing info",
            "no_value_defined": "No {placeholder} defined",
            "update_error_url": "The URL must have the format: \"http://example.com\" <br>",
            "update_error_email": "The email must have the format: \"example@example.com\" <br>",
            "customer_no": {
                "success": "The customer number was saved. You are now ready to import the customers information from E-conomic",
                "modal": "Create customer number",
                "label": "Input customer number (equivalent to E-conomic account number)"
            },
            "save_success": "The information was saved",
            "create_company": "Opret virksomhed",
            "header_user_companies": "Employees & Companies",
            "working_days": "working days",
            "select": {
                "has_salary": "Has salary",
                "no_salary": "No salary",
                "deactivated": "Inactive"
            },
            "clients": "Clients",
            "accounts": "Accounts",
            "dimensions": "Dimensions",
            "no_dimensions": "No dimensions",
            "loading_dimensions": "Loading dimensions",
            "services": "Services",
            "general_settings": "General settings",
            "kube_settings": "Kube settings",
            "employees_assigned": "Employees assigned on",
            "created": "Company created",
            "updated": "Company updated",
            "deleted": "Company deleted",
            "user_companies_table": {
                "id": "ID",
                "name": "Name",
                "employees": "Keepers employees",
                "count": "Count",
                "has_salary": "Company has salary"
            },
            "user_companies_edit_title": "Manage affiliation",
            "user_companies_edit": "Select Keepers employees",
            "active": "Active",
            "non_active": "Non Active",
            "none_selected": "No company",
            "information": "Information",
            "no_voucher_accounts": "No voucher accounts",
            "economic_unauthorized": "E-conomic API token is not valid"
        },
        "company-affiliation": {
            "nav": {
                "header": "Company-group association"
            },
            "navbar_header": "Company-group association",
            "table": {
                "group_id": "Company Group Ids",
                "group": "Company Groups",
                "company_id": "Company Ids",
                "companies": "Companies"
            }
        },
        "company-groups": {
            "actions": {
                "create": "Create",
                "update": "Update",
                "delete": "Delete"
            },
            "delete": {
                "title": "Delete group",
                "content": "This deletes the group. The action can not be undone. <br> Are you sure you want to delete the group?",
                "yes": "Delete",
                "no": "Cancel"
            },
            "form": {
                "labels": {
                    "name": "Group name",
                    "companies": "Affiliated companies"
                },
                "placeholders": {
                    "name": "Gefion"
                }
            },
            "company_groups_create": "Create group",
            "company_groups_edit": "Update group",
            "part_of": "A part of",
            "header_companies_groups": "Companies & Groups",
            "table_headers": {
                "id": "ID",
                "name": "Name",
                "companies": "Affiliated companies",
                "count": "Count"
            },
            "created": "Company group created",
            "updated": "Company group updated",
            "deleted": "Company group deleted"
        },
        "credit-cards": {
            "page_header": "Registered credit cards",
            "table": {
                "name": "Name",
                "number": "Card number",
                "type": "Card type",
                "company": "Company",
                "assigned": "Assigned to",
                "last_used": "Last used"
            },
            "form": {
                "name": "Name",
                "number": "Card number",
                "type": "Card type",
                "employee_ids": "Employees associated",
                "user_ids": "Users associated",
                "number_min": "The card number must be 16 digits",
                "number_max": "The card number must be 16 digits"
            },
            "create": {
                "title": "Create credit card",
                "success": "The credit card {name} has been created"
            },
            "edit": {
                "title": "Edit credit card",
                "success": "The credit card {name} has been updated"
            },
            "delete": {
                "title": "Delete credit card",
                "content": "Are you sure you want to delete the credit card?",
                "success": "The credit card has been deleted"
            },
            "types": {
                "visa": "Visa",
                "mastercard": "Mastercard",
                "discover": "Discover",
                "unionpay": "Unionpay",
                "jcb": "JCB",
                "other": "Other"
            }
        },
        "custom-rules": {
            "ids_exists_in_table": {
                "message": "One or more of the {tableName} ids is invalid."
            },
            "exists_in_table": {
                "message": "The value for {tableName} is invalid."
            }
        },
        "dashboards": {
            "feed_header": "Feed",
            "feed": {
                "info": "Feed Info"
            },
            "procedures_header": "Monthly close procedure",
            "stats_header": "Stats from Keepers",
            "stats": {
                "has_power_bi": "BI:",
                "has_salary": "Salary at Keepers:",
                "fixed_price": "Fixed price:",
                "hourly_price": "Hourly price:",
                "num_of_vouchers": "Number of vouchers in agreement:",
                "report_deadline": "Report deadline:",
                "update_frequency": "Update frequency:",
                "vat_frequency": "VAT frequency:",
                "voucher_limit": "Limit for lost vouchers:",
                "price_frequency": {
                    "monthly": "pr. month",
                    "hourly": "pr. hour"
                }
            },
            "customer_stats": {
                "price_frequency": {
                    "monthly": "Price per month",
                    "hourly": "Price per hour"
                },
                "missing_vouchers": "Missing vouchers",
                "vat_frequency": "VAT frequency",
                "procedures": "Procedures",
                "work_days": "{count} work days",
                "weekdays": "Weekdays: {days}",
                "actual_tasks": "Current tasks"
            },
            "marquee": {
                "keepers_email": "Keepers email",
                "corpay_invoice": "Corpay One invoice",
                "corpay_receipts": "Corpay One receipts"
            },
            "tasks_header": "Current tasks",
            "tasks_create": "Create task",
            "tasks_create_from_template": "Task from template",
            "vouchers_header": "Missing vouchers",
            "primary_employees": "Primary employee",
            "assistant": "Secondary employee",
            "general_info": "General info",
            "support": "Support",
            "vouchers": {
                "account_number": "No account chosen",
                "deadline": "Deadline in {deadline} days",
                "no_file": "No voucher uploaded",
                "has_files": "Vouchers uploaded",
                "success": "Approved",
                "failure": "Not approved"
            },
            "employee": {
                "progress": "Progress (%)",
                "docs": "Docs (Dropbox)",
                "payroll_progress": "Payroll progress",
                "payroll_reported": "Payroll reported to Keepers?",
                "salary_deadline": "Salary deadline",
                "pay_slips_for_approval": "Pay slips for approval",
                "payslips_approved": "Payslips approved?",
                "payslips_sent": "Payslips sent?",
                "deadlines_header": "Deadlines",
                "metrics_header": "Metrics",
                "others_header": "Others",
                "payroll_finalized": "Payroll finalized?",
                "hand_in": "Hand-in ind deadline",
                "reported_deadline": "Reporting deadline",
                "repoting_finised": "Reporting finished current period?",
                "next_vat_deadline": "Next VAT deadline",
                "accounting_year": "Accounting Year",
                "frequency": "Frequency",
                "vat_reported": "VAT reported?",
                "open_tasks": "Open tasks on tasklist",
                "no_of_tasks": "No of tasks",
                "overdue_tasks": "Overdue tasks",
                "product_related_header": "Product related:",
                "table_company": "Company",
                "postings": "Postings vs. agreement",
                "actual_vs_contract": "Actual vs. contract",
                "action": "Action",
                "active_services": "Active services",
                "book_status": "Bookkeeping status",
                "bookkeeping_header": "Bookkeeping status",
                "no_companies": "No companies attached",
                "payroll_header": "Payroll status",
                "tasks_table_date": "Deadline",
                "tasks_table_file": "Attached",
                "tasks_table_status": "Status",
                "tasks_table_task": "Task",
                "tasks_table_task_description": "Description",
                "tasks_table_task_responsible_name": "Responsible",
                "vat_header": "Vat Status",
                "amount_of_customers": "Number of customers",
                "amount_of_customers_missing_report": "Customers missing report",
                "amount_of_customers_missing_report_within_two_days": "Customers missing report with two days",
                "amount_of_customers_missing_salery": "Customers missing payroll",
                "amount_of_customers_missing_voucher": "Customers missing vouchers",
                "over_deadline": "Customers over deadline",
                "daily_frequency": "Weekday",
                "update_frequency": "Update Frequency",
                "reporting_finished": "Reporting status",
                "handled_vouchers": "Handled vouchers",
                "missing_docs_deadline": "Deadline m.v.",
                "vat_frequency": "VAT Frequency",
                "reload_on_demand": "Reload on demand",
                "global_search": {
                    "placeholder": "Filter companies"
                },
                "weekdays": "Weekdays",
                "stats": {
                    "customers_assigned": "Number of customers",
                    "customers_missing_vouchers": "Customers missing vouchers",
                    "customers_missing_report": "Customers missing report",
                    "customers_missing_report_within_two_days": "Customers missing report within two days",
                    "customers_missing_onboarding": "Customers missing onboarding",
                    "cusomters_over_deadline": "Customers over deadline",
                    "days_until_accounting_deadline": "Customers with under 7 days until accounting deadline",
                    "days_until_report_deadline": "Customers with under 7 days until reporting deadline",
                    "days_until_vat_deadline": "Customers with under 7 days until VAT reporting deadline"
                }
            },
            "salary": {
                "output": "Output salary"
            },
            "edit_user_companies": "Attach employee(s)",
            "companies_users": "Choose attachment to Keepers employee",
            "no": "NO",
            "power_bi": "Power BI",
            "app_service": "App",
            "payments": "Payments",
            "outsourcing": "Outsourcing",
            "consulting": "Consulting",
            "robotics": "Robotics",
            "outlay": "Outlay",
            "salary_app": "Danlon App",
            "e_income": "E Income",
            "roger_ai": "Corpay One",
            "procedures": "Procedures",
            "procedures_add": "Procedure",
            "procedures_choose_responsible": "Choose responsible",
            "salery": "Salary",
            "payroll": "Payroll",
            "tasks_add": "Task",
            "tasks_add_from_template": "Tasks from template",
            "tasks_delete_confirm": "Are you sure you want to delete this task?",
            "tasks_delete_success": "Task deleted",
            "tasks_notification": "Task notification",
            "selected_template": "Select template",
            "procedures_create": "Create procedure",
            "procedures_edit": "Edit procedure",
            "procedures_delete": "Delete procedure",
            "procedures_delete_confirm": "Are you sure you want to delete this procedure?",
            "procedures_delete_success": "Procedure deleted",
            "tasks_closed": "Closed",
            "tasks_recurring": "Recurring",
            "tasks_deadline": "Deadline",
            "tasks_description": "Description",
            "tasks_finish": "Done",
            "tasks_open": "Open",
            "tasks_status": "Status",
            "tasks_delete": "Delete task",
            "tasks_title": "Title",
            "vouchers_account": "Account",
            "vouchers_amount": "Amount",
            "vouchers_contra_account": "Contra Account",
            "vouchers_date": "Date",
            "vouchers_deadline_voucher": "Deadline",
            "vouchers_description": "Description",
            "vouchers_filename_uploaded": "Filename",
            "vouchers_status": "Status",
            "yes": "YES",
            "vouchers_product": "Vouchers",
            "notification": {
                "send_notification": "Send notification",
                "day_in_week": "Day in the week",
                "frequency": "frequency",
                "choose_odd_or_even_week": "Choose odd or even week",
                "choose_start_or_end_month": "Choose start or end of month"
            },
            "dashboards": {
                "employee": {
                    "daily_frequency": "Weekday"
                }
            },
            "comment": {
                "employees": "Employees:",
                "comment_by": "Comment by:",
                "body": "Comment",
                "comment": "Comment",
                "store": "Create new comment:",
                "update": "Update",
                "delete": "Delete",
                "new": "New",
                "assigned_to": "Assigned to",
                "title": "Comments on {company}",
                "placeholder": "Type {'@'} to tag a user"
            },
            "hard_refresh": "Refresh",
            "title": "Dashboard",
            "buttons": {
                "customize_columns": "Customize columns",
                "collapse": "Collapse groups",
                "expand": "Expand groups"
            },
            "grouping": {
                "my_clients": "My customers",
                "all": "All",
                "outsourcing": "Outsourcing",
                "powerbi": "PowerBI",
                "salary": "Salary",
                "roger_ai": "Corpay One"
            },
            "table_headers": {
                "name": "Company",
                "keepers_employees": "Assigned to",
                "status": "Bookkeeping status",
                "deadline": "Deadline m.v.",
                "report_status": "Reporting status",
                "report_deadline": "Reporting deadline",
                "vat_status": "VAT reported?",
                "vat_deadline": "Next VAT deadline",
                "accouting_year": "Accounting Year",
                "output_salary": "Output salary",
                "vat_frequency": "VAT Frequency",
                "weekday": "Weekday",
                "update_frequency": "Update Frequency",
                "postings": "Postings vs. agreement",
                "actual_vs_contract": "Actual vs. contract",
                "active_services": "Active services",
                "handled_vouchers": "Missing vouchers",
                "reload_on_demand": "Reload on demand"
            },
            "datatable": {
                "name": "Company",
                "keepers_employees": "Assigned to",
                "bookkeeping_status": "Bookkeeping status",
                "bookkeeping_deadline": "Book. deadline",
                "report_status": "Reporting status",
                "report_deadline": "Report deadline",
                "vat_status": "VAT reported?",
                "vat_deadline": "Next VAT deadline",
                "pbc_status": "PBC status",
                "pbc_deadline": "PBC deadline",
                "annual_report": "Reconciled to annual report",
                "accouting_year": "Accounting Year",
                "onboarding": "Onboarding",
                "vat_frequency": "VAT Frequency",
                "weekday": "Weekday",
                "update_frequency": "Update Frequency",
                "postings": "Postings vs. agreement",
                "actual_vs_contract": "Actual vs. contract",
                "active_services": "Active services",
                "handled_vouchers": "Missing vouchers",
                "reload_on_demand": "Reload on demand"
            },
            "bulk_update_success": "{status} updated for {count} companies",
            "tasks_help": "Current tasks are open tasks that need to be solved within the specified deadline.",
            "procedures_help": "Monthly close procedures are procedures that need to be solved at the end of each month.",
            "status_update_failed": "Status update failed",
            "invoices": {
                "title": "Invoices",
                "table": {
                    "number": "Invoice number",
                    "date": "Date",
                    "amount": "Price (ex. VAT)",
                    "status": "Status"
                },
                "download": "View invoice",
                "no_cvr": "Loading invoices requires the company to have a CVR number"
            }
        },
        "datatables": {
            "display": "Display",
            "search": "Search:",
            "thousands": ",",
            "zeroRecords": "No matching results",
            "emptyTable": "No data available",
            "info": "Displaying page _PAGE_ of _PAGES_",
            "infoEmpty": "No results found",
            "infoFiltered": "",
            "show_columns": "Filter columns",
            "processing": "Working...",
            "loadingRecords": "Loading...",
            "lengthMenu": "Display _MENU_ rows",
            "all": "All",
            "paginate": {
                "first": "First",
                "last": "Last",
                "next": "Next",
                "previous": "Previous"
            },
            "aria": {
                "sortAscending": ": activate to sort columns by ascending order",
                "sortDescending": ": activate to sort columns by descending order"
            },
            "search_placeholder": "Search...",
            "show": "Show",
            "rows": "rows",
            "rows_selected": "row(s) selected",
            "showing": "Showing",
            "to": "to",
            "of": "of",
            "entries": "entries",
            "page": "Page",
            "loading": "Loading...",
            "expand_all": "Expand all groups",
            "collapse_all": "Collapse all groups",
            "reload_table": "Reload table",
            "view_options": {
                "header": "Views",
                "add_option": "Add view",
                "choose_columns": "Choose columns to display",
                "placeholder": "Unnamed",
                "default": "Default",
                "global_views": "Shared views",
                "personal_views": "My views",
                "make_global": "Share with everyone",
                "make_personal": "Make private",
                "shared": "Shared"
            },
            "no_company": "No company selected"
        },
        "dropzone": {
            "dictDefaultMessage": "Drop your files here for upload",
            "dictFallbackMessage": "Your browser does not support drag and drop of files.",
            "dictFallbackText": "Please use the backup form below to upload files, just like in the old days..",
            "dictFileTooBig": "The file is too too big ({{filesize}}MiB). Max file size: {{maxFilesize}}MiB.",
            "dictInvalidFileType": "Upload of this file type is not allowed.",
            "dictResponseError": "Server responded with an {{statusCode}} code.",
            "dictCancelUpload": "Cancel",
            "dictCancelUploadConfirmation": "Are you sure you want to cancel?",
            "dictRemoveFile": "Remove",
            "dictMaxFilesExceeded": "You are only allowed to upload one file per voucher.",
            "dictCustomDropMessage": "Drop your files here for upload. You can upload up to 4 files."
        },
        "economic-period": {
            "table": {
                "company": "Virksomhed",
                "january": "Jan",
                "february": "Feb",
                "march": "Mar",
                "april": "Apr",
                "may": "May",
                "june": "Jun",
                "july": "Jul",
                "august": "Aug",
                "september": "Sept",
                "october": "Oct",
                "november": "Nov",
                "december": "Dec",
                "year": "År"
            }
        },
        "economic": {
            "cashbook": {
                "not_found": "Cashbook {cashbook} was not found."
            },
            "account": {
                "not_found": "One or more of the accounts where not found."
            },
            "department": {
                "not_found": "One or more of the departments where not found."
            },
            "default_voucher_error": "An error occurred while updating the voucher in E-conomic. Please try again or contact support for more info.",
            "voucher_not_found": "The voucher was not found in E-conomic."
        },
        "employee": {
            "validation": {
                "errors_found": "The following errors were found:",
                "first_name": "Please input first name",
                "last_name": "Please input last name",
                "cpr": "Please input a cpr in the correct format",
                "email": "Please input email in correct format",
                "company_id": "Please select a client",
                "employee_id": "Please select employees from the table that you wish to select. You can do this by using the checkboxes.",
                "phone_private": "Please input a correct number. Max length is 12 digits",
                "phone_cell": "Please input a correct number. Max length is 12 digits",
                "employment_date": "Please input employment date in the following format: dd/mm/yyyy",
                "address": "Please input address",
                "postal_code": "Please input zip/postal code",
                "city": "Please input city",
                "country_code": "Please select a country",
                "bank_reg": "Bank reg. number should be 4 digits long.",
                "bank_account": "Bank account number should be 10 digits long.",
                "iban_empty": "Please input IBAN.",
                "swift_empty": "Please input SWIFT number.",
                "employee_contribution": "Please input employee contribution to pension",
                "company_contribution": "Please input company contribution to pension",
                "pension_company": "Please input pension company",
                "salary": "Please input salary/month",
                "hourly_rate": "Please input hourly rate",
                "production_unit": "Please input production unit",
                "days_vacation": "Please input days vacation",
                "flex_savings": "Please input flex savings",
                "yes": "Yes",
                "no": "No",
                "confirm": "employees have already been downloaded. Danlon does not allow overwrites. Download anyway?",
                "title": "Already downloaded",
                "are_you_sure": "Are you sure?",
                "delete_employee_confirm_text": "Do you really want to delete this employee?",
                "deleted_employee": "Deleted employee",
                "weekly_working_hours": "Please input weekly working hours",
                "user_id": "An user must be selected or created when a credit card is assigned"
            },
            "page_header": "Employees",
            "create": {
                "header": "Create employee"
            },
            "edit": {
                "header": "Edit employee"
            },
            "upload": {
                "header": "Upload employees",
                "admin_header": "Upload employees (Admin)",
                "invalid_headers": "Invalid file. It is missing the correct fields.",
                "consent": "I understand that I am uploading employees to {name}"
            },
            "address": {
                "header": "Address",
                "address": "Address:",
                "address2": "Address 2:",
                "postal_code": "Zip/postal code:",
                "city": "City:",
                "country_code": "Country:",
                "pnumber": "Pnumber:",
                "country_codes_array": {
                    "AF": "Afghanistan",
                    "AL": "Albania",
                    "DZ": "Algeria",
                    "AS": "American Samoa",
                    "AD": "Andorra",
                    "AO": "Angola",
                    "AI": "Anguilla",
                    "AQ": "Antarctica",
                    "AG": "Antigua and Barbuda",
                    "AR": "Argentina",
                    "AM": "Armenia",
                    "AW": "Aruba",
                    "AU": "Australia",
                    "AT": "Austria",
                    "AZ": "Azerbaijan",
                    "BS": "Bahamas",
                    "BH": "Bahrain",
                    "BD": "Bangladesh",
                    "BB": "Barbados",
                    "BY": "Belarus",
                    "BE": "Belgium",
                    "BZ": "Belize",
                    "BJ": "Benin",
                    "BM": "Bermuda",
                    "BT": "Bhutan",
                    "BO": "Bolivia",
                    "BA": "Bosnia and Herzegovina",
                    "BW": "Botswana",
                    "BV": "Bouvet Island",
                    "BR": "Brazil",
                    "BQ": "British Antarctic Territory",
                    "IO": "British Indian Ocean Territory",
                    "VG": "British Virgin Islands",
                    "BN": "Brunei",
                    "BG": "Bulgaria",
                    "BF": "Burkina Faso",
                    "BI": "Burundi",
                    "KH": "Cambodia",
                    "CM": "Cameroon",
                    "CA": "Canada",
                    "CT": "Canton and Enderbury Islands",
                    "CV": "Cape Verde",
                    "KY": "Cayman Islands",
                    "CF": "Central African Republic",
                    "TD": "Chad",
                    "CL": "Chile",
                    "CN": "China",
                    "CX": "Christmas Island",
                    "CC": "Cocos [Keeling] Islands",
                    "CO": "Colombia",
                    "KM": "Comoros",
                    "CG": "Congo - Brazzaville",
                    "CD": "Congo - Kinshasa",
                    "CK": "Cook Islands",
                    "CR": "Costa Rica",
                    "HR": "Croatia",
                    "CU": "Cuba",
                    "CY": "Cyprus",
                    "CZ": "Czech Republic",
                    "CI": "Côte d’Ivoire",
                    "DK": "Denmark",
                    "DJ": "Djibouti",
                    "DM": "Dominica",
                    "DO": "Dominican Republic",
                    "NQ": "Dronning Maud Land",
                    "DD": "East Germany",
                    "EC": "Ecuador",
                    "EG": "Egypt",
                    "SV": "El Salvador",
                    "GQ": "Equatorial Guinea",
                    "ER": "Eritrea",
                    "EE": "Estonia",
                    "ET": "Ethiopia",
                    "FK": "Falkland Islands",
                    "FO": "Faroe Islands",
                    "FJ": "Fiji",
                    "FI": "Finland",
                    "FR": "France",
                    "GF": "French Guiana",
                    "PF": "French Polynesia",
                    "TF": "French Southern Territories",
                    "FQ": "French Southern and Antarctic Territories",
                    "GA": "Gabon",
                    "GM": "Gambia",
                    "GE": "Georgia",
                    "DE": "Germany",
                    "GH": "Ghana",
                    "GI": "Gibraltar",
                    "GR": "Greece",
                    "GL": "Greenland",
                    "GD": "Grenada",
                    "GP": "Guadeloupe",
                    "GU": "Guam",
                    "GT": "Guatemala",
                    "GG": "Guernsey",
                    "GN": "Guinea",
                    "GW": "Guinea-Bissau",
                    "GY": "Guyana",
                    "HT": "Haiti",
                    "HM": "Heard Island and McDonald Islands",
                    "HN": "Honduras",
                    "HK": "Hong Kong SAR China",
                    "HU": "Hungary",
                    "IS": "Iceland",
                    "IN": "India",
                    "ID": "Indonesia",
                    "IR": "Iran",
                    "IQ": "Iraq",
                    "IE": "Ireland",
                    "IM": "Isle of Man",
                    "IL": "Israel",
                    "IT": "Italy",
                    "JM": "Jamaica",
                    "JP": "Japan",
                    "JE": "Jersey",
                    "JT": "Johnston Island",
                    "JO": "Jordan",
                    "KZ": "Kazakhstan",
                    "KE": "Kenya",
                    "KI": "Kiribati",
                    "KW": "Kuwait",
                    "KG": "Kyrgyzstan",
                    "LA": "Laos",
                    "LV": "Latvia",
                    "LB": "Lebanon",
                    "LS": "Lesotho",
                    "LR": "Liberia",
                    "LY": "Libya",
                    "LI": "Liechtenstein",
                    "LT": "Lithuania",
                    "LU": "Luxembourg",
                    "MO": "Macau SAR China",
                    "MK": "Macedonia",
                    "MG": "Madagascar",
                    "MW": "Malawi",
                    "MY": "Malaysia",
                    "MV": "Maldives",
                    "ML": "Mali",
                    "MT": "Malta",
                    "MH": "Marshall Islands",
                    "MQ": "Martinique",
                    "MR": "Mauritania",
                    "MU": "Mauritius",
                    "YT": "Mayotte",
                    "FX": "Metropolitan France",
                    "MX": "Mexico",
                    "FM": "Micronesia",
                    "MI": "Midway Islands",
                    "MD": "Moldova",
                    "MC": "Monaco",
                    "MN": "Mongolia",
                    "ME": "Montenegro",
                    "MS": "Montserrat",
                    "MA": "Morocco",
                    "MZ": "Mozambique",
                    "MM": "Myanmar [Burma]",
                    "NA": "Namibia",
                    "NR": "Nauru",
                    "NP": "Nepal",
                    "NL": "Netherlands",
                    "AN": "Netherlands Antilles",
                    "NT": "Neutral Zone",
                    "NC": "New Caledonia",
                    "NZ": "New Zealand",
                    "NI": "Nicaragua",
                    "NE": "Niger",
                    "NG": "Nigeria",
                    "NU": "Niue",
                    "NF": "Norfolk Island",
                    "KP": "North Korea",
                    "VD": "North Vietnam",
                    "MP": "Northern Mariana Islands",
                    "NO": "Norway",
                    "OM": "Oman",
                    "PC": "Pacific Islands Trust Territory",
                    "PK": "Pakistan",
                    "PW": "Palau",
                    "PS": "Palestinian Territories",
                    "PA": "Panama",
                    "PZ": "Panama Canal Zone",
                    "PG": "Papua New Guinea",
                    "PY": "Paraguay",
                    "YD": "People's Democratic Republic of Yemen",
                    "PE": "Peru",
                    "PH": "Philippines",
                    "PN": "Pitcairn Islands",
                    "PL": "Poland",
                    "PT": "Portugal",
                    "PR": "Puerto Rico",
                    "QA": "Qatar",
                    "RO": "Romania",
                    "RU": "Russia",
                    "RW": "Rwanda",
                    "RE": "Réunion",
                    "BL": "Saint Barthélemy",
                    "SH": "Saint Helena",
                    "KN": "Saint Kitts and Nevis",
                    "LC": "Saint Lucia",
                    "MF": "Saint Martin",
                    "PM": "Saint Pierre and Miquelon",
                    "VC": "Saint Vincent and the Grenadines",
                    "WS": "Samoa",
                    "SM": "San Marino",
                    "SA": "Saudi Arabia",
                    "SN": "Senegal",
                    "RS": "Serbia",
                    "CS": "Serbia and Montenegro",
                    "SC": "Seychelles",
                    "SL": "Sierra Leone",
                    "SG": "Singapore",
                    "SK": "Slovakia",
                    "SI": "Slovenia",
                    "SB": "Solomon Islands",
                    "SO": "Somalia",
                    "ZA": "South Africa",
                    "GS": "South Georgia and the South Sandwich Islands",
                    "KR": "South Korea",
                    "ES": "Spain",
                    "LK": "Sri Lanka",
                    "SD": "Sudan",
                    "SR": "Suriname",
                    "SJ": "Svalbard and Jan Mayen",
                    "SZ": "Swaziland",
                    "SE": "Sweden",
                    "CH": "Switzerland",
                    "SY": "Syria",
                    "ST": "São Tomé and Príncipe",
                    "TW": "Taiwan",
                    "TJ": "Tajikistan",
                    "TZ": "Tanzania",
                    "TH": "Thailand",
                    "TL": "Timor-Leste",
                    "TG": "Togo",
                    "TK": "Tokelau",
                    "TO": "Tonga",
                    "TT": "Trinidad and Tobago",
                    "TN": "Tunisia",
                    "TR": "Turkey",
                    "TM": "Turkmenistan",
                    "TC": "Turks and Caicos Islands",
                    "TV": "Tuvalu",
                    "UM": "U.S. Minor Outlying Islands",
                    "PU": "U.S. Miscellaneous Pacific Islands",
                    "VI": "U.S. Virgin Islands",
                    "UG": "Uganda",
                    "UA": "Ukraine",
                    "SU": "Union of Soviet Socialist Republics",
                    "AE": "United Arab Emirates",
                    "GB": "United Kingdom",
                    "US": "United States",
                    "ZZ": "Unknown or Invalid Region",
                    "UY": "Uruguay",
                    "UZ": "Uzbekistan",
                    "VU": "Vanuatu",
                    "VA": "Vatican City",
                    "VE": "Venezuela",
                    "VN": "Vietnam",
                    "WK": "Wake Island",
                    "WF": "Wallis and Futuna",
                    "EH": "Western Sahara",
                    "YE": "Yemen",
                    "ZM": "Zambia",
                    "ZW": "Zimbabwe",
                    "AX": "Åland Islands"
                },
                "cvr-address-headline": "CVR address(es)",
                "cvr-address-import-btn": "Import address"
            },
            "vacation": {
                "months": [
                    "No allocation of vacation days",
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ]
            },
            "bank": {
                "bank_reg": "Bank reg.number",
                "bank_account": "Bank account number",
                "iban": "IBAN",
                "swift": "SWIFT",
                "transfer_manually": "When choosing IBAN and SWIFT, the salary must be transferred manually.",
                "required": "* Requires a danish bank account",
                "header": "Bank",
                "international_account": "I do not have a danish bank account",
                "non_danish_account": "No Danish bank account"
            },
            "employment": {
                "header": "Employment terms",
                "salaried": "Salaried employee",
                "hourly": "Hourly employee",
                "ceo": "Company CEO",
                "b_honorarium_receiver": "B-Honorarmodtager",
                "standard_time": "Hours/week in contract:",
                "salary": "Salary/month:",
                "current_salary": "Current salary",
                "new_salary": "New salary",
                "new_salary_starts_at": "Salary change valid from",
                "future_salary_changes": "Future salary changes",
                "future_salary_starts_at": "Valid from",
                "salary_change_duplicated_date_error": "There is already a salary change with this date",
                "has_free_car": "Free car",
                "free_car_monthly": "Car - Monthly taxable amount",
                "free_car_file": "Leasing contract",
                "free_car_filename": "Leasing contract",
                "free_car_file_description": "Registration number",
                "has_free_phone": "Free phone",
                "has_health_insurance": "Health insurance",
                "hourly_rate": "Hourly rate:",
                "no_fields": "has no fields",
                "with": "with",
                "weekly_working_hours": "Weekly working hours",
                "weekly_working_days": "Weekly working days",
                "tax_card": "Tax card",
                "primary_tax_card": "Primary",
                "secondary_tax_card": "Secondray",
                "tax_exemption_card": "Tax exemption",
                "danmarks_statistik": "Denmark Statistics",
                "dst_time_limited_employment": "Employment type in company:",
                "dst_hired_terms": "Employment terms:",
                "dst_job_status": "Job status:",
                "dst_salary_form": "Salary type:",
                "has_lunch_arrangement": "Lunch arrangement",
                "lunch_arrangement_monthly": "Lunch arrangement - Monthly amount:",
                "fixed_add_ons_monthly": "Fixed add-ons - Monthly amount:",
                "has_fixed_add_ons": "Fixed add-ons",
                "pension": "Pension",
                "disco_code": "Disco-code:",
                "health_insurance_monthly": "Health insurance - Monthly amount",
                "free_car_filepath": "Leasing contract - Filepath",
                "time_monday": "Monday:",
                "time_tuesday": "Tuesday:",
                "time_wednesday": "Wednesday:",
                "time_thursday": "Thursday:",
                "time_friday": "Friday:",
                "time_saturday": "Saturday",
                "time_sunday": "Sunday:",
                "lunch_arrangement": "Lunch arrangement",
                "flex_savings": "Flex savings:",
                "days_vacation": "Days vacation:",
                "allocation_of_vacation_days": "Allocation of vacation days",
                "production_unit": "Production unit:",
                "health_insurance": "Health insurance",
                "has_pension": "Pension",
                "kilometer": "Miles",
                "diaeter": "Diets",
                "employee_contribution": "Pension - employee contribution:",
                "company_contribution": "Pension - company contribution:",
                "pension_company": "Pension company:",
                "type": "Pension in:"
            },
            "pension": {
                "header": "Pension",
                "employee_contribution": "Pension - employee contribution:",
                "company_contribution": "Pension - company contribution:",
                "pension_company": "Pension company:",
                "type": "Pension in:",
                "type_option": "Amount",
                "type_percentage": "Percentage",
                "type_selection": "Account no.",
                "type_pbs": "PBS no.",
                "type_account": "Account no.",
                "normal_headline": "Other pension type",
                "company_headline": "Company pension",
                "pension_other": "Other",
                "pension_none": "None",
                "select_pension_company": "Select pension company",
                "amount_warning": "Note that this amount will not change if the employees monthly salary changes. If the pension is accompanied by a salary increase, then choose the percentage."
            },
            "required_with": {
                "employee_contribution": "Required with company contribution and pension company",
                "company_contribution": "Required with employee and company contribution",
                "pension_company": "Required with employee and company contribution"
            },
            "companyPension": {
                "header": "Pension",
                "employee_contribution": "Company pension - employee contribution:",
                "company_contribution": "Company pension - company contribution:",
                "pension_company": "Company pension company:",
                "type": "Company pension in:",
                "type_option": "Amount",
                "type_selection": "Account no.",
                "type_pbs": "PBS no.",
                "type_account": "Account no.",
                "normal_headline": "Other pension type",
                "company_headline": "Company pension",
                "has_pension": "Pension"
            },
            "pensionBank": {
                "bank_reg": "Pension - Bank reg.number:",
                "bank_account": "Pension - Bank account number:",
                "header": "Pension",
                "swift": "SWIFT",
                "iban": "IBAN"
            },
            "companyPensionBank": {
                "bank_reg": "Company pension - Bank reg.number:",
                "bank_account": "Company pension - Bank account number:",
                "header": "Company pension",
                "swift": "SWIFT",
                "iban": "IBAN"
            },
            "user": {
                "header": "User",
                "id": "Select user",
                "create_user": "Create new user",
                "create_info": "Creates a new user with name and email specified under 'Personal'. The employee will receive an email with a password.",
                "assigned_employee": "Assigned to employee"
            },
            "personal": {
                "employment_type": "Employment terms:",
                "first_name": "First name:",
                "last_name": "Last name:",
                "cpr": "CPR number:",
                "email": "Email:",
                "company_id": "Client:",
                "phone_private": "Phone:",
                "phone_cell": "Cell:",
                "job_title": "Job title:",
                "employment_date": "Employment date:",
                "department": "Department:",
                "active": "Active",
                "employee_number": "Employee ID:",
                "header": "Personal",
                "deleted_at": "Deleted"
            },
            "changed": {
                "header": "Latest changes"
            },
            "tooltip": {
                "changes_noted": "Changes on the employee has been registered."
            },
            "termination": {
                "termination_date": "Termination date:",
                "notice_date": "Notice date:",
                "days_vacation_period": "Vacation days in termination period? If no input 0.",
                "header": "Termination",
                "customer_employee_id": "Customer employee id:"
            },
            "optional": {
                "lunch_arrangement": "Lunch arrangement",
                "flex_savings": "Flex savings",
                "days_vacation": "Days vacation",
                "allocation_of_vacation_days": "Allocation of vacation days",
                "production_unit": "Production unit",
                "danmarks_statistik": "Denmark Statistics",
                "header": "Optional",
                "health_insurance": "Health insurance",
                "has_lunch_arrangement": "Lunch arrangement",
                "has_free_car": "Free car",
                "has_pension": "Pension",
                "has_free_phone": "Free phone",
                "kilometer": "Miles",
                "diaeter": "Diets",
                "has_fixed_add_ons": "Fixed add-ons"
            },
            "header": "Type employee information",
            "table": {
                "company_id": "Client Id",
                "checkbox": "Select",
                "full_name": "Full name",
                "employment_date": "Employment date",
                "termination_date": "Termination date",
                "cards_assigned": "Cards assigned",
                "user": "User",
                "changes": "Changes",
                "actions": "Actions"
            },
            "pbs": {
                "pbs": "Pbs number",
                "debtor_group": "Debtor group",
                "accounting_group_id": "Account group"
            },
            "credit_cards": {
                "header": "Cards",
                "assigned": "Credit cards",
                "credit_card": "Create credit card"
            },
            "changes": {
                "change_date": "Change date",
                "employment": "Note that employment details have changed",
                "previous_values": "Previous values",
                "export": "Export changes",
                "no_changes_registered": "No change",
                "past_salary": "There has been a change in the employees monthly salary with retrospective effect: {amount} per {date}"
            },
            "changed_fields": {
                "lunch_arrangement": "Lunch arrangement",
                "flex_savings": "Flex savings",
                "days_vacation": "Days vacation",
                "allocation_of_vacation_days": "Allocation of vacation days",
                "production_unit": "Production unit",
                "danmarks_statistik": "Danmarks statistik",
                "header": "Address",
                "health_insurance": "Health insurance",
                "has_lunch_arrangement": "Lunch arrangement",
                "has_free_car": "Free car",
                "has_pension": "Pension",
                "has_free_phone": "Free phone",
                "kilometer": "Miles",
                "diaeter": "Diets",
                "employment_type": "Employment terms",
                "first_name": "First name",
                "last_name": "Last name",
                "cpr": "CPR number",
                "email": "Email",
                "company_id": "Client",
                "phone_private": "Phone",
                "phone_cell": "Cell",
                "job_title": "Job title",
                "employment_date": "Employment date",
                "department": "Department",
                "active": "Active",
                "employee_number": "Employee ID",
                "deleted_at": "Deleted",
                "bank_reg": "Pension - Bank reg.number",
                "bank_account": "Pension - Bank account number",
                "swift": "SWIFT",
                "iban": "IBAN",
                "employee_contribution": "Company pension - employee contribution",
                "company_contribution": "Company pension - company contribution",
                "pension_company": "Company pension company",
                "type": "Company pension in",
                "type_option": "Amount",
                "type_selection": "Account no.",
                "type_pbs": "PBS no.",
                "type_account": "Account no.",
                "normal_headline": "Other pension type",
                "company_headline": "Company pension",
                "salaried": "Salaried employee",
                "hourly": "Hourly employee",
                "ceo": "Company CEO",
                "b_honorarium_receiver": "B-Honorarmodtager",
                "standard_time": "Hours/week in contract",
                "salary": "Salary/month",
                "free_car_monthly": "Car - Monthly taxable amount",
                "free_car_file": "Leasing contract",
                "free_car_filename": "Leasing contract",
                "free_car_file_description": "Registration number",
                "free_car_file_description_warning": "Leasing contract and registration number must be provided when leasing a car",
                "has_health_insurance": "Health insurance",
                "hourly_rate": "Hourly rate",
                "no_fields": "has no fields",
                "with": "with",
                "weekly_working_hours": "Weekly working hours",
                "weekly_working_days": "Weekly working days",
                "tax_card": "Tax card",
                "primary_tax_card": "Primary",
                "secondary_tax_card": "Secondray",
                "tax_exemption_card": "Tax exemption",
                "dst_time_limited_employment": "Employment type in company",
                "dst_hired_terms": "Employment terms",
                "dst_job_status": "Job status",
                "dst_salary_form": "Salary type",
                "lunch_arrangement_monthly": "Lunch arrangement - Monthly amount",
                "fixed_add_ons_monthly": "Fixed add-ons - Monthly amount",
                "has_fixed_add_ons": "Fixed add-ons",
                "pension": "Pension",
                "disco_code": "Disco-code",
                "health_insurance_monthly": "Health insurance - Monthly amount",
                "free_car_filepath": "Leasing contract - Filepath",
                "time_monday": "Monday",
                "time_tuesday": "Tuesday",
                "time_wednesday": "Wednesday",
                "time_thursday": "Thursday",
                "time_friday": "Friday",
                "time_saturday": "Saturday",
                "time_sunday": "Sunday",
                "address": "Address",
                "address2": "Address 2",
                "postal_code": "Zip/postal code",
                "city": "City",
                "country_code": "Country",
                "pnumber": "Pnumber",
                "work_calendar": "Work calendar",
                "termination_date": "Termination date",
                "notice_date": "Notice date",
                "fixed_add_ons": "Fixed add-ons",
                "amount": "Salary",
                "starts_at": "Salary change valid from"
            },
            "employees": "Employees",
            "pension_type_changed": "Pension type changed"
        },
        "employees-optionals": {
            "table": {
                "id": "Id",
                "name": "Name",
                "flex_savings": "Flex savings",
                "days_vacation": "Days vacation",
                "production_unit": "Production unit",
                "danmarks_statistik": "Danmarks statistik",
                "has_free_car": "Free car",
                "has_free_phone": "Free Phone",
                "has_lunch_arrangement": "Lunch arrangement",
                "has_pension": "Pension",
                "health_insurance": "Health insurance",
                "kilometer": "Miles",
                "diaeter": "Diets",
                "has_fixed_add_ons": "Fixed addons",
                "actions": "Actions"
            },
            "page_header": "Selection of optional fields for employees",
            "update": "Update selections",
            "success": "Please be aware that if you have activated any fields you should fill them out for employees from {company_name}"
        },
        "errors": {
            "403": {
                "title": "Access denied",
                "description": "You do not have the required authorization for this action. Please contact support if you believe this is a mistake."
            },
            "404": {
                "title": "Page not found",
                "description": "The page you are looking for could not be found."
            }
        },
        "fields-company": {
            "table": {
                "headers": {
                    "company_id": "Id",
                    "name": "Name",
                    "fields_company": "Fields"
                }
            },
            "page_header": "Payroll Fields",
            "columns": {
                "units": "Units",
                "rate": "Rate",
                "amount": "Amount",
                "comment": "Comment"
            },
            "extras": {
                "header": "Extras"
            },
            "groups": {
                "timelon": "Hourly etc.",
                "periodisk_tillaeg": "Periodic add-ons",
                "periodisk_fradrag": "Periodic deductions",
                "saerlige_tillaeg": "Special add-ons",
                "personalegoder": "Employee benefits",
                "sygdom": "Ailment",
                "ferie_sh": "Vacation & SH",
                "afspadsering_flex": "Time off in lieu & flex",
                "andet_fravaer": "Other absence",
                "rettelser": "Corrections"
            },
            "names": {
                "timelon_1": "Hourly 1",
                "timelon_2": "Hourly 2",
                "timelon_3": "Hourly 3",
                "timelon_4": "Hourly 4",
                "timelon_5": "Hourly 5",
                "overtid_1": "Overtime 1",
                "overtid_2": "Overtime 2",
                "overtid_3": "Overtime 3",
                "overtid_4": "Overtime 4",
                "overtid_5": "Overtime 5",
                "dage_ferieoptjening": "Dage ferieoptjening",
                "periodisk_tillaeg_1": "Periodic add-on 1",
                "periodisk_tillaeg_2": "Periodic add-on 2",
                "periodisk_tillaeg_3": "Periodic add-on 3",
                "periodisk_tillaeg_4": "Periodic add-on 4",
                "periodisk_tillaeg_5": "Periodic add-on 5",
                "periodisk_fradrag_1": "Periodic deduction 1",
                "periodisk_fradrag_2": "Periodic deduction 2",
                "periodisk_fradrag_3": "Periodic deduction 3",
                "periodisk_fradrag_4": "Periodic deduction 4",
                "periodisk_fradrag_5": "Periodic deduction 5",
                "tantieme": "Tantieme",
                "bestyrelseshonorar": "Board fee",
                "honorar_bidragspligtigt": "Honorar bidragspligtigt",
                "honorar_bidragsfrit": "Honorar bidragsfrit",
                "bidragsfri_a": "Bidragsfri A",
                "jubilaeumsgratiale": "Jubilæumsgratiale",
                "fratraedelsesgodtgorelse": "Fratrædelsesgodtgørelse",
                "diaeter": "Diets",
                "diaeter_udl": "Diets, foreign",
                "kilometerpenge": "Miles",
                "refusion_udlaeg": "Refusion udlæg",
                "ikke_ferieberettiget": "Ikke ferieberettiget",
                "rejsegodtgorelse": "Travel allowance",
                "fri_kost": "Fri kost",
                "sygedagpenge": "Sick pay",
                "sygelon": "Sygeløn",
                "sygeferiepenge": "Sygeferiepenge",
                "sygedage": "Sick days",
                "afholdte_feriedage": "Afholdte feriedage",
                "nettoferiepenge_udb": "Nettoferiepenge paid",
                "ferietillaeg": "Ferietillæg",
                "sh_forskud": "SH advance",
                "sh_hensat_not_neg": "SH hensat",
                "fritvalg_udb": "Fritvalg paid",
                "hensat_afspadsering": "Hensat afspadsering",
                "afholdt_afspadsering": "Afholdt afspadsering",
                "planlagt_flex": "Planned flex",
                "faktisk_flex": "Actual flex",
                "omsorgsdage_udb": "Child care days paid",
                "feriefridage_udb": "Feriefridage paid",
                "ledighedsdage": "Ledighedsdage",
                "a_skat_fradrag_dage": "A-skat fradrag - dage",
                "atp": "ATP",
                "a_skat": "A-skat",
                "gagereduktion": "Salary reduction",
                "ret_a_skat_feriepenge": "Ret A-skat - feriepenge",
                "ret_sh_opspar": "Ret SH accrued",
                "ret_sh_forskud": "Ret SH advance",
                "ret_sh_fritvalg_opspar": "Ret SH fritvalg accrued",
                "ret_sh_fritvalg_brugt": "Ret SH fritvalg brugt"
            }
        },
        "forms": {
            "fetch": "Get",
            "update": "Update",
            "import": "Import",
            "load": "Load",
            "loading": "Loading",
            "number": "Number",
            "remove": "Remove file",
            "files": "Select File",
            "upload": "Upload",
            "re_upload": "Re-upload",
            "final_upload": "Upload final",
            "save": "Save",
            "search": "Search",
            "copied_to_clipboard": "Copied to clipboard",
            "save_and_close": "Save and close",
            "save_changes": "Save changes",
            "file_upload": {
                "success": "{filename} was successfully upload",
                "error": "File was not upload! Please try again"
            },
            "file_delete": {
                "success": "File was deleted",
                "error": "File was not deleted! Please try again"
            },
            "file_import": {
                "success": "Upload to database was successful. {insert_no} {type} were inserted"
            },
            "upload-final": "Finished",
            "upload_file": "Upload csv file",
            "import_file": "Import file to database",
            "approve": "Approve",
            "approved": "Approved",
            "approved-without-customer": "Approved (by Keepers)",
            "uploaded": "Sent to approval",
            "pending": "Pending approval",
            "awaiting": "Awaiting approval",
            "is_final": "Completed",
            "upload-final-without-customer": "Finished (by Keepers)",
            "not_uploaded": "Not uploaded",
            "reject": "Reject",
            "rejected": "Rejected",
            "create": "Create",
            "delete": "Delete",
            "restore": "Restore",
            "deactivate": "Deactivate",
            "activate": "Activate",
            "edit": "Edit",
            "open": "Open",
            "log": "Log",
            "current": "Current",
            "previous_value": "Previous",
            "updated_at": "Updated",
            "field": "Field",
            "export": "Export",
            "required": "* Field is required",
            "send": "Send",
            "unauthorized": "You do not have the required authorization for this action. Please contact us for more information",
            "ok": "OK",
            "close": "Close",
            "yes_no": [
                "No",
                "Yes",
                "Loading"
            ],
            "info": "Info",
            "next": "Next",
            "previous": "Previous",
            "update_pw": "Update your password",
            "update_pw_confirm": "Confirm update of password",
            "password_current": "Current password",
            "password_new": "New password",
            "password_new_confirm": "Confirm new password",
            "deleted": "{name} was deleted",
            "restored": "{name} was restored",
            "deactivated": "{name} was deactivated",
            "activated": "{name} was activated",
            "general": {
                "success": "Changes were saved",
                "error": "Changes were not saved"
            },
            "export_all_changes_title": "Export all changes",
            "export_no_changes": "There are no employee changes",
            "from": "From",
            "to": "To",
            "optional_to": "Optional",
            "note_change": "Changes noted",
            "additional": "And more...",
            "additional_w_num": "And {number} more...",
            "generic_error": "Something went wrong. The error could have occurred because of multiple issues.",
            "possibly": "Possibly the following:",
            "select_all": "Select all",
            "unselect_all": "Unselect all",
            "selected_options": "selected",
            "company_mismatch": "Something went wrong, please reload the page. Contact support if the problem continues.",
            "download_template": "Get template",
            "system_error": "An error occurred. Please try again, and otherwise contact support.",
            "select_placeholder": "Select..",
            "on": "On",
            "off": "Off",
            "no_options": "No options",
            "found_no_options": "No match found",
            "delete_confirmation": {
                "header": "Are you sure?",
                "description": "This action cannot be undone. The data will be permanently deleted.",
                "cancel": "Cancel",
                "continue": "Continue",
                "error": "An error occurred. Please try again, and otherwise contact support.",
                "success": "Data was deleted"
            },
            "yes": "Yes",
            "no": "No",
            "home": "Go to start page",
            "clear_selection": "Clear selection",
            "cancel": "Cancel",
            "is_deleted": "deleted",
            "days_in_week": {
                "monday": "Monday",
                "tuesday": "Tuesday",
                "wednesday": "Wednesday",
                "thursday": "Thursday",
                "friday": "Friday",
                "saturday": "Saturday",
                "sunday": "Sunday"
            },
            "no_results": "No results found for {term}"
        },
        "global-search": {
            "placeholder": "Search",
            "searching": "Searching...",
            "no_results": "No results found"
        },
        "headers": {
            "dashboard": "Welcome {username}",
            "voucher": "Vouchers",
            "upload-statement": "Upload statement",
            "confirm-user": "Confirm creation",
            "salary-data": {
                "id": "Id",
                "first_name": "First name",
                "last_name": "Last name",
                "salary": "Monthly salary",
                "company_contribution": "Pension employer (%)",
                "employee_contribution": "Pension employee (%)",
                "hourly_hours": "Hours (hourly employed)",
                "hourly_rate": "Rate (hourly employed)",
                "b_contribution": "B-contribution",
                "vacation_days": "Vacation days in period",
                "employee_outlay": "Outlay to be paid"
            }
        },
        "help": {
            "vouchers": {
                "btn-help-text": "Need help uploading files?"
            }
        },
        "holiday-pay-obligations": {
            "file_import_warning": "Please note uploading a file overwrites the existing values with the values from the excel file.",
            "file_headers_needed": "The excel file should contain the following column names: Navn, Til import (dage tilgode).",
            "file_formatting_error": "Invalid file format. Please ensure to upload a file in a correct format with the following columns: Nummer and Til import (dage tilgode).",
            "page_header": "Holiday pay provision",
            "create": "Create provision",
            "export": "Export to E-conomic",
            "upload": "Upload provision",
            "missing_employees_text": "Note! The following employees where not found in KC: {employees}",
            "exists_error": "Note! A provision already exists for the given period.",
            "incorrect_employment": "Note! The employee is not a salaried employee.",
            "last_month": "Last month",
            "headers": {
                "id": "Id",
                "year": "Year",
                "month": "Month",
                "num_of_employees": "Number of employees",
                "file_actions": "File",
                "actions": "Open"
            },
            "entries": {
                "page_header": "Holiday pay provision for employee",
                "headers": {
                    "id": "Id",
                    "number": "Employee number",
                    "name": "Employee",
                    "department": "Department",
                    "days_outstanding": "Days in favour",
                    "basic_salary": "Base salary",
                    "obligation": "Current provision (DKK)",
                    "last_months_obligation": "Last month",
                    "export_difference": "Difference"
                },
                "tooltip": {
                    "basic_salary": {
                        "salary": "Salary",
                        "fixed_add_ons": "Fixed add-ons",
                        "company_pension": "Company pension",
                        "free_car_monthly": "Free car",
                        "free_phone_monthly": "Free phone",
                        "company_atp": "Company ATP",
                        "health_insurance_monthly": "Health insurance"
                    },
                    "obligation": {
                        "basic_salary": "Base salary",
                        "days_outstanding": "Days in favour",
                        "work_days": "Work days"
                    }
                },
                "economic": {
                    "pl_account": "P&L account",
                    "balance_sheet_account": "Balance sheet account",
                    "export": {
                        "title": "Eksport holiday pay provision",
                        "content": "Are you sure you want to export the holiday pay provision?",
                        "completed": "E-conomic export was completed."
                    }
                }
            }
        },
        "holidays": {
            "table": {
                "id": "Id",
                "name": "Name",
                "date": "Date",
                "actions": "Actions"
            },
            "page_header": "Holidays",
            "delete": {
                "title": "Delete holiday",
                "content": "Are you sure that you want to delete this holiday?"
            },
            "create": "Create holiday",
            "update": "Update holiday",
            "error_date_format": "Error in date format. Please type the date in the format dd/mm/yyyy."
        },
        "kube": {
            "table": {
                "id": "Id",
                "name": "Name",
                "number": "Number",
                "actions": "Actions"
            },
            "page_header": "Kube data fields",
            "delete": {
                "title": "Delete data field",
                "content": "Are you sure that you want to delete this data field?"
            },
            "create": "Create data field",
            "update": "Update data field",
            "create_kube": "Add data field",
            "edit": "Edit data field",
            "form": {
                "name": "Name of data field",
                "number": "Number of data field"
            }
        },
        "mails": {
            "voucher": {
                "headers": {
                    "amount": "Amount",
                    "text": "Text",
                    "voucher_no": "Number"
                },
                "list_info_txt": "There are <strong>{count}</strong> vouchers that need to be sent in for {company} to Keepers.",
                "deadline": "Please note that the deadline is in <strong>{daysToDeadline} days</strong>, on",
                "delivery_details": "Missing vouchers are to be sent in via Keepers' customer centre.",
                "btn": "Click to upload voucher",
                "subject": "Keepers - Upload vouchers",
                "overdue": {
                    "subject": "Keepers - Overdue vouchers",
                    "deadline": "Please note that upload of the vouchers are overdue by <strong>{daysOverdue} days</strong>, as deadline was"
                }
            },
            "salary": {
                "delivery_details": "Payrolls should be approved via Keepers' customer centre.",
                "subject": "Keepers - Deadline for salary",
                "btn": "Click to approve payroll",
                "payroll_details": "Payroll for {month}/{year} is yet to be approved"
            },
            "user": {
                "description": "A user was created for you at Keepers. Please click the link below to finish the sign-up process of your user by creating a password. ",
                "greeting": "Dear {username}",
                "link": "Click here to log in"
            },
            "resets": {
                "msg": "Hi {name}. You have told us that you have forgotten your Keepers password. Don't worry, click the link below to change it.",
                "expire_text": "Please note that this link expires after five days.",
                "subject": "Keepers - New password",
                "title": "Reset password"
            },
            "user_created": {
                "subject": "Keepers - User created"
            },
            "success": "Mail was successfully sent",
            "monthly_close_procedures": {
                "subject": "Deadline for monthly close procedures",
                "title": "Please note that the deadline for monthly close procedures is now",
                "description": "This concerns the following procedures:",
                "btn": "Click for more details"
            },
            "mention_in_comment": {
                "subject": "{user} mentioned you in a comment.",
                "greeting": "Hello,",
                "introduction": "{user} mentioned you in a comment on the company {company}:",
                "comment": "{comment}",
                "action": "Go to dashboard"
            }
        },
        "menu": {
            "settings": "Settings",
            "logout": "Log out",
            "dashboard": "Dashboard",
            "dashboards": "Dashboards",
            "salary": "Salary",
            "payrolls": "Payrolls",
            "pay_slips": "Pay Slips",
            "salary_setup": "Salary Setup",
            "employees": "Employees",
            "vouchers": "Vouchers",
            "voucher": "Vouchers",
            "administration": "Administration",
            "companies": "Companies",
            "users": "Users",
            "power_bi": "Power BI",
            "power_bi_settings": "BI Mapping",
            "system": "System",
            "activities": "Activities",
            "translations": "Translations",
            "bi_and_companies": "BI Mapping",
            "bi_client": "BI Mapping",
            "fields_company": "Payroll fields",
            "employees-optionals": "Optional fields on employees",
            "status": "Payroll status",
            "holidays": "Holidays",
            "roles": "Roles",
            "economic-period": "Economic Periods",
            "work-calendars": "Work Calendars",
            "task-templates": "Task Templates",
            "holiday-pay-obligations": "Holiday pay provision",
            "help": "Send a mail to support@keepers.dk for help",
            "help_desk": "Support",
            "payroll_activity_log": "Activity log",
            "vat": "VAT",
            "bank": "Bank",
            "actuate": "Actuate",
            "support": "Support",
            "customer_employees": "Employees",
            "outlay": "Outlay",
            "corpay_one": "Corpay One",
            "customer_dashboard": "Customer Dashboard",
            "employee_dashboard": "Employee Dashboard",
            "pay_setup": "Pay Setup",
            "credit_cards": "Credit Cards",
            "onboarding": "Onboarding",
            "power_bi_dashboard": "Dashboard",
            "power_bi_mapping": "Mapping",
            "choose_client": "Please choose a client"
        },
        "month-picker": {
            "year": "Year",
            "prevYear": "Previous Year",
            "nextYear": "Next Year",
            "next12Years": "Jump Forward 12 Years",
            "prev12Years": "Jump Back 12 Years",
            "nextLabel": "Next",
            "prevLabel": "Prev",
            "buttonText": "Open Month Chooser",
            "jumpYears": "Jump Years",
            "backTo": "Back to",
            "months": [
                "Jan.",
                "Feb.",
                "Mar.",
                "Apr.",
                "May",
                "June",
                "July",
                "Aug.",
                "Sep.",
                "Oct.",
                "Nov.",
                "Dec."
            ]
        },
        "months": {
            "january": "January",
            "february": "February",
            "march": "March",
            "april": "April",
            "may": "May",
            "june": "June",
            "july": "July",
            "august": "August",
            "september": "September",
            "october": "October",
            "november": "November",
            "december": "December"
        },
        "onboarding": {
            "page_header": "Onboarding flow",
            "create_step": "Create onboarding step",
            "edit_step": "Edit onboarding step",
            "status_update_failed": "Status update failed",
            "delete": {
                "title": "Are you sure you want to delete this onboarding step?"
            },
            "download": {
                "title": "Download attachments ({count})"
            },
            "table": {
                "service": "Service",
                "description": "Description",
                "comment": "Comment",
                "files": "Attachments",
                "status": "Status"
            },
            "services": {
                "e-conomic": "E-conomic",
                "vat": "VAT",
                "e-income": "eIncome",
                "salary": "Salary",
                "bank": "Bank",
                "other": "Other"
            },
            "statuses": {
                "pending": "Awaiting response",
                "completed": "Yes",
                "rejected": "No"
            },
            "form": {
                "service": "Service",
                "title": "Service name",
                "description": "Description",
                "description_placeholder": "Ex. Confirm that Keepers has received access to..",
                "allow_comments": "Allow text field",
                "allow_files": "Allow file uploads"
            },
            "guide": {
                "title": "Onboarding - connection status"
            },
            "assistant": {
                "title": "System access",
                "completed": "We now have everything we need. You can now continue using the customer portal platform."
            },
            "steps_intro": {
                "title": "Hello {name}",
                "subtitle": "Welcome to Keepers",
                "content": "We are excited to have you on board and look forward to supporting you with your accounting needs. To ensure we can help you in the best possible way, we need to go through some steps where you confirm that we have the necessary access to the following systems:",
                "button": "Let's begin"
            },
            "steps_intro_missing": {
                "title": "Hello again, {name}",
                "subtitle": "We need access to one or more systems",
                "content": "To ensure we can help you in the best possible way, we need to go through the steps where we are missing something from you. If you have any questions, you are of course welcome to contact us.",
                "skip": "Skip",
                "button": "Continue"
            },
            "steps": {
                "e-conomic": {
                    "title": "E-conomic",
                    "description": "Confirm that you have given Keepers access to your E-conomic account so we can handle your accounting data.",
                    "accept": [
                        "Yes - Keepers has been given access to our e-conomic account",
                        "Keepers should create an e-conomic agreement for us"
                    ],
                    "reject": "No - Keepers has not yet received access to our e-conomic account"
                },
                "vat": {
                    "title": "VAT",
                    "description": "Confirm that you have given Keepers access to your VAT information via SKAT so we can help with VAT settlements.",
                    "accept": [
                        "Yes - we have given Keepers access to our VAT information"
                    ],
                    "reject": "No - we have not yet given Keepers access to our VAT information",
                    "give_access": "Give Keepers access to VAT"
                },
                "e-income": {
                    "title": "eIncome",
                    "description": "Confirm that Keepers has access to eIncome via SKAT so we can report payroll data correctly.",
                    "accept": [
                        "Yes - we have given Keepers access to our eIncome"
                    ],
                    "reject": "No - we have not yet given Keepers access to eIncome",
                    "give_access": "Give Keepers access to eIncome via SKAT"
                },
                "salary": {
                    "title": "Salary",
                    "description": "Confirm that Keepers has received access to your payroll system so we can ensure correct payroll processing and reporting.",
                    "accept": [
                        "Yes - we have given Keepers access to our payroll system",
                        "Keepers should set up a payroll system for us"
                    ],
                    "reject": "No - we have not yet given Keepers access to our payroll system"
                },
                "bank": {
                    "title": "Bank",
                    "description": "Confirm that Keepers has the necessary permissions to access your bank information for bookkeeping and reconciliation.",
                    "accept": [
                        "Yes - we have given Keepers access to our bank"
                    ],
                    "reject": "No - we have not yet given Keepers access to our bank"
                },
                "other": {
                    "title": "Other",
                    "accept": [
                        "Yes - I have now given Keepers access to other systems"
                    ],
                    "reject": "No - I have not given Keepers access to other systems",
                    "description": ""
                }
            },
            "steps_completed": {
                "title": "Thank you for your information!",
                "subtitle": "You can now continue to the customer portal platform.",
                "button": "Go to customer portal"
            },
            "steps_completed_missing": {
                "title": "Thank you for your information!",
                "subtitle": "We need access to one or more systems",
                "content": "We have noted that we still need access to one or more systems. We kindly ask you to give Keepers the necessary access as soon as possible. This concerns the following:",
                "back": "Back",
                "button": "Go to customer portal"
            },
            "next": "Next",
            "back": "Back",
            "close": "Close",
            "complete": "Complete",
            "help": "Help",
            "help_title": "How to do it",
            "comment": "Comments",
            "files": "Upload attachments"
        },
        "outlay": {
            "company": {
                "missing_integration": "Kunne ikke finde Outlay for den angivne virksomhed",
                "no_client_selected": "Vælg venligst en kunde"
            },
            "invalid_token": "Koden er ugyldig",
            "validation": {
                "phone": {
                    "required": "Telefonnummer er påkrævet.",
                    "integer": "Telefonnummer er ugyldigt.",
                    "digits": "Telefonnummer skal være på præcist 8 tal og uden mellemrum."
                }
            },
            "connect": {
                "title": "Forbind denne konto med din Outlay konto ved at logge ind.",
                "subtitle": "Du giver herved Keepers tilladelse til at tilgå data fra din Outlay konto.",
                "invalid_credentials": "E-Mail eller adgangskode er forkert."
            }
        },
        "passwords": {
            "change": "Change password",
            "sent": "We have e-mailed your password reset link!",
            "user": "We can't find a user with that e-mail address."
        },
        "pay-slips": {
            "delete": "Delete payslips",
            "headers": {
                "upload": "Upload payslips"
            },
            "reminder-text": "Send reminder",
            "last_sent": "Last sent",
            "comment": "Comment",
            "upload_final": "Upload final",
            "upload": "Upload",
            "upload_consent": "I understand that I am uploading payslips for {name}",
            "approve": "Approve",
            "awaiting_approval": "Awaiting your approval",
            "awaiting_other_approver": "Awaiting other approver",
            "show_comment": "Show comment",
            "open": "Open",
            "reject": "Reject",
            "mail": {
                "headers": {
                    "month": "Month",
                    "year": "Year",
                    "status": "Status",
                    "type": "Type",
                    "num_of_employees": "No. Of employees",
                    "created_at": "Created at"
                },
                "subject": "Payslips - {company}",
                "btn": "Click to approve",
                "info": "Please find more information about current pay slips in the overview below:",
                "info-approval": "There are payslips for approval for {company} at Keepers.",
                "info-done": "There are payslips finished for {company} at Keepers."
            },
            "response-mail": {
                "title": "Payslips for {company}",
                "body": "{user} has {status} payslips for {period}",
                "subject": "payslips {status} - {company}",
                "btn": "Click to go to overview",
                "comment": "with the following comment {comment}"
            },
            "confirm": {
                "involved": "Remind the customer about the following payslips:",
                "confirm": "Are you sure you want to send a reminder?",
                "yes": "Yes",
                "no": "No",
                "title": "Send reminder for approval of payslips",
                "error": "No payslips chosen. Please choose one or more in order to send reminder",
                "last_reminded_at": "Last reminded at: ",
                "comment": "Attach comment"
            },
            "toggle_sent": {
                "title": "Payslips sent to Nets/Bank",
                "confirm": "Have the payslips been sent to Nets/Bank?",
                "warning": "Please note the payslips have not been approved yet! Are you sure you want to approve circumvent the approval of payslips?"
            },
            "no-comments": "No comments"
        },
        "payrolls": {
            "page_header": "Payroll",
            "payroll_header": "Payroll",
            "mail": {
                "subject": "{company} have approved payroll",
                "body": "{company} have finished preparing the payroll for {period}. Click on the link below to go to the overview. Here you can download a csv file for Danløn",
                "title": "Payroll approved by {user}"
            },
            "filter": "Filtrer",
            "grouping": {
                "open": "Open",
                "closed": "Closed",
                "all": "All"
            },
            "existing": {
                "data_updated": "Updated",
                "data_not_updated": "Not updated",
                "headers": {
                    "id": "Id",
                    "year": "Year",
                    "month": "Month",
                    "type": "Type",
                    "num_of_employees": "Number of employees",
                    "approved_by": "Approved by",
                    "payslip_approved_by": "Payroll approved by",
                    "last_reminded_at": "Last reminded",
                    "payslip_actions": "Payslips",
                    "actions": "Payroll"
                },
                "not_approved": "Not approved",
                "no_data_fields": "{company} needs to be set up. Please add payroll fields before creating payrolls.",
                "no_honorarium_fields": "Honorar payrolls require one or more of the following fields selected: Bestyrelseshonorar, Honorar bidragspligt, Honorar bidragsfrit, Refusion udlæg."
            },
            "edit": {
                "header": "Payroll for {company}",
                "unlock": "Undo approval",
                "approval_denied": "Payroll was not approved. Please find in the table lines that need to be updated",
                "approval_not_sent": "Payroll was not sent to approval. Please check that everything was filled out correctly",
                "approve": "Approve payroll",
                "approved": "Payroll was approved",
                "approved_text": "Approved",
                "blueprint": "Format",
                "choose": "Choose format",
                "comment": "* Write a comment",
                "comment_from_customer": "Comment from {customer}",
                "create": "Create payroll",
                "created_info_exists": "Payroll for this month has already been created. Please find it in the table below",
                "created_success": "Payroll was created. Please find it in the table.",
                "download": "Export to Danløn",
                "edit": "Edit existing payroll",
                "mintues_short": "mins",
                "summary": "Overview",
                "help-text": "Please fill out the below with precise information.",
                "help-text-table": "Please fill out the table with precise information.",
                "help-text-bold": "Keepers cannot be held responsible for the correctness of the information and only performs sanity checks on the payroll.",
                "awaiting-text": "The payroll has been sent to a Keepers employee. When the payroll has been processed you can find the payslips under <a class=\"btn btn-primary btn-flat btn-icon\" href=\"{url}\">\"Payrolls\"</a> in the menu under \"Salary\".",
                "awaiting-text-table": "The payroll has been sent to a Keepers employee. When the payroll has been processed you can find the payslips under \"Payrolls\" in the menu under \"Salary\".",
                "not_allowed": "The payroll was not deleted because the payroll has already been approved.",
                "not_approved_text": "Not approved",
                "open": "Open",
                "send_to_approval": "Send to approval",
                "sent_to_approval": "The payroll was sent to approval.",
                "sheets": "Payrolls",
                "updated_success": "Employee information was saved",
                "months": {
                    "1": "January",
                    "2": "February",
                    "3": "March",
                    "4": "April",
                    "5": "May",
                    "6": "June",
                    "7": "July",
                    "8": "August",
                    "9": "September",
                    "10": "October",
                    "11": "November",
                    "12": "December"
                },
                "lunch_arrangement_modal": {
                    "title": "Lunch arrangement updated",
                    "header": "Lunch arrangement",
                    "body_1": "Lunch arrangement has been updated for",
                    "body_2": "do you wish to update the amount for lunch arrangement on master data for this employee?",
                    "cancel": "Cancel",
                    "confirm": "Update"
                },
                "fixed_add_ons_modal": {
                    "title": "Fixed add-ons updated",
                    "header": "Fixed add-ons",
                    "body_1": "Fixed add-ons has been updated for",
                    "body_2": "do you wish to update the amount for fixed add-ons on master data for this employee?",
                    "cancel": "Cancel",
                    "confirm": "Update"
                },
                "hourly_rate_modal": {
                    "title": "Hourly rate updated",
                    "header": "Hourly rate",
                    "body_1": "Hourly rate has been updated for",
                    "body_2": "do you wish to update the hourly rate on master data for this employee?",
                    "cancel": "Cancel",
                    "confirm": "Update"
                },
                "modal": {
                    "title": "Monthly salary updated",
                    "header": "Payroll",
                    "body_1": "Monthly salary has been updated for",
                    "body_2": "do you wish to update the monthly salary on master data for this employee?",
                    "cancel": "Cancel",
                    "confirm": "Update"
                },
                "employee_already_in_payroll": "Employee is already in payroll",
                "employee_added_to_payroll": "Employee was added to payroll",
                "select_employee_to_add": "No employee selected. Action was not performed",
                "no_employee_selected": "No employee selected. Please select an employee",
                "upload": "Upload to {format}",
                "download_excel": "Download excel",
                "employee": "Employee:"
            },
            "table": {
                "headers": {
                    "id": "Id",
                    "first_name": "First name",
                    "last_name": "Last name",
                    "employment_details": "Employment details",
                    "status": "Status",
                    "employee_total": "Employee estimate",
                    "actions": "Actions"
                }
            },
            "unlock": {
                "confirm": "Are you sure?",
                "yes": "Yes",
                "no": "No",
                "title": "Undo approval of payroll."
            },
            "summary": {
                "company": "Company:",
                "data": "data",
                "summary": "overview",
                "title": "Payroll",
                "month": "Month:",
                "year": "Year:",
                "approved": "Payroll was approved by:",
                "total": "Total payroll expense estimated in period:",
                "approved_user_name": "Payroll was approved by: {username}",
                "num_of_employees": "Employee count:",
                "employees": "employee(s)",
                "updated_at": "Updated at:"
            },
            "no_salary": "<h5>Does not have salary</h5>",
            "missing_deadline": "Missing deadline",
            "other_buttons": {
                "create_employee": "Create employee",
                "add_employee_to_payroll": "Add employees to payroll",
                "remove_employee_from_payroll": "Remove employee from payroll"
            },
            "add_employee_to_payroll": {
                "header": "Add employees to payroll",
                "employees": "Employees",
                "add_employee": "Add employee",
                "select_employee": "Select employee"
            },
            "remove_employee_from_payroll": {
                "header": "Remove employee from payroll",
                "employees": "Employees",
                "remove_employee": "Remove employee",
                "select_employee": "Select employee",
                "terminate": "Terminate employee",
                "employee_not_found": "No employee selected."
            },
            "no_negative_value": "Values must not be negative",
            "changes": {
                "confirm_1": "The following employees have not had their information updated:",
                "confirm_2": "Do you still want to approve the payroll?"
            },
            "deleted": {
                "success": "Payroll was deleted"
            },
            "activity_log": {
                "header": "Payroll log for {company}",
                "actions": {
                    "payroll_created": "Payroll created",
                    "show_payroll": "Show payroll",
                    "comment_add_to_employee": "Comment added to employee",
                    "payroll_unlocked": "Payroll unlocked",
                    "payroll_approved": "Payroll sent to approval",
                    "payroll_field_changed": "Payroll field changed",
                    "employee_removed": "Employee removed from payroll"
                },
                "table_headers": [
                    "Date",
                    "Subject",
                    "User",
                    "Description",
                    "Content"
                ],
                "table": {
                    "date": "Date",
                    "subject": "Subject",
                    "user": "User",
                    "description": "Description",
                    "content": "Content"
                }
            }
        },
        "payslips_log": {
            "entries": {
                "page_header": "Payslips log",
                "headers": {
                    "company_name": "Company",
                    "month": "Month",
                    "year": "Year",
                    "description": "Status",
                    "user_name": "Approver",
                    "type": "Type",
                    "date_created": "Date approved"
                }
            }
        },
        "permissions": {
            "crud_with_group": {
                "view": "View {group}",
                "create": "Create {group}",
                "update": "Update {group}",
                "delete": "Delete {group}"
            },
            "crud": {
                "view": "View",
                "create": "Create",
                "update": "Update",
                "delete": "Delete",
                "crud": "View-Create-Update-Delete",
                "payslips-log": "Download pdf of payslips log",
                "receive-notifications": "Receive notifications",
                "receive-invite": "Receive invite",
                "update-status": "Update status",
                "search": "Search",
                "administrate-cards": "Administrate voucher cards",
                "administrate-fallback": "Administrate voucher fallback",
                "dimensions-view": "View voucher dimensions",
                "share-global": "Share views"
            },
            "groups": {
                "users": {
                    "name": "Users",
                    "description": ""
                },
                "companies": {
                    "name": "Companies",
                    "description": ""
                },
                "roles": {
                    "name": "Roles",
                    "description": ""
                },
                "holidays": {
                    "name": "Holidays",
                    "description": ""
                },
                "powerbi": {
                    "name": "Power BI",
                    "description": ""
                },
                "powerbi-setup": {
                    "name": "Power BI setup",
                    "description": ""
                },
                "translations": {
                    "name": "Translations",
                    "description": ""
                },
                "system": {
                    "name": "System",
                    "description": ""
                },
                "dashboard": {
                    "name": "Dashboard",
                    "description": ""
                },
                "dashboard-admin": {
                    "name": "Dashboard admin",
                    "description": ""
                },
                "vouchers": {
                    "name": "Vouchers",
                    "description": ""
                },
                "vouchers-admin": {
                    "name": "Vouchers admin",
                    "description": ""
                },
                "vouchers-own": {
                    "name": "Vouchers (own)",
                    "description": ""
                },
                "activities": {
                    "name": "Activities",
                    "description": ""
                },
                "kube": {
                    "name": "Kube",
                    "description": ""
                },
                "employees": {
                    "name": "Employees",
                    "description": ""
                },
                "salary-payrolls": {
                    "name": "Salary - Payrolls",
                    "description": ""
                },
                "salary-payslips": {
                    "name": "Salary - Payslips",
                    "description": ""
                },
                "salary-company": {
                    "name": "Salary - Data setup",
                    "description": ""
                },
                "salary-status": {
                    "name": "Salary - Status",
                    "description": ""
                },
                "keepers-companies": {
                    "name": "Keepers companies",
                    "description": "Access to associating employees with Keepers companies"
                },
                "economic-period": {
                    "name": "Economic-periods",
                    "description": "Status of periods and year"
                },
                "work-calendars": {
                    "name": "Work-calendars",
                    "description": "Access to work calendars"
                },
                "task-templates": {
                    "name": "Task templates",
                    "description": ""
                },
                "vouchers-earlier-releases": {
                    "name": "Vouchers: Earlier releases",
                    "description": "Access to earlier released vouchers"
                },
                "bank-module": {
                    "name": "Bank module",
                    "description": "Access to the bank module"
                },
                "holiday-pay-obligations": {
                    "name": "Holiday pay provision",
                    "description": "Access to Holiday pay provision"
                },
                "employees-import": {
                    "name": "Upload of employees",
                    "description": "Access to upload of employees from excel file"
                },
                "employees-admin-import": {
                    "name": "Upload of employees (Admin)",
                    "description": "Access to upload of employees from excel file (Admin)"
                },
                "vat": {
                    "name": "VAT",
                    "description": "Access to VAT module"
                },
                "credit-cards": {
                    "name": "Credit cards",
                    "description": "Access to credit cards"
                },
                "onboarding": {
                    "name": "Onboarding",
                    "description": "Access to onboarding"
                },
                "global-search": {
                    "name": "Global Search",
                    "description": "Access to global search"
                },
                "outlay": {
                    "name": "Outlay",
                    "description": "Access to Outlay login menu"
                },
                "payslips-log": {
                    "name": "Payslips log",
                    "description": "Access to payslips log"
                },
                "notifications": {
                    "name": "Notifications",
                    "description": ""
                }
            }
        },
        "power_bi": {
            "missing_workspace_id": "Missing Workspace ID!",
            "choose_company": "Please choose company...",
            "no_power_bi_data_found": "No Power BI data found",
            "please_contact_support": "Please contact support",
            "error_fetching_power_bi_data": "Error fetching Power BI data",
            "power_bi_reports": "BI reports",
            "create_power_bi_report": "Add BI report account",
            "upload_power_bi_report": "Upload CSV"
        },
        "procedures": {
            "table": {
                "deadline": "Deadline",
                "deadline_text": "Deadline",
                "task": "Task",
                "responsible": "Responsible"
            },
            "deadline_text": "{day}. work day in month"
        },
        "profile": {
            "picture_upload": "Please be aware that if you upload a new profile picture your current one will be overwritten.",
            "page_header": "Personal settings",
            "edit_picture": "Add/Edit Profile picture",
            "edit_profile": "Edit your info",
            "save_success": "Your information was saved",
            "upload_failed": "The file was not removed or changed...",
            "failed": "Upload failed",
            "your_information": "Your information",
            "update_password": "Update password",
            "profile_settings": "Profile settings",
            "picture_upload_success": "Profile picture updated",
            "picture_upload_failed": "Profile picture upload failed",
            "picture_upload_error": "The image you are trying to upload is too large. Please try with a smaller image."
        },
        "roger-ai": {
            "teams": {
                "missing": "Note! {kc_name} was not found in Corpay One. You are logged in to Corpay One with {roger_name}"
            },
            "login": {
                "successful": "You are now logged in to Corpay One",
                "credential_error": "E-Mail address or password is wrong",
                "unknown_error": "Error, please contact support",
                "invalid_token": "Error, please contact support",
                "user_not_approved": "Error, user is not approved yet. Please contact support if the error persists."
            },
            "loading-teams": "Loading your Corpay One data. This can take a moment."
        },
        "roles": {
            "table": {
                "id": "Id",
                "permissions": "Permissions",
                "companies": "Companies",
                "name": "Name",
                "display_name": "Display name",
                "description": "Description",
                "is_client_text": "Client role",
                "permissions_text": "Permissions",
                "companies_text": "Companies",
                "actions": "Actions"
            },
            "page_header": "Roles",
            "delete": {
                "title": "Delete role",
                "content": "Are you sure that you want to delete this role? Warning! If the role is associated to a user, the user might no longer have a role."
            },
            "create": "Create role",
            "edit": "Edit role",
            "update": "Update role",
            "select": {
                "permissions": {
                    "placeholder": "Select Permissions",
                    "search_options": {
                        "default": "Search Permissions"
                    }
                },
                "companies": {
                    "placeholder": "Select Companies",
                    "search_options": {
                        "default": "Search Companies"
                    }
                },
                "roles": {
                    "placeholder": "Select Roles",
                    "search_options": {
                        "default": "Search Roles"
                    }
                },
                "texts": {
                    "placeholder": "Select options",
                    "search": "Search",
                    "selectedOptions": " selected",
                    "selectAll": "Select all",
                    "unselectAll": "Unselect all",
                    "noneSelected": "None selected"
                }
            },
            "general_tab_text": "General information",
            "permissions_tab_text": "Permissions"
        },
        "salary": {
            "payroll": {
                "not_updated": "Not updated",
                "month": "Month",
                "year": "Year",
                "type": "Type",
                "employees": "Employees",
                "updated": "Updated",
                "add_comment": "Add comment",
                "comment": "Comment",
                "remove": "Remove",
                "change_comment": "Edit comment",
                "show_comment": "Show comment",
                "comment_success": "Comment updated",
                "remove_employee": "Remove employee from payroll?",
                "are_you_sure": "Are you sure you want to remove the employee from the payroll?",
                "yes_and_remove": "Yes, and terminate",
                "cancel": "Cancel",
                "terminate": "Terminate",
                "create": "Create Payroll",
                "start": "Create Payroll",
                "table_headings": {
                    "gage_amount": "Monthly salary",
                    "timelon_2_units": "Hours",
                    "timelon_2_rate": "Rate",
                    "timelon_2_amount": "Total salary",
                    "timelon_3_units": "Hours 3",
                    "timelon_3_rate": "Rate 3",
                    "timelon_3_amount": "Total salary 3",
                    "timelon_4_units": "Hours 4",
                    "timelon_4_rate": "Rate 4",
                    "timelon_4_amount": "Total salary 4",
                    "timelon_5_units": "Hours 5",
                    "timelon_5_rate": "Rate 5",
                    "timelon_5_amount": "Total salary 5",
                    "overtid_1_units": "Overtime Hours",
                    "overtid_1_rate": "Overtime Rate",
                    "overtid_1_amount": "Overtime Total salary",
                    "overtid_2_units": "Overtime Hours 2",
                    "overtid_2_rate": "Overtime Rate 2",
                    "overtid_2_amount": "Overtime Total salary 2",
                    "overtid_3_units": "Overtime Hours 3",
                    "overtid_3_rate": "Overtime Rate 3",
                    "overtid_3_amount": "Overtime Total salary 3",
                    "overtid_4_units": "Overtime Hours 4",
                    "overtid_4_rate": "Overtime Rate 4",
                    "overtid_4_amount": "Overtime Total salary 4",
                    "overtid_5_units": "Overtime Hours 5",
                    "overtid_5_rate": "Overtime Rate 5",
                    "overtid_5_amount": "Overtime Total salary 5",
                    "periodisk_tillaeg_1_units": "Periodical Add-on Hours",
                    "periodisk_tillaeg_1_rate": "Periodical Add-on Rate",
                    "periodisk_tillaeg_1_amount": "Periodical Add-on Total salary",
                    "periodisk_tillaeg_2_units": "Periodical Add-on Hours 2",
                    "periodisk_tillaeg_2_rate": "Periodical Add-on Rate 2",
                    "periodisk_tillaeg_2_amount": "Periodical Add-on Total salary 2",
                    "periodisk_tillaeg_3_units": "Periodical Add-on Hours 3",
                    "periodisk_tillaeg_3_rate": "Periodical Add-on Rate 3",
                    "periodisk_tillaeg_3_amount": "Periodical Add-on Total salary 3",
                    "periodisk_tillaeg_4_units": "Periodical Add-on Hours 4",
                    "periodisk_tillaeg_4_rate": "Periodical Add-on Rate 4",
                    "periodisk_tillaeg_4_amount": "Periodical Add-on Total salary 4",
                    "periodisk_tillaeg_5_units": "Periodical Add-on Hours 5",
                    "periodisk_tillaeg_5_rate": "Periodical Add-on Rate 5",
                    "periodisk_tillaeg_5_amount": "Periodical Add-on Total salary 5",
                    "periodisk_fradrag_1_amount": "Periodical Deduction Total salary",
                    "periodisk_fradrag_2_amount": "Periodical Deduction Total salary 2",
                    "periodisk_fradrag_3_amount": "Periodical Deduction Total salary 3",
                    "periodisk_fradrag_4_amount": "Periodical Deduction Total salary 4",
                    "periodisk_fradrag_5_amount": "Periodical Deduction Total salary 5",
                    "tantieme_amount": "Tantieme",
                    "bestyrelseshonorar_amount": "Board Fee",
                    "honorar_bidragspligtigt_amount": "B-honorarium",
                    "honorar_bidragsfrit_amount": "B-honorarium (free)",
                    "bidragsfri_a_amount": "A-Contributory",
                    "jubilaeumsgratiale_amount": "Anniversary Bonus",
                    "fratraedelsesgodtgorelse_amount": "Severance Pay",
                    "diaeter_units": "Diets Units",
                    "diaeter_rate": "Diets Rate",
                    "diaeter_amount": "Diets Amount",
                    "diaeter_udl_amount": "Diets, foreign",
                    "diaeter_kroner_amount": "Diets in dkk",
                    "kilometerpenge_units": "Miles",
                    "kilometerpenge_amount": "Miles",
                    "refusion_udlaeg_amount": "Outlay Reimbursement",
                    "ikke_ferieberettiget_amount": "Non Holiday Eligible Salary",
                    "rejsegodtgorelse_units": "Travel Allowance Units",
                    "rejsegodtgorelse_rate": "Travel Allowance Rate",
                    "rejsegodtgorelse_amount": "Travel Allowance Amount",
                    "fri_kost_units": "Free Food Units",
                    "fri_kost_rate": "Free Food Rate",
                    "fri_kost_amount": "Free Food Amount",
                    "sygedagpenge_units": "Sick Pay Units",
                    "sygedagpenge_rate": "Sick Pay Rate",
                    "sygedagpenge_amount": "Sick Pay Amount",
                    "sygelon_units": "Sick Salary Units",
                    "sygelon_rate": "Sick Salary Rate",
                    "sygelon_amount": "Sick Salary Amount",
                    "sygeferiepenge_amount": "Sick Vacation Salary",
                    "sygedage_units": "Sick Days",
                    "afholdte_feriedage_units": "Vacation days",
                    "nettoferiepenge_udb_amount": "Netto Vacation Salary Paid",
                    "ferietillaeg_amount": "Vacation Supplement",
                    "sh_forskud_units": "SH Advance Units",
                    "sh_forskud_rate": "SH Advance Rate",
                    "sh_forskud_amount": "SH Advance Amount",
                    "sh_hensat_not_neg_amount": "SH Provisioned",
                    "fritvalg_udb_amount": "Fritvalg paid",
                    "hensat_afspadsering_units": "Provisioned Time Off Units",
                    "hensat_afspadsering_amount": "Provisioned Time Off Amount",
                    "afholdt_afspadsering_units": "Time Off Units",
                    "afholdt_afspadsering_amount": "Time Off Amount",
                    "planlagt_flex_units": "Planned Flex",
                    "faktisk_flex_units": "Actual Flex",
                    "omsorgsdage_udb_units": "Child Care Days paid Units",
                    "omsorgsdage_udb_rate": "Child Care Days paid Rate",
                    "omsorgsdage_udb_amount": "Child Care Days paid Amount",
                    "feriefridage_udb_units": "Vacation Days Paid Units",
                    "feriefridage_udb_rate": "Vacation Days Paid Rate",
                    "feriefridage_udb_amount": "Vacation Days Paid Amount",
                    "ledighedsdage_units": "Ledighedsdage Units",
                    "ledighedsdage_rate": "Ledighedsdage Rate",
                    "ledighedsdage_amount": "Ledighedsdage Amount",
                    "a_skat_fradrag_dage_units": "A-Tax Deduction - Days",
                    "atp_units": "ATP Units",
                    "atp_amount": "ATP Amount",
                    "a_skat_amount": "A-Tax",
                    "gagereduktion_amount": "Salary Reduction",
                    "ret_a_skat_feriepenge_amount": "Adjust A-Tax Vacation Salary",
                    "ret_sh_opspar_amount": "Adjust SH Accrued",
                    "ret_sh_forskud_amount": "Adjust SH Advance",
                    "ret_sh_fritvalg_opspar_amount": "Adjust SH Fritvalg Accrued",
                    "ret_sh_fritvalg_brugt_amount": "Adjust SH Fritvalg Used",
                    "bonus_amount": "Bonus WO/pension",
                    "afholdte_feriedage_amount": "Spent vacation days",
                    "fixed_add_ons_amount": "Fixed Add-ons",
                    "hourly_rate_amount": "Hourly rate",
                    "lunch_arrangement_monthly_amount": "Lunch arrangement",
                    "fixed_add_ons_monthly_amount": "Fixed Add-ons",
                    "working_hours_amount": "Hours",
                    "free_car_amount": "Free car",
                    "afholdte_feriefridage_amount": "Spent extra vacation days",
                    "status": "Status",
                    "name": "Name",
                    "employment_date": "Employment date",
                    "termination": "Termination date",
                    "comment": "Comment"
                }
            },
            "excel": {
                "approved": "Payroll was approved by:",
                "approved_user_name": "Payroll was approved by: {username}",
                "data": "data",
                "month": "Month:",
                "summary": "overview",
                "year": "Year:",
                "type": "Type",
                "types": {
                    "primary": "General",
                    "extra": "Extra",
                    "honorarium": "Honorarium"
                },
                "email_types": {
                    "primary": "General run of",
                    "extra": "Extra run of",
                    "honorarium": "Honorarium run of"
                },
                "total": "Total payroll expense in period:",
                "title": "Payroll expense sheet",
                "templates": {
                    "danlon": {
                        "b_contribution": "B-contribution",
                        "customer_employees_pension_details": {
                            "company_contribution": "Pension employer (%)",
                            "employee_contribution": "Pension employee (%)"
                        },
                        "customer_employees": {
                            "first_name": "First name",
                            "id": "Id",
                            "last_name": "Last name"
                        },
                        "customer_hourly_employees": {
                            "hourly_rate": "Wage (hourly employed)"
                        },
                        "customer_salaried_employees": {
                            "salary": "Salary"
                        },
                        "days_vacation": "Days vacation in period",
                        "hours": "Hours (hourly employed)",
                        "outlays": "Outlays in period"
                    }
                }
            },
            "modal": {
                "title": "Edit payroll"
            },
            "sheets": {
                "approval_denied": "Payroll was approved",
                "approval_not_sent": "Payroll was not sent to approval. Please check that everything was filled out correctly",
                "approve": "Approve payroll",
                "approved": "Payroll was approved",
                "approved_text": "Approved",
                "blueprint": "Format",
                "choose": "Choose format",
                "comment": "* Write a comment",
                "comment_from_customer": "Comment from {customer}",
                "create": "Create payroll",
                "created_info_exists": "Payroll for this month has already been created. Please find it in the table below",
                "created_success": "Payroll was created. Please find it in the table.",
                "download": "Download {format} format",
                "edit": "Edit existing payroll",
                "employee": "employee",
                "employees": "employees",
                "employees_plural": "No employees | {count} employee | {count} employees",
                "help-text": "Keepers cannot be held responsible for the correctness of the information and only performs sanity checks on the payroll",
                "help-text-bold": "Keepers cannot be held responsible for the correctness of the information and only performs sanity checks on the payroll.",
                "awaiting-text": "The payroll has been sent to a Keepers employee. When the payroll has been processed you can find the payslips under <a class=\"btn btn-primary btn-flat btn-icon\" href=\"{url}\">\"Payrolls\"</a> in the menu under \"Salary\".",
                "months": {
                    "1": "January",
                    "2": "February",
                    "3": "March",
                    "4": "April",
                    "5": "May",
                    "6": "June",
                    "7": "July",
                    "8": "August",
                    "9": "September",
                    "10": "October",
                    "11": "November",
                    "12": "December"
                },
                "not_allowed": "The file was not deleted because the payroll has already been approved.",
                "not_approved_text": "Draft - not approved",
                "open": "Open",
                "send_to_approval": "Send to approval",
                "sent_to_approval": "The payroll was sent to approval.",
                "sheets": "Payrolls",
                "updated_success": "Employee information was saved",
                "upload": "Upload to {format}",
                "download_excel": "Download excel"
            },
            "js": {
                "confirm": "Are you sure you want to approve the payroll?",
                "changes": {
                    "confirm": "Are you sure you want to approve the payroll, even though you have not edited: "
                },
                "yes": "Yes",
                "no": "No",
                "delete_title": "Delete payroll",
                "delete_content": "Are you sure you want to delete the payroll? All inputs will be deleted and cannot be recovered afterwards."
            },
            "page_header": "Payroll",
            "pay_slips": {
                "header": "Pay Slips",
                "headers": {
                    "id": "Id",
                    "checkbox": "Select",
                    "year": "Year",
                    "month": "Month",
                    "type": "Type",
                    "name": "Client",
                    "comment": "Comment",
                    "status": "Status",
                    "filename": "Filename",
                    "last_reminded_at": "Latest reminder",
                    "actions": "Actions"
                },
                "approve": {
                    "success": "The payslips were approved",
                    "error": "Something went wrong. The payslips was not approved"
                },
                "delete": {
                    "success": "The payslips were deleted",
                    "error": "Something went wrong. The payslips were not deleted",
                    "status_error": "Payslips were not deleted. You are not allowed to delete payslips that are either approved or finished."
                },
                "reject": {
                    "alert": "Please write a detailed explanation of why you are rejecting the payslips",
                    "header": "Reject payslips",
                    "success": "The payslips were rejected",
                    "error": "Something went wrong. The payslips were not rejected"
                },
                "two_step_approval": {
                    "cannot_approve": "You cannot approve this payslip before the first approver has approved.",
                    "cannot_reject": "You cannot reject this payslip before the first approver has approved."
                },
                "js": {
                    "delete": {
                        "confirm": "Are you sure you want to delete the payslips?",
                        "yes": "Yes",
                        "no": "No",
                        "title": "Delete payslips",
                        "content": "Are you sure you want to delete the payslips? The file will be deleted and cannot be recovered afterwards."
                    },
                    "approve": {
                        "confirm": "Are you sure you want to approve the payslips?",
                        "yes": "Yes",
                        "no": "No",
                        "title": "Approve payslips",
                        "content": "Are you sure you want to approve the payslips? By selecting yes, you are agreeing that the payslips are filled out correctly."
                    },
                    "reject": {
                        "confirm": "Are you sure you want to reject the payslips?",
                        "yes": "Yes",
                        "no": "No",
                        "title": "Reject payslips",
                        "content": "Are you sure you want to reject the payslips? By selecting yes, you are saying that the payslips are incorrect."
                    }
                }
            }
        },
        "status": {
            "bookingcompleted": "Booking completed",
            "bookinginprogressind": "Booking in progress IND",
            "bookingcompletedind": "Missing docs ready DK",
            "missingdocsreadyind": "Missing docs ready IND",
            "missingdocsreleased": "Missing docs released",
            "na": "N/A",
            "notstarted": "Not started",
            "periodclosed": "Period closed",
            "readyforreview": "Ready for review",
            "reconstarted": "Recon started",
            "reconciliationcompleted": "Reconciliation completed",
            "reconciliationstarted": "Reconciliation started",
            "reportingcompleted": "Reporting completed",
            "reviewed": "Reviewed",
            "vatapproved": "VAT approved",
            "vatdeclared": "VAT declared",
            "vatreadyforreview": "VAT ready for review",
            "vatrecondone": "VAT recon done",
            "vatsentforapproval": "VAT sent for approval",
            "missing": "Missing",
            "delivered": "Delivered",
            "annualreportreconciled": "Reconciled"
        },
        "success-msgs": {
            "voucher-db-save": "Changes saved to database"
        },
        "system": {
            "add_data_field": "Add data field",
            "edit_data_field": "Edit data field",
            "add_vat_deadline": "Add vat deadline",
            "edit_vat_deadline": "Edit vat deadline",
            "bookkeeping_status": "Bookkeeping status",
            "pbc_status": "PBC status",
            "annual_report": "Annual report",
            "data_field_approve": "Is data field an approval",
            "data_fields": {
                "id": "ID",
                "group": "Datafield group",
                "status_text": "Name",
                "color": "Status color code"
            },
            "data_field_name": "Datafield name",
            "report_status": "Report status",
            "settlement_period": "Period",
            "settlement_period_from": "Period - From",
            "settlement_period_to": "Period - To",
            "vat_deadlines_header": "Frequency",
            "vat_deadlines": {
                "id": "ID",
                "deadline": "Deadline",
                "month": "Frequency",
                "settle_period": "Period"
            },
            "dropbox": {
                "access_token": "Access Token",
                "client_identifier": "Client Identifier",
                "root_folder": "Root Folder",
                "success": "Config was updated",
                "folder_path_example": "Folder Path Example"
            },
            "vat_status": "Vat status",
            "approved": "Approved field",
            "data_fields_title": "Datafields",
            "dropbox_config_title": "Dropbox config",
            "vat_deadlines_title": "VAT Deadlines",
            "data_field_groups": {
                "bookkeeping_status": "Bookkeeping status",
                "report_status": "Report status",
                "vat_status": "Vat status",
                "pbc_status": "PBC status",
                "annual_report": "Annual report"
            },
            "data_field_colors": {
                "yellow": "Yellow",
                "red": "Red",
                "green": "Green",
                "blue": "Blue",
                "baby_blue": "Baby Blue",
                "bright_yellow": "Bright Yellow"
            }
        },
        "tables": {
            "actions": "Actions",
            "edit": "Edit",
            "create": "Create",
            "delete": "Delete",
            "view": "View",
            "customize_columns": "Customize columns",
            "reset": "Reset",
            "update": "Update table",
            "filters": {
                "filters": "Filters",
                "date_from_to": "Date (from/to)",
                "amount_from_to": "Amount (from/to)"
            },
            "export": {
                "copy": "Copy"
            }
        },
        "task-templates": {
            "table": {
                "id": "Id",
                "name": "Name",
                "description": "Description",
                "tasks_string": "Tasks",
                "actions": "Actions"
            },
            "page_header": "Task templates",
            "delete": {
                "title": "Delete task template",
                "content": "Are you sure that you want to delete this task template?"
            },
            "create": "Create task template",
            "update": "Update task template",
            "add_task": "Add task",
            "title": "Title",
            "required": "Please add at least one task to template",
            "task": {
                "task": "Task",
                "title": "Task title",
                "description": "Task description",
                "task_notification": "Task notification",
                "send_notification": "Send notification",
                "notification_frequency": "Frequency",
                "notification_odd_or_even_week": "Even or odd weeks",
                "notification_start_or_end_month": "Start or end of month",
                "status": "Status",
                "title_required": "Task title is required",
                "description_required": "Task description is required"
            },
            "statuses": {
                "Open": "Open",
                "Finish": "Finished",
                "Closed": "Closed",
                "Recurring": "Recurring"
            },
            "days_in_week": {
                "monday": "Monday",
                "tuesday": "Tuesday",
                "wednesday": "Wednesday",
                "thursday": "Thursday",
                "friday": "Friday",
                "saturday": "Saturday",
                "sunday": "Sunday"
            },
            "frequency_options": {
                "0": "One time only",
                "1": "Weekly",
                "2": "Every second week",
                "4": "Monthly"
            },
            "odd_or_even_week_options": {
                "1": "Even week",
                "0": "Odd week"
            },
            "start_or_end_month_options": {
                "1": "Start of month",
                "0": "End of month"
            },
            "email": {
                "info": "This is a reminder to take action on the following task:",
                "info_with_name": "This is a reminder to take action on the following task for {name}:",
                "subject": "Reminder for task"
            },
            "responsible": "Responsible for the task",
            "no_responsible_selected": "Note! No responsible employee selected. If you have chosen to send notifications, they will be sent to the company email",
            "responsible_selected_first": "Note! You have chosen",
            "responsible_selected_second": ". If you have chosen to send notifications they will get sent to this user's email",
            "no_notifications": "If you have not chosen to send notifications, no one will receive any emails about the task",
            "weekdays": "Weekdays",
            "edit_txt": "Edit task template",
            "attach": "Attach"
        },
        "termination": {
            "cancel-error-msg": "Something went wrong. Termination of employee was not registered. Please contact an administrator-",
            "cancel-success-msg": "The employee's termination has been reversed",
            "cancel-termination": "Undo termination",
            "error-msg": "Something went wrong. The employee's termination information was not saved. Please contact an administrator",
            "success-msg": "The changes were saved. {name} will resign on {date}",
            "table": {
                "0": "Edit",
                "1": "Terminate",
                "2": "Terminated",
                "btns": {
                    "dismiss": "Terminate",
                    "edit": "Edit",
                    "terminated": "Terminated"
                }
            },
            "js": {
                "confirm_title": "Confirm termination of: ",
                "confirm_msg": "Are you sure you want to terminate: ",
                "yes": "Yes",
                "no": "No",
                "undo_title": "Confirm undo termination of: ",
                "undo_msg": "Please confirm:",
                "input_title": "Input information for: "
            }
        },
        "translations": {
            "warning": "Warning, translations are not visible until they are exported back to the app/lang file, using 'php artisan translation{export}' command or publish button.",
            "finished": "Done importing, processed <strong class=\"counter\">N</strong> items! Reload this page to refresh the groups!",
            "search_finished": "Done searching for translations, found <strong class=\"counter\">N</strong> items!",
            "group_finished": "Done publishing the translations for group '{group}'!",
            "append": "Append new translations",
            "replace": "Replace existing translations",
            "group_import": "Import groups",
            "scan_confirm": "Are you sure you want to scan you app folder? All found translation keys will be added to the database.",
            "search": "Find translations in files",
            "publish": "Publish translations",
            "publish_confirm": "Are you sure you want to publish the translations group '{group}'? This will overwrite existing language files.",
            "back": "Back",
            "add_no_prefix": "Add 1 key per line, without the group prefix",
            "result": "Total: {numTranslations}, changed: {numChanged}",
            "key": "Key",
            "add": "Add Keys",
            "enter": "Enter translation",
            "delete_confirm": "Are you sure you want to delete the translations for '{key}'?",
            "choose_group": "Choose a group to display the group translations. If no groups are visible, make sure you have run the migrations and imported the translations.",
            "js": {
                "yes": "Yes",
                "no": "No",
                "delete_title": "Delete ",
                "delete_content": "Are you sure you want to delete "
            },
            "status": {
                "active": "Active",
                "inactive": "Inactive",
                "paid": "Paid",
                "unpaid": "Unpaid"
            },
            "kr": "Kr.",
            "you": "You",
            "deleted": "Deleted"
        },
        "upload": {
            "content": "Choose or drag files into the upload zone",
            "file_size_exceeds": "File size exceeds {max_size}",
            "file_type_not_accepted": "File type not accepted. Allowed: {allowed}",
            "max_uploads_exceeded": "Maximum {max_uploads} files allowed",
            "file_already_added": "File {file_name} already added",
            "no_upload_route_specified": "No upload route specified",
            "upload_failed": "Upload failed: {status_text}",
            "upload_failed_general": "Upload failed",
            "file_too_large": "File is too large",
            "network_error": "Network error"
        },
        "user-affiliation": {
            "nav": {
                "header": "Employee-client association"
            },
            "navbar_header": "Employee-client association",
            "employee-groups": "Employee-group association"
        },
        "user-groups": {
            "actions": {
                "create": "Create",
                "update": "Update",
                "delete": "Delete"
            },
            "delete": {
                "title": "Delete group",
                "content": "This deletes the group. The action can not be undone. <br> Are you sure you want to delete the group?",
                "yes": "Delete",
                "no": "Cancel"
            },
            "form": {
                "labels": {
                    "name": "Group name",
                    "users": "Group members"
                },
                "placeholders": {
                    "name": "Salary"
                }
            },
            "groups": "Groups",
            "user_groups_create": "Create group",
            "user_groups_edit": "Update group",
            "part_of": "A part of",
            "header_users_groups": "Employees & Groups",
            "table_headers": {
                "id": "ID",
                "name": "Name",
                "users": "Group members"
            },
            "created": "Group created",
            "updated": "Group updated",
            "deleted": "Group deleted"
        },
        "users": {
            "create": {
                "success": "{username} was created",
                "error": {
                    "no_companies": "User was not created because no companies were selected",
                    "contact_person": "Contact person does not match any of the selected companies",
                    "company_name": "Company not found: {company}",
                    "role_name": "Role not found: {role}",
                    "role_not_assigned": "Role {role} is not assigned to {company}"
                }
            },
            "delete": {
                "error": "{username} was not deleted",
                "success": "{username} was deleted"
            },
            "personal_tab_text": "Personal",
            "reset": {
                "success": "Password for {username} was reset and an email was sent"
            },
            "rights_tab_text": "Roles",
            "table": {
                "actions": "Actions",
                "company": "Company",
                "companies": "Companies",
                "company_id": "Client id",
                "company_ids": "Client ids",
                "name": "Name",
                "permissions_display_name": "Description",
                "has_accepted_invite": "Accepted invite",
                "roles_display_name": "Roles",
                "status": "Status"
            },
            "update": {
                "success": "{username} was updated",
                "error": {
                    "deactivated": "User is deactivated and cannot be updated"
                }
            },
            "language": {
                "da": "Danish",
                "en": "English"
            },
            "notifications": {
                "1": "On",
                "0": "Off"
            },
            "create_txt": "Create user",
            "edit_txt": "Edit user",
            "form": {
                "company_id": "Company",
                "company_ids": "Companies",
                "email": "E-mail",
                "language": "Language",
                "name": "Name",
                "phone": "Phone",
                "role_id": "Roles",
                "notifications": "Notifications",
                "contact_persons": "Contact person"
            },
            "header": "Users",
            "grouping": {
                "active": "Active",
                "deactivated": "Inactive",
                "all": "All"
            },
            "filter_label": "Filter users",
            "js": {
                "reset": {
                    "title": "Reset password",
                    "content1": "Are you sure you want to reset the password for ",
                    "content2": "? The user will receive an e-mail notifying him that the password has been reset.",
                    "content_1": "Are you sure you want to reset the password for {name}?",
                    "content_2": "The user will receive an e-mail notifying them that the password has been reset.",
                    "success": "Password for {username} was reset and an email was sent"
                },
                "delete": {
                    "title": "Delete user",
                    "content": "Are you sure you want to delete this user? This action cannot be undone."
                },
                "no": "No",
                "yes": "Yes",
                "company_id": "Please select a client"
            },
            "deactivate": {
                "title": "Deactivate user",
                "content": "Are you sure you want to deactivate the user?",
                "yes": "Yes",
                "no": "No",
                "success": "User was deactivated"
            },
            "activate": {
                "title": "Activate user",
                "content": "Are you sure you want to activate the user?",
                "yes": "Yes",
                "no": "No",
                "success": "User was activated"
            },
            "page_header": "Registered users"
        },
        "validation": {
            "accepted": "The {attribute} field must be accepted.",
            "accepted_if": "The {attribute} field must be accepted when {other} is {value}.",
            "active_url": "The {attribute} field must be a valid URL.",
            "after": "The {attribute} field must be a date after {date}.",
            "after_or_equal": "The {attribute} field must be a date after or equal to {date}.",
            "alpha": "The {attribute} field must only contain letters.",
            "alpha_dash": "The {attribute} field must only contain letters, numbers, dashes, and underscores.",
            "alpha_num": "The {attribute} field must only contain letters and numbers.",
            "array": "The {attribute} field must be an array.",
            "ascii": "The {attribute} field must only contain single-byte alphanumeric characters and symbols.",
            "before": "The {attribute} field must be a date before {date}.",
            "before_or_equal": "The {attribute} field must be a date before or equal to {date}.",
            "between": {
                "array": "The {attribute} field must have between {min} and {max} items.",
                "file": "The {attribute} field must be between {min} and {max} kilobytes.",
                "numeric": "The {attribute} field must be between {min} and {max}.",
                "string": "The {attribute} field must be between {min} and {max} characters."
            },
            "boolean": "The {attribute} field must be true or false.",
            "can": "The {attribute} field contains an unauthorized value.",
            "confirmed": "The {attribute} field confirmation does not match.",
            "contains": "The {attribute} field is missing a required value.",
            "current_password": "The password is incorrect.",
            "date": "The {attribute} field must be a valid date.",
            "date_equals": "The {attribute} field must be a date equal to {date}.",
            "date_format": "The {attribute} field must match the format {format}.",
            "decimal": "The {attribute} field must have {decimal} decimal places.",
            "declined": "The {attribute} field must be declined.",
            "declined_if": "The {attribute} field must be declined when {other} is {value}.",
            "different": "The {attribute} field and {other} must be different.",
            "digits": "The {attribute} field must be {digits} digits.",
            "digits_between": "The {attribute} field must be between {min} and {max} digits.",
            "dimensions": "The {attribute} field has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "doesnt_end_with": "The {attribute} field must not end with one of the following: {values}.",
            "doesnt_start_with": "The {attribute} field must not start with one of the following: {values}.",
            "email": "The {attribute} field must be a valid email address.",
            "ends_with": "The {attribute} field must end with one of the following: {values}.",
            "enum": "The selected {attribute} is invalid.",
            "exists": "The selected {attribute} is invalid.",
            "extensions": "The {attribute} field must have one of the following extensions: {values}.",
            "file": "The {attribute} field must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "array": "The {attribute} field must have more than {value} items.",
                "file": "The {attribute} field must be greater than {value} kilobytes.",
                "numeric": "The {attribute} field must be greater than {value}.",
                "string": "The {attribute} field must be greater than {value} characters."
            },
            "gte": {
                "array": "The {attribute} field must have {value} items or more.",
                "file": "The {attribute} field must be greater than or equal to {value} kilobytes.",
                "numeric": "The {attribute} field must be greater than or equal to {value}.",
                "string": "The {attribute} field must be greater than or equal to {value} characters."
            },
            "hex_color": "The {attribute} field must be a valid hexadecimal color.",
            "image": "The {attribute} field must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field must exist in {other}.",
            "integer": "The {attribute} field must be an integer.",
            "ip": "The {attribute} field must be a valid IP address.",
            "ipv4": "The {attribute} field must be a valid IPv4 address.",
            "ipv6": "The {attribute} field must be a valid IPv6 address.",
            "json": "The {attribute} field must be a valid JSON string.",
            "list": "The {attribute} field must be a list.",
            "lowercase": "The {attribute} field must be lowercase.",
            "lt": {
                "array": "The {attribute} field must have less than {value} items.",
                "file": "The {attribute} field must be less than {value} kilobytes.",
                "numeric": "The {attribute} field must be less than {value}.",
                "string": "The {attribute} field must be less than {value} characters."
            },
            "lte": {
                "array": "The {attribute} field must not have more than {value} items.",
                "file": "The {attribute} field must be less than or equal to {value} kilobytes.",
                "numeric": "The {attribute} field must be less than or equal to {value}.",
                "string": "The {attribute} field must be less than or equal to {value} characters."
            },
            "mac_address": "The {attribute} field must be a valid MAC address.",
            "max": {
                "array": "The {attribute} field must not have more than {max} items.",
                "file": "The {attribute} field must not be greater than {max} kilobytes.",
                "numeric": "The {attribute} field must not be greater than {max}.",
                "string": "The {attribute} field must not be greater than {max} characters."
            },
            "max_digits": "The {attribute} field must not have more than {max} digits.",
            "mimes": "The {attribute} field must be a file of type: {values}.",
            "mimetypes": "The {attribute} field must be a file of type: {values}.",
            "min": {
                "array": "The {attribute} field must have at least {min} items.",
                "file": "The {attribute} field must be at least {min} kilobytes.",
                "numeric": "The {attribute} field must be at least {min}.",
                "string": "The {attribute} field must be at least {min} characters."
            },
            "min_digits": "The {attribute} field must have at least {min} digits.",
            "missing": "The {attribute} field must be missing.",
            "missing_if": "The {attribute} field must be missing when {other} is {value}.",
            "missing_unless": "The {attribute} field must be missing unless {other} is {value}.",
            "missing_with": "The {attribute} field must be missing when {values} is present.",
            "missing_with_all": "The {attribute} field must be missing when {values} are present.",
            "multiple_of": "The {attribute} field must be a multiple of {value}.",
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} field format is invalid.",
            "numeric": "The {attribute} field must be a number.",
            "password": {
                "letters": "The {attribute} field must contain at least one letter.",
                "mixed": "The {attribute} field must contain at least one uppercase and one lowercase letter.",
                "numbers": "The {attribute} field must contain at least one number.",
                "symbols": "The {attribute} field must contain at least one symbol.",
                "uncompromised": "The given {attribute} has appeared in a data leak. Please choose a different {attribute}."
            },
            "present": "The {attribute} field must be present.",
            "present_if": "The {attribute} field must be present when {other} is {value}.",
            "present_unless": "The {attribute} field must be present unless {other} is {value}.",
            "present_with": "The {attribute} field must be present when {values} is present.",
            "present_with_all": "The {attribute} field must be present when {values} are present.",
            "prohibited": "The {attribute} field is prohibited.",
            "prohibited_if": "The {attribute} field is prohibited when {other} is {value}.",
            "prohibited_unless": "The {attribute} field is prohibited unless {other} is in {values}.",
            "prohibits": "The {attribute} field prohibits {other} from being present.",
            "regex": "The {attribute} field format is invalid.",
            "required": "The {attribute} field is required.",
            "required_array_keys": "The {attribute} field must contain entries for: {values}.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_if_accepted": "The {attribute} field is required when {other} is accepted.",
            "required_if_declined": "The {attribute} field is required when {other} is declined.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} field must match {other}.",
            "size": {
                "array": "The {attribute} field must contain {size} items.",
                "file": "The {attribute} field must be {size} kilobytes.",
                "numeric": "The {attribute} field must be {size}.",
                "string": "The {attribute} field must be {size} characters."
            },
            "starts_with": "The {attribute} field must start with one of the following: {values}.",
            "string": "The {attribute} field must be a string.",
            "timezone": "The {attribute} field must be a valid timezone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "uppercase": "The {attribute} field must be uppercase.",
            "url": "The {attribute} field must be a valid URL.",
            "ulid": "The {attribute} field must be a valid ULID.",
            "uuid": "The {attribute} field must be a valid UUID.",
            "custom": {
                "check-recurring-week": "Chosen frequency only allows one day",
                "task-weekdays-required": "Task weekdays is required.",
                "attribute-name": [],
                "customer_employees.email": {
                    "unique": "{attribute} {input} already exists."
                },
                "invalid-company-id-role-rule": "You do not have permission to use company {input}.",
                "company_ids": {
                    "company_ids_changed": "You do not have permission to give users access to companies."
                }
            },
            "attributes": {
                "name": "Name",
                "holiday_pay_obligations": "holiday pay provision",
                "customer_employees.first_name": "First name",
                "customer_employees.last_name": "Last name",
                "customer_employees.email": "Email",
                "customer_employees.cpr": "CPR",
                "customer_employees.company_id": "Customer",
                "customer_employees.employment_date": "Employment date",
                "address.main.address": "Address",
                "address.main.city": "City",
                "address.main.country_code": "Country",
                "address.main.postal_code": "Postal code",
                "companyPension.company_contribution": "Company pension - company contribution",
                "companyPension.employee_contribution": "Company pension - employee contribution",
                "companyPension.pension_company": "Company pension - pension company",
                "pension.company_contribution": "Pension - company contribution",
                "pension.employee_contribution": "Pension - employee contribution",
                "pension.pension_company": "Pension - pension company",
                "employment": {
                    "employment_type": "Type",
                    "tax_card": "Tax card",
                    "salary": "Salary",
                    "hourly_rate": "Hourly rate",
                    "weekly_working_hours": "Weekly working hours",
                    "weekly_working_days": "Weekly working days",
                    "lunch_arrangement_monthly": "Lunch arrangement - Monthly amount",
                    "fixed_add_ons_monthly": "Fixed addons - Monthly amount",
                    "disco_code": "Disco-kode",
                    "dst_hired_terms": "Employment terms",
                    "dst_job_status": "Job status",
                    "dst_salary_form": "Salary type",
                    "dst_time_limited_employment": "Employment in company"
                },
                "obligation": "Provision",
                "bank.iban": "IBAN",
                "bank.swift": "SWIFT",
                "optional.allocation_of_vacation_days": "Allocation of vacation days",
                "optional.flex_savings": "Flex savings",
                "optional.days_vacation": "Days vacation",
                "bank.bank_reg": "Bank reg.number",
                "bank.bank_account": "Bank account number",
                "Kundenavn": "customer name",
                "CvrNummer": "CVR number",
                "Adresse": "address",
                "Postnummer": "postal code",
                "By": "city",
                "Land": "country",
                "Telefon": "telephone",
                "Faxnummer": "fax number",
                "Mobilnummer": "mobile number",
                "Email": "email",
                "CorpayOneFakturaEmail": "Corpay One invoice email",
                "CorpayOneKvittering": "Corpay One receipt",
                "KeepersEmail": "keepers email",
                "services": "services",
                "services.AntalBilagIAftalen": "number of vouchers in agreement",
                "services.BetalingerHosKeepers": "has payments at Keepers",
                "services.FastPris": "fixed price",
                "services.PrisFrekvens": "price frequency",
                "services.Rapportteringsdeadline": "reporting deadline",
                "services.LønDeadline": "salary deadline",
                "services.UgentligFrekvens": "weekly frequency",
                "services.Momsfrekvens": "VAT frequency",
                "services.Opdateringsfrekvens": "update frequency",
                "services.GrænseForManglendeBilag": "voucher limit",
                "services.CorpayOne": "Corpay One",
                "services.Kube": "Kube",
                "services.Outlay": "Outlay",
                "services.Lønsystem": "salary system",
                "services.SkalIKeepersKube": "should be in Keepers Kube",
                "services.EIndkomst": "E-income",
                "services.HarOutsourcing": "has outsourcing",
                "services.HarConsulting": "has consulting",
                "services.HarLøn": "has salary",
                "services.HarRobotics": "has robotics",
                "services.HarPowerBI": "has Power BI",
                "services.KubeID": "Kube ID",
                "roger_invoices": "Corpay One invoice email",
                "roger_receipts": "Corpay One receipts"
            },
            "unique_employee_email_for_company": "An employee with that email has already been created for this company."
        },
        "vat": {
            "actions": "Actions",
            "total": "Total",
            "specify_amount": "Specify amount",
            "submit": "Submit",
            "edit": "Edit",
            "company_cvr_not_set": "Company CVR number not set",
            "submission_successful": "Submission successful",
            "submission_failed": "Submission failed. Please try again.",
            "see_submission": "See submission",
            "show_previous_submission": "Show previous submission",
            "previous_submission": "Previous submission",
            "vat_deadline_not_found": "VAT deadline not found",
            "deadline_passed": "The deadline for this VAT submission has passed. Editing and submitting is no longer allowed.",
            "group_headers": {
                "danish_sales_and_purchase_vat": "Danish input and output VAT",
                "trade_with_abroad": "International trade",
                "energy_taxes": "Reimbursement of energy taxes"
            },
            "columns": {
                "company": "Company",
                "company_group": "Company group",
                "period": "Period",
                "total_vat": "Total",
                "sales_vat": "Output VAT (VAT payable)",
                "purchase_vat": "Input VAT (VAT deductible)",
                "vat_on_purchase_of_goods_abroad": "VAT on goods purchased abroad",
                "vat_on_purchase_of_services_abroad": "VAT on services purchased abroad subject to a reverse charge",
                "box_a_goods": "Box A - goods",
                "box_a_services": "Box A - services",
                "box_b_goods_reported": "Box B - goods - to be reported",
                "box_b_goods_not_reported": "Box B - goods - not to be reported",
                "box_b_services": "Box B - services",
                "box_c": "Box C",
                "oil_and_bottled_gas_tax": "Oil and bottled gas tax",
                "electricity_tax": "Electricity tax",
                "natural_gas_and_town_gas_tax": "Natural and town gas tax",
                "coal_tax": "Coal tax",
                "co2_tax": "CO2 tax",
                "water_tax": "Water tax"
            },
            "column_helpers": {
                "vat_on_purchase_of_goods_abroad": "Both the EU and third countries",
                "box_a_goods": "The value exclusive of VAT of goods purchased in other EU countries (EU purchases)",
                "box_a_services": "The value exclusive of VAT on services purchased in other EU countries",
                "box_b_goods_reported": "The value of goods sold exclusive of VAT to other EU countries",
                "box_b_goods_not_reported": "The value of, for example, installation and assembly, distance selling and new means of transport sold exclusive of VAT to other EU customers not registered for VAT",
                "box_b_services": "The value of certain sales of services exclusive of VAT to other EU countries. To be reported to the \"EU sales exclusive of VAT\" system",
                "box_c": "Enter the value of other goods and services sold exclusive of VAT in Denmark, other EU countries and countries outside the EU"
            }
        },
        "viia": {
            "attach_bank": "Attach bank",
            "select_a_cashbook": "Choose a daybook...",
            "transfer": "Transfer",
            "table": {
                "id": "#",
                "account_name": "Account Name",
                "account_number": "Account Number",
                "currency": "Currency",
                "balance": "Balance",
                "owner": "Owner",
                "available": "Available",
                "features": "Features",
                "synced_at": "Updated",
                "status": "Status",
                "attach_account": "Attach e-conomic account",
                "automatic_transfer": "Transfer automatically to daybook"
            },
            "accounts": {
                "page_header": "Accounts",
                "attach": "Attach e-conomic account",
                "account_attached": "Account attached",
                "account_detached": "Account detached",
                "detach": "Detach account",
                "attach_cashbook": "Attach daybook",
                "from_date": "From date",
                "pick_daybook": "Pick daybook",
                "automatic_transfer_activated": "Automatic transfer of transactions to e-conomic has been activated.",
                "automatic_transfer_updated": "Automatic transfer of transactions to e-conomic has been updated.",
                "automatic_transfer_deactivated": "Automatic transfer of transactions to e-conomic has been deactivated."
            },
            "transaction": "Transaktion",
            "transactions": {
                "page_header": "Transactions",
                "transfer-economic": "Transfer to daybook",
                "cashbook": "Daybook",
                "cashbook-type": "Daybook type",
                "transferredToCashBook": "Transferred to daybook",
                "assign_bank_account": "To transfer transactions to a daybook, you have to assign an e-conomic bank account.",
                "account_id": "Account ID",
                "bban_number": "BBan number",
                "iban_number": "IBan number",
                "state": "Status",
                "search": "Search transactions",
                "table": {
                    "date": "Date",
                    "originalText": "Original text",
                    "text": "Text",
                    "message": "Message",
                    "type": "Type",
                    "amount": "Amount",
                    "balance": "Balance",
                    "detail": "Details",
                    "transferred_at": "Transferred at",
                    "cashbook": "Daybook"
                },
                "inner_table": {
                    "transaction_id": "Transaction id",
                    "account_id": "Account id",
                    "estimated_balance": "Estimated balance",
                    "is_deleted": "Deleted",
                    "api_transaction_id": "API Transaction id",
                    "original_text": "Original text",
                    "creation_date": "Creation date"
                },
                "transaction_account_id_required": "Please select an account",
                "transaction_from_amount": "From amount",
                "transaction_to_amount": "To amount",
                "transaction_from_date": "From date",
                "transaction_to_date": "To date",
                "transaction_amount_larger_than": "{field} should be larger than {field2}",
                "transaction_filter_required_with": "{field} is requred together with {field2}",
                "transaction_filter_invalid_format": "{field} has an incorrect format",
                "update_table": "Update table",
                "estimated": "Estimated",
                "contra_account_nr_required": "Please assign an e-conomic account before transferring transactions to daybook."
            },
            "mail-synchronization": {
                "subject": "{company_name} - Login required to synchronize your bank data in Keepers KC",
                "description": "In order to keep your bank data and transactions synchronized in Keepers KC it is important that you follow the link below to give access to your data."
            },
            "mail-consent-revoked": {
                "subject": "{company_name} - Your bank data is no longer accessible by Keepers KC",
                "description": "Please note that you have removed access to your bank data in Keepers KC. If this was unintentional please contact Keepers for more information."
            },
            "api-error-messages": {
                "400": "There is an error in the request to Nordic API Gateway. Contact support for further info.",
                "400-token": "There is an error in the request to Nordic API Gateway. Token has expired.",
                "401": "There was an error in accessing Nordic API Gateway. It is most likely because of an invalid token or missing access to the account requested.",
                "500": "We are currently experiencing errors with Nordica API Gateway. Please contact support if the problem persists."
            },
            "cash-book-types": {
                "finance_voucher": "Finance Voucher",
                "creditor_payment": "Creditor Voucher",
                "debtor_payment": "Debtor Payment",
                "creditor_invoice": "Creditor Invoice",
                "manual_debtor_invoice": "Manual Debtor Invoice"
            },
            "deactivate": {
                "deactivate_bank_connection": "Deactive bank connection",
                "deactivate_bank_connection_success": "Bank connection deactived",
                "deactive_bank_connection_failed": "Something went wrong. Bank connection could not be deactived. Contact support if the problem persists.",
                "deactive_bank_connection_no_token": "No valid bank connection found. Contact support if the problem persists.",
                "js": {
                    "deactive_bank_connection_title": "Deactive bank connection",
                    "deactive_bank_connection_confirm": "Are you sure you want to deactive the bank connection?",
                    "yes": "Yes",
                    "no": "No"
                }
            },
            "header": "Registered accounts",
            "date_selection": "By date",
            "connect_economic": "Connect e-conomic",
            "economic_account": "E-conomic account",
            "connect_economic_success": "E-conomic account connected",
            "connect_economic_success_no_contra_account": "E-conomic account connection was removed",
            "connect_economic_error": "Something went wrong. E-conomic account could not be connected. Contact support if the problem persists.",
            "kr": "Kr.",
            "transactions_table": {
                "date": "Date",
                "originalText": "Text",
                "message": "Message",
                "currency": "Currency",
                "amount": "Amount (currency)",
                "transaction_rate": "Transaction rate",
                "amount_dkk": "Amount (DKK)",
                "card": "Card",
                "by": "By",
                "transaction_type": "Transaction type",
                "reference": "Reference",
                "balance": "Balance"
            },
            "transaction_types": {
                "Card": "Card",
                "BankTransfer": "Bank transfer",
                "DirectDebit": "Direct debit",
                "PeerToPeer": "Peer to peer",
                "Unknown": "Unknown",
                "CashWithdrawal": "Cash withdrawal"
            },
            "dato_help": "There may be deviations from the actual balance in Balance and Available"
        },
        "vouchers-earlier-releases": {
            "header": "Earlier releases"
        },
        "vouchers": {
            "page_header": "Vouchers",
            "account_handle": "Account",
            "department_handle_number": "Department:",
            "department_handle_number_optional": "Department (optional)",
            "choose_account": "Please select an account",
            "choose_department": "Please select a department",
            "comment": "Comments",
            "comment_optional": "Comments (optional)",
            "comment_required": "Comments (required)",
            "missing_reason": "Please state a reason for not having a voucher",
            "missing-text": "vouchers are missing in the period",
            "lost": "Voucher lost",
            "comment_reason": "<strong>NB!</strong> Please be aware that we use an account statement for missing vouchers and that you are responsible for the missing voucher.",
            "comment_reason_lost": "Please be aware that we use an account statement for missing vouchers and that you are responsible for the missing voucher.",
            "show": "Show voucher",
            "press_to_show": "Click on the thumbnail to show attachment",
            "attachment_number": "Attachment {number}",
            "missing_txt": "Missing voucher",
            "see": "Display voucher",
            "missing_voucher_text": "There are no missing vouchers in the period",
            "help_text": "Total expenses without documentation in the form of vouchers may not exceed {voucher_limit} without your consent that you are responsible and that Keepers cannot be held accountable if the expenses are not related to the company.",
            "close_period": "Close period",
            "release": "Release vouchers from E-conomic",
            "statement_upload": "Upload statement",
            "approve_all": "Approve all registered vouchers",
            "clear_list": "Clear list",
            "clear_list_done": "List was cleared",
            "service_down": "Upload of vouchers is not possible at the moment. We are working on it!",
            "table": {
                "company_id": "Client Id",
                "select": "Select",
                "date": "Date",
                "voucher": "Voucher",
                "text": "Text",
                "amount": "Amount",
                "account": "Account",
                "contra_account": "Contra account",
                "department": "Department",
                "comment": "Comment",
                "actions": "Actions"
            },
            "cashbook": {
                "not_found": "Cashbook \"Manglende bilag\" not found."
            },
            "release_success": "Vouchers were released. Please find them in the table",
            "release_error": "Vouchers were not released. Please make sure that the customer's E-conomic token is correct. If the problem persists, please contact support.",
            "close_success": "The list has been cleared and the period closed",
            "close_error": "There are still vouchers missing. Please upload an account statement for alle accounts with missing vouchers in order to close the period.",
            "multi_registration": {
                "error": "One or more of the entries have already been registered and uploaded to E-conomic. Please contact us for more information.",
                "success": "{number} of entries were uploaded to E-conomic.",
                "no_uploads": "No new entries were uploaded to E-conomic",
                "register_success": "Vouchers were registered"
            },
            "single_registration": {
                "success": "Registration was approved and uploaded to E-conomic.",
                "error": "Registration failed. Please make sure that everything is filled out correctly.",
                "exists_error": "An entry already exists. Please contact us for more information.",
                "entry_not_exists": "The entry does not exist in E-conomic anymore. It is recommended that the draft be updated with current entries. Please contact us for more info.",
                "entry_not_exists_in_year": "The entry does not exist in E-conomic in the selected accounting year. It is recommended that the draft be updated with current entries. Please contact us for more info.",
                "pdf_wrong_format": "The PDF file format is incorrect. Please re-upload the voucher in a correct format and try again.",
                "connection_error": "There is a connection error. Please try again or contact us for help.",
                "entry_not_of_type_finans_voucer": "The Account property is only accessible on cash book entries of type Finance Voucher. Please check the entry is of type Finance Voucher. "
            },
            "js": {
                "period_title": "Close period",
                "period_content": "Do you want to close the current period? Please note that if you do, alle the client's vouchers will be removed from the table.",
                "period_text": "There are no missing vouchers in the period",
                "clear_list": "Are you sure you want to clear the list? The list cannot be restored afterwards.",
                "clear_list_done": "The list was cleared",
                "clear_list_title": "Clear list",
                "send_to_customer": "Send to customer?",
                "send_to_customer_content": "Are you sure you want to send it to the customer?",
                "yes": "Yes",
                "no": "No",
                "cancel": "Cancel",
                "all": "All",
                "missing_voucher_text_default": "There are no missing vouchers in the period.",
                "still_missing": "There are still missing",
                "vouchers": "vouchers",
                "company_id": "Please choose a client first",
                "release_title": "Release vouchers",
                "release_content": "Do you want to release the vouchers from E-conomic?",
                "release_alert": "Please choose a deadline date",
                "release_label": "Input deadline for handing in the vouchers",
                "limit_agreement": "I agree to the terms that I am responsible for the correctness...",
                "limit_amount": "NB! the amount exceeds your limit of ",
                "limit_alert": "Please accept the terms and conditions for uploading",
                "upload_title": "Upload all",
                "upload_content": "Do you want to approve and upload everything? Please be aware that if you choose yes, you will no longer be able to edit the content.",
                "account_select": "Please select an account",
                "department_select": "Select a department (optional)",
                "input_valid": "Everything is filled out correctly",
                "uploads_processing_title": "Uploads currently being processed",
                "uploads_processing_content": "There are uploads being processed. Are you sure that you want to close the window? Please be aware that all changes will be lost.",
                "approve_title": "Approve voucher: ",
                "approve_content": "Do you want to upload this voucher attachment?",
                "approve_alert": "Please accept the terms and conditions for uploading"
            },
            "select": {
                "invalid": "The selected vouchers cannot be deleted. The following vouchers are not valid: {body} Please deselect these and try again.",
                "title": "Delete selected vouchers",
                "content": "Delete entries: {body} from KC and Economic. Please note that these changes are permanent and cannot be undone. Go ahead anyway?",
                "delete_confirm": {
                    "description": "Deletes entries from KC kladden and E-conomic."
                },
                "delete_voucher_confirm": "Are you sure you want to delete this voucher attachment? This action cannot be undone.",
                "deleted": {
                    "success": "Entries deleted",
                    "error": "Entries deleted"
                },
                "other_options": "Bulk options",
                "delete": "Delete selected entries from KC and E-conomic",
                "approve": "Approve selected entries",
                "close": "Close selected entries in KC",
                "remove": "Remove selected entries from KC draft",
                "ignore": "Ignore selected entries in KC draft",
                "mark_as_missing": "Mark selected entries as missing",
                "assign_assigned": "Add assigned to selected entries",
                "assign_project": "Add project to selected entries",
                "removed": {
                    "success": "Entries removed KC",
                    "error": "Entries where not removed from KC"
                },
                "ignored": {
                    "success": "Entries ignored in KC",
                    "error": "Entries where not ignored in KC"
                },
                "closed": {
                    "success": "Entries closed in KC",
                    "error": "Entries where not closed in KC"
                },
                "mark_as_missing_responses": {
                    "success": "Entries where marked as missing",
                    "error": "Entries where not marked as missing",
                    "comment_min": "The comment must be at least 10 characters."
                },
                "mark_as_missing_response": {
                    "success": "Entry was marked as missing",
                    "error": "Entry was not marked as missing",
                    "comment_min": "The comment must be at least 10 characters."
                },
                "yes": "Yes",
                "no": "No",
                "upload": {
                    "title": "Approve selected entries",
                    "invalid": "The selected vouchers cannot be approved. The following vouchers are not valid: {body} Please deselect these and try again.",
                    "content": "Approve entries: {body} from KC and Economic. ",
                    "description": "Please be aware that if you choose yes, you will no longer be able to edit the content. The vouchers will be uploaded to E-conomic.",
                    "invalid_header": "The selected vouchers cannot be approved",
                    "invalid_description": "The following vouchers are not valid: {body}. Please deselect these and try again."
                },
                "remove_confirm": {
                    "invalid": "The selected vouchers cannot be removed. The following vouchers are not valid: {body} Please deselect these and try again.",
                    "title": "Remove selected entries",
                    "content": "Remove entries: {body} from KC and Economic.",
                    "description": "This action is recommended if entries do not exist in E-conomic anymore. It removes the entries from the list in KC.",
                    "invalid_header": "The selected vouchers cannot be removed",
                    "invalid_description": "The following vouchers are not valid: {body}. Please deselect these and try again."
                },
                "ignore_confirm": {
                    "invalid": "The selected vouchers cannot be ignored. The following vouchers are not valid: {body} Please deselect these and try again.",
                    "title": "Ignore the selected vouchers in KC",
                    "content": "Ignore vouchers: {body} from the current draft.",
                    "description": "This action is recommended if an entry in E-conomic already has a voucher. If you choose yes the selected account and department is saved to E-conomic if not already. Afterwards it is your own responsibility to upload the voucher from E-conomic to Dropbox. Also note that you cannot unignore a voucher",
                    "invalid_header": "The selected vouchers cannot be ignored",
                    "invalid_description": "The following vouchers are not valid: {body}. Please deselect these and try again."
                },
                "close_confirm": {
                    "invalid": "The selected vouchers cannot be closed. The following vouchers are not valid: {body} Please deselect these and try again.",
                    "title": "Close the selected vouchers in KC",
                    "content": "Close vouchers: {body} from the current draft.",
                    "description": "This action can be used to have a better overview of the vouchers not approved yet as it closes and removes the entries from the list if the entries are valid.",
                    "invalid_header": "The selected vouchers cannot be closed",
                    "invalid_description": "The following vouchers are not valid: {body}. Please deselect these and try again."
                },
                "mark_as_missing_confirm": {
                    "invalid": "The selected vouchers cannot be marked as missing. The following vouchers are not valid: {body} Please deselect these and try again.",
                    "title": "Mark the selected vouchers as missing",
                    "content": "Mark as missing: {body} from the current draft.",
                    "description": "This action should only be used to mark multiple vouchers as missing if the reason for them missing is the same and the account for all of them is the same.",
                    "invalid_header": "The selected vouchers cannot be marked as missing",
                    "invalid_description": "The following vouchers are not valid: {body}. Please deselect these and try again."
                },
                "assign_confirm": {
                    "title": "Assign selected vouchers",
                    "content": "{amount} selected vouchers",
                    "assigned": "Assigned",
                    "project": "Project",
                    "success": "Vouchers were assigned",
                    "error": "Vouchers were not assigned",
                    "assignees_required": "Select at least one employee or user"
                }
            },
            "current_vouchers": {
                "header": "Current vouchers"
            },
            "earlier_releases": {
                "header": "Earlier releases"
            },
            "economic_connection_down": "The connection to E-conomic is down. Please try again later or contact support for more info.",
            "missing_economic_token": "The action could no be performed. The integration to E-conomic may have been deleted.",
            "missing_account": "The selected account does not appear to exist in E-conomic. Please select another account or contact support for more info.",
            "missing_entry": "The selected voucher does not exist in E-conomic.",
            "period_barred": "The selected voucher is in a barred period. Please reopen the period first before approving.",
            "delete_failed": "Updating the voucher in E-conomic failed. Please try again or contact support for more info.",
            "recreate_failed": "Updating the voucher in E-conomic failed. This has caused the voucher to be deleted in E-conomic. The system will attempt to restore the voucher within the next 5 minutes. Please contact support if this does not happen.",
            "file_too_big": "The file is too too big. Max file size is 8MB.",
            "delete": "Delete voucher",
            "help": {
                "title": "Do you need help with uploads?",
                "content": "Total expenses without documentation in the form of receipts must not be exceeded without consent, acknowledging that it is your own responsibility and that Keepers cannot be held liable if the expenses were not incurred for business purposes."
            },
            "voucher_table": {
                "date": "Date",
                "voucher": "Voucher",
                "text": "Text",
                "amount": "Amount",
                "account": "Account",
                "contra_account": "Contra account",
                "assigned_to": "Assigned to",
                "project": "Project",
                "card": "Card",
                "department": "Department",
                "comment": "Comment"
            },
            "administrate": {
                "title": "Administrate",
                "subtitle": "Administrate automatic assignment of missing vouchers from credit cards",
                "administrate_cards": "Administrate cards",
                "search": "Search for cards",
                "general": "General",
                "fallback": "Fallback people",
                "voucher_assignment_rule": "AI assignment of fallback people",
                "voucher_assignment_rules_prompt": "Description",
                "add_voucher_assignment_rule": "Add AI fallback",
                "success": "Voucher assignment was updated",
                "error": "An error occurred while updating the voucher assignment",
                "validation_errors": {
                    "voucher_assignment_rules_prompt_required": "Description is required",
                    "voucher_assignment_rules_user_ids_required": "Employee(s) are required",
                    "voucher_assignment_rules_user_ids_exists": "Employee(s) do not exist",
                    "voucher_assignment_rules_employee_ids_exists": "Employee(s) do not exist",
                    "fallback_employee_ids_array": "Fallback employee(s) must be an array",
                    "fallback_employee_ids_exists": "Fallback employee(s) do not exist",
                    "fallback_user_ids_array": "Fallback user(s) must be an array",
                    "fallback_user_ids_exists": "Fallback user(s) do not exist",
                    "cards_id_exists": "Card does not exist"
                },
                "no_cards": "The company has no credit cards attached"
            },
            "release_all": {
                "title": "Release vouchers",
                "content": "Do you want to send the vouchers to the customer?",
                "send_to_customer": "Send to customer",
                "release_label": "Input deadline for handing in the vouchers",
                "button": "Release vouchers"
            },
            "upload_statement": "Upload voucher (max {max_uploads} files)",
            "assigned_by": {
                "credit_card": "Found matching credit card",
                "transaction": "Transaction matched via date and amount",
                "api": "Matched via AI fallback {fallback}",
                "fallback": "Fallback employee(s)"
            }
        },
        "work-calendars": {
            "table": {
                "id": "Id",
                "name": "Name",
                "actions": "Actions"
            },
            "page_header": "Work calendars",
            "delete": {
                "title": "Delete work calendar",
                "content": "Are you sure that you want to delete this work calendar?"
            },
            "create": "Create work calendar",
            "update": "Update work calendar"
        }
    }
}
